<template>
  <vue100vh style="position: fixed; width: 100%; overflow-y: hidden;">
  <!-- <Vue100vh> -->
  <div>
    <v-toolbar style="background-color: white !important;" v-if="showphone === false">
      <v-btn icon @click="toPage('/mobile/homepage')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-avatar size="40px" class="user-photo" v-if="infofriend.type === 'user'">
        <img v-if="infofriend.data_room[0].profilepicture" :src="infofriend.data_room[0].profilepicture" class="alligator-turtle">
        <img v-else-if="infofriend.data_room[0].profilepicture === '' && infofriend.data_room[0].type === 'user'" src="/static/img/default_profile/man-white.png" class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
        <img v-else-if="infofriend.data_room[0].profilepicture === '' && infofriend.data_room[0].type === 'business'" src="/static/img/default_profile/business-white.png" class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
        <img v-else-if="infofriend.data_room[0].profilepicture === '' && infofriend.data_room[0].type === 'bot'" src="/static/img/default_profile/bot-white.png" class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
        <img v-else src="/static/img/default_profile/man-white.png" class="alligator-turtle">
      </v-avatar>
      <v-avatar size="40px" class="user-photo" v-else-if="infofriend.type === 'group'">
        <img v-if="infofriend.picture" :src="infofriend.picture" class="alligator-turtle">
        <img v-else src="/static/img/default_profile/group-white.png" class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
      </v-avatar>
      <v-toolbar-title v-if="infofriend.type ==='user'">{{infofriend.data_room[0].name}}
      </v-toolbar-title>
      <v-toolbar-title v-else>{{infofriend.group_name}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <p>H: {{ $vssHeight }} | I: {{innerHeight}} | Bo: {{box_height}}</p> -->
      <!-- <p>{{ chatlogsFlex }}</p> -->
      <!-- <v-btn color="primary" @click="hideLayoutChat()">text</v-btn> -->
      <!-- video call -->
      <!-- <v-btn icon @click="showphone = !showphone" v-if="infofriend.data_room[0].type != 'bot' && statemember == 'active'">
        <v-icon>fas fa-phone</v-icon>
      </v-btn> -->

      <!-- <p>{{infofriend.data_room[0].statemember}}</p> -->

      <v-btn icon @click="toPageinfo()">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <!--  tab show video call-->
    <v-toolbar v-show="showphone" style="background-color: white !important; height: 90px !important;">
      <v-layout row wrap justify-center align-center>
        <v-flex xs5 style="justify-content: center; display: flex; mr-2">
          <v-layout column wrap justify-center align-center class="mt-4">
            <v-btn small color="green" fab icon @click="openCall('voice',infofriend)">
              <v-icon style="color: white;">fas fa-phone</v-icon>
            </v-btn>
            <span>{{$t('ChatSide.conference.startCall')}}</span>
          </v-layout>
        </v-flex>
        <v-flex xs5 style="justify-content: center; display: flex;">
          <v-layout column wrap justify-center align-center class="mt-4">
            <v-btn small color="primary" fab icon @click="openCall('video',infofriend)">
              <v-icon>fas fa-video</v-icon>
            </v-btn>
            <span>{{$t('ChatSide.conference.startVideo')}}</span>
          </v-layout>
        </v-flex>
        <v-flex xs2>
          <v-btn icon @click="closeshow">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <!-- tab announce_msg -->
    <div v-if="listannounce.length != 0">
      <v-btn fab dark small v-if="less" @click="less = !less; show = false;" style="position: fixed; right: 0%;z-index: 2;background: #2562afd4;">
        <v-icon style="font-size: 15px;">fas fa-bullhorn</v-icon>
      </v-btn>
      <v-card style=" position: fixed; width: 100%; z-index: 2; background: none;" v-else id="list_height">
      <v-slide-y-transition>
        <v-card-text v-show="show" style="padding: 0px !important;">
          <v-list style="max-height: 200px; overflow-y: scroll;">
            <template v-for="(item, index) in listannounce">
              <v-list-tile
                :key="item.index"
                @click="announce_dialog(item)"
                class="list-announce">
                <v-list-tile-action>
                  <!-- @contextmenu.prevent="RightClickDialog($event, ['cancel_announce'], item)" -->
                  <v-icon style="font-size: 18px;">fas fa-bullhorn</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <!-- <v-list-tile-title style="font-size: 13px;">llll {{ item.message_info.message }}</v-list-tile-title> -->
                  <v-list-tile-title style="font-size: 13px;" v-html="convertMention(item.message_info.message)"></v-list-tile-title>
                  <v-list-tile-sub-title style="font-size: 12px;">{{ item.nickname }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index + 1 < listannounce.length" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-slide-y-transition>
      <v-card-actions v-if="!show" style="background: #2562afa6; height: 40px;">
        <v-icon style="font-size: 18px; color: #1b232c;">fas fa-bullhorn</v-icon>
        <p class="mb-0" style="color: black; padding-left: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; cursor: pointer; font-size: 13px;"
           @click="announce_dialog(item)" v-html="convertMentionAnnounce(listannounce[0].message_info.message)">
        </p>
        <!-- @click="RightClickDialog($event, ['cancel_announce'], listannounce[0])" -->
        <v-spacer></v-spacer>
        <v-btn icon @click.native="show = !show">
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions v-if="show" style="color: white;background: #2562af;height: 40px;">
        <p class="p-announce" @click="delete_announce()">{{$t('ChatSide.announce.delete')}}</p>
        |
        <p class="p-announce" @click="less = !less">{{$t('ChatSide.announce.minimize')}}</p>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="show = !show">
          <v-icon style="color: white;">keyboard_arrow_up</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    </div>
    <v-layout row wrap class="centerbox">
      <div class="chatbox">
        <!-- :style="chatbox" -->
        <vue-context ref="menucontext" style="z-index: 1500;">
           <li v-for="(list,index) in ListMenuRightClick" :key="index">
               <a @click="SelectMenuRightClick(list.methods)">{{list.message}}</a>
           </li>
         </vue-context>
        <!-- modal file pdf -->
        <div class="modalc" id="myModalFile">
          <div id="headcaption">
            <v-container>
              <v-layout row wrap>
                <v-flex xs2 md2 sm2 style="text-align: right; padding-right: 2vw;">
                  <v-avatar size="40px" class="user-photo">
                    <img v-if="picSend" :src="picSend" class="alligator-turtle">
                    <img v-else-if="typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                    <img v-else-if="typeuser === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                  </v-avatar>
                </v-flex>
                <v-flex xs9 md9 sm9>
                  <p style="font-size: 14px; white-space: nowrap; width: 16em; overflow: hidden; text-overflow: ellipsis;font-weight: bold;"> {{filenameSend}}</p>
                  <p style="font-size: 12px; white-space: nowrap; width: 20em; overflow: hidden; text-overflow: ellipsis;"> {{$t('Dialog.showImage.by')}} {{nicknameSend}}
                  </p>
                  <p style="font-size: 12px;">{{$t('Dialog.showImage.date')}} &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
                  </p>
                </v-flex>
                <v-flex xs1 md1 sm1>
                  <span class="close" @click="closemodal()">&times;</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md12 sm12 style="margin-left: 15vw;">
                  <!-- <v-btn depressed small  class="btnallow" :href="pathSend" target="_blank" v-if="extension(filenameSend) !== 'pdf'" >
                    <v-icon>file_download</v-icon>&nbsp;
                    บันทึก
                  </v-btn> -->
                  <v-btn depressed small  class="btnallow text-transform" @click="loadfile(infor_file)" :disabled="statemember !== 'active'">
                    <v-icon>file_download</v-icon>&nbsp;
                      {{$t('AnswerQuestion.keep')}}
                  </v-btn>
                  <v-btn depressed small class="btncancel text-transform" @click="sendimgonebox(tokenmsgSend)" :disabled="statemember !== 'active'">
                    <v-icon>cloud_upload</v-icon> &nbsp;
                      {{$t('AnswerQuestion.sendOnebox')}}
                  </v-btn>
                </v-flex>
              </v-layout>
          </v-container>
          </div>
            <!-- <iframe :src="filepdf" style="width:100%; height:100%;justify-content: center;" frameborder="0"></iframe> -->
            <!-- <pdf
            :src="filepdf"
            :page="1"
            ref="myPdfComponent">
            </pdf> -->
            <div style="overflow-y: scroll; height: 90%;">
              <!-- <pdf
                v-for="i in numPages"
                :key="i"
                :page="i"
                :src="filepdf"
                ref="myPdfComponent"
                @password="passwordPdfDialog"
                @error="errorPdfDialog"
                >
              </pdf> -->
              <div class="app-content">
                <vue-pdf-embed
                  ref="myPdfComponent"
                  :source="filepdf"
                  :page="page"
                  @password-requested="handlePasswordRequest"
                  @rendered="handleDocumentRender"
                />
              </div>
            </div>
        </div>
        <!-- modal picture -->
        <div id="myModalImage" class="modalc">
          <div id="headcaption">
            <v-container>
              <v-layout row wrap>
                <v-flex xs2 md2 sm2 style="text-align: right; padding-right: 2vw;">
                  <v-avatar size="40px" class="user-photo">
                    <img v-if="picSend" :src="picSend" class="alligator-turtle">
                    <img v-else-if="typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                    <img v-else-if="typeuser === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                  </v-avatar>
                </v-flex>
                <v-flex xs9 md9 sm9>
                  <p style="font-size: 14px; white-space: nowrap; width: 16em; overflow: hidden; text-overflow: ellipsis;font-weight: bold;"> {{filenameSend}} </p>
                  <p style="font-size: 12px; white-space: nowrap; width: 20em; overflow: hidden; text-overflow: ellipsis;"> {{$t('Dialog.showImage.by')}} {{nicknameSend}}
                  </p>
                  <p style="font-size: 12px;">{{$t('Dialog.showImage.date')}} &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
                  </p>
                </v-flex>
                <v-flex xs1 md1 sm1>
                  <span class="close" @click="closemodal()">&times;</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md12 sm12 style="margin-left: 15vw;">
                  <v-btn depressed small  class="btnallow text-transform"  @click="loadpic(filenameSend)" :disabled="statemember !== 'active'">
                    <v-icon>file_download</v-icon>&nbsp;
                      {{$t('AnswerQuestion.keep')}}
                  </v-btn>
                  <v-btn depressed small class="btncancel text-transform" @click="sendimgonebox(tokenmsgSend)" :disabled="statemember !== 'active'">
                    <v-icon>cloud_upload</v-icon> &nbsp;
                      {{$t('AnswerQuestion.sendOnebox')}}
                  </v-btn>
                </v-flex>
              </v-layout>
          </v-container>
          </div>
          <img class="modal-contentc" id="img01">
      </div>
        <div class="chatlogs" id="myscroll" v-on:scroll="scrollFunction" :style="chatlogsFlex">
          <div v-if="progressLoadChat">
            <v-progress-linear :indeterminate="progressLoadChat"></v-progress-linear>
          </div>
          <!-- <div v-if="progressLoadChat">
            <v-progress-circular :value="50" :indeterminate="progressLoadChat" color="primary"></v-progress-circular>
          </div> -->
          <!-- selected == false -->
          <div v-for="(item, i) in items" :key="item.id" v-if="!selected">
            <v-layout justify-center row align-center>
              <div v-if="i == 0">
                <div class="text-xs-center" @click="loadchathistory" v-if="statusload">
                  <v-btn round outline color="primary" style="background: #ff000000 !important;text-transform: none;"><v-icon left style="font-size: 18px !important;" @click="loadchathistory">refresh</v-icon>{{$t('ChatSide.loadHistory')}}</v-btn>
                </div>
                <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect === item.tokenroom">
                    <span>{{dateMoment(item.timestamp)}} </span>
                </div>
              </div>
              <div v-else-if="dateMoment(item.timestamp) !== dateMoment(items[i-1].timestamp)">
                <br>
                <v-flex xs2 md12 sm12>
                <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect === item.tokenroom">
                  <span>{{dateMoment(item.timestamp)}}</span>
                </div>
               </v-flex>
              </div>
            </v-layout>
            <!--========= SELF =========-->
            <div :ref="item.tokenmessage" :id="item.tokenmessage" class="chat self" v-if="item.tokenuser === token && tokenrooomSelect === item.tokenroom">
              <v-layout align-center justify-end row v-if="item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task'">
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
                  <p class="boxself_unsend">
                    {{$t('ChatSide.system.self.cancelMsg')}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
                  <p class="boxself_unsend">
                    {{item.message}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
                  <p class="boxself_system" v-if="item.message === 'active'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    {{$t('ChatSide.system.self.joinGroup')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message === 'kick'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message === 'invite'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} เชิญ {{item.file_name}} -->
                    {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message === 'leave'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- คุณออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.self.leftGroup')}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_albums'">
                  <p class="boxself_system" v-if="item.message == 'edit_name_albums'">
                    <!-- คุณแก้ไขชื่ออัลบั้ม -->
                    {{$t('ChatSide.system.self.editNameAlbum')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'create_albums'">
                    <!-- คุณสร้างอัลบั้ม {{ item.albums_name}} -->
                    {{$t('ChatSide.system.self.createAlbum', { name: item.albums_name })}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'delete_albums'">
                    <!-- คุณลบอัลบั้ม -->
                    {{$t('ChatSide.system.self.deleteAlbum')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'delete_images_albums'">
                    <!-- คุณลบรูปภาพในอัลบั้ม -->
                    {{$t('ChatSide.system.self.deleteImageAlbum')}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_task'">
                  <p class="boxself_system" v-if="item.message == 'edit_task'">
                    {{$t('ChatSide.system.self.editTask')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'create_project'">
                    {{$t('ChatSide.system.self.createProject')}}
                  </p>
                </v-flex>
              </v-layout>
              <v-layout align-center justify-end row v-else style="margin-bottom: 15px; margin-top: 15px;">
                <v-flex xs2 v-if="item.status == 'no' && item.typeofmessage == 'message'">
                  <v-layout align-end justify-end wrap row>
                    <p @click="resendMessage(item)" style="padding-right: 5px; color: #ff0000cc;font-size: 10px; cursor: pointer; text-decoration: underline;">{{$t('ChatSide.system.resend')}}</p>
                  </v-layout>
                </v-flex>
                <v-flex xs2 v-else-if="item.status == 'no' && item.typeofmessage == 'contact'">
                  <v-layout align-end justify-end wrap row>
                    <p @click="resendMessage(item)" style="padding-right: 5px; color: #ff0000cc; font-size: 10px; cursor: pointer; text-decoration: underline;">{{$t('ChatSide.system.resend')}}</p>
                  </v-layout>
                </v-flex>
                <v-flex xs10 style="float: right;">
                  <v-layout row wrap align-end style="float: right;">
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px; display: none;" v-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0">{{timeMoment(item.timestamp)}} </span>
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px;" v-else>{{timeMoment(item.timestamp)}} </span>
                    <!-- message -->
                    <!-- <p slot="activator" v-if="item.typeofmessage === 'message'" style="height: 100%;" class="chat_self" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"  @click="setting_dialog(item, 'forwardunsend')">
                    </p> -->
                    <!-- <div slot="activator" v-if="item.typeofmessage === 'message'" style="height: 100%;" class="chat_self" @click="setting_dialog(item, 'forwardunsend')"> -->
                    <div slot="activator" v-if="item.typeofmessage === 'message'" style="height: 100%;" class="chat_self" data-long-press-delay="500" v-longclick="() =>  (item, 'forwardunsend')" >
                      <!-- <button
                        v-longclick="() => handleClickTest()" @click="handleClickTest()">+
                      </button> -->
                      <p slot="activator" style="margin: 0 !important;" @click="handleClickTest" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
                      </p>

                      <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
                        <link-prevue :url="x">
                          <template slot-scope="props">
                            <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                              <v-flex xl3 lg3 md3 sm3 class="border_website">
                                <p class="title_website" >{{props.title}}  </p>
                                <span class="description_website">{{props.description}}</span>
                              </v-flex>
                              <v-flex xl9 lg9 md9 sm9 class="centerimg_website">
                                <img class="img_website" :src="props.img"  v-if="props.img">
                              </v-flex>
                            </v-layout>
                          </template>
                          <template slot="loading">
                            <span></span>
                          </template>
                        </link-prevue>
                     </div>
                    </div>
                    <!-- type mention_message -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="chat_self" v-longclick="() => setting_dialog(item, 'forwardunsend')">
                      <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                        <v-flex xs1>
                          <v-avatar>
                            <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                            <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                          </v-avatar>
                        </v-flex>
                        <v-flex xs11 style="padding-left: 40px;">
                          <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                            <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                            <span @click="handleClickTest" v-html="convertMention(item.source_message.message)"></span>
                            <!-- <span>{{item.source_message.message}}</span> -->
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span v-if="item.source_message.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                              <span v-else>{{$t('ChatSide.sticker')}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span>{{$t('ChatSide.file')}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                              <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'video'">
                            <v-flex xs12>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <!-- <video width="100" height="100" controls style="justify-content: center; align-items: center;">
                                <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                              </video> -->
                              <video v-if="extension(item.source_message.message) === 'media'" width="150" height="150" controls style="justify-content: center; align-items: center;">
                                <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                              </video>
                              <div v-else style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                                <vplayer
                                  style="height: 150px !important;"
                                  :playerOptions="{
                                    type: 'application/x-mpegURL',
                                    src: item.source_message.message,
                                    preload: true,
                                    autoplay: false,
                                    isLoop: false,
                                    playsinline: false,
                                    poster: '',
                                    controls: 'progress,current,durration,volume',
                                    crossOrigin: false
                                  }"
                                  @onplay="play"
                                />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                              <span v-else>{{item.source_message.message}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="padding-bottom: 10px;" v-else>
                        <span>{{$t('ChatSide.noMsg')}}</span>
                      </v-layout>
                      <v-divider></v-divider>
                      <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                    </p>
                    <!-- type task -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="" @click="open_detail_task(item.task_id, item.tokenroom)">
                      <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                        <v-layout style="text-align: left;">
                          <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs11 sm11 md11 lg11 xl11>
                            <v-layout column wrap>
                              <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                              <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                        <v-layout column wrap align-start>
                          <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                          <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                          <div style="margin-bottom: 5px; text-align: left;">
                            <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                              <v-avatar left color="#2662af" >
                                <img v-if="profile" :src="profile" class="alligator-turtle">
                                <span v-else style="color: white;">{{name[0]}}</span>
                              </v-avatar>
                              <span class="test-overflow-chip">{{name}}</span>
                            </v-chip>
                            <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                              <v-avatar left color="#2662af" >
                                <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                                <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                              </v-avatar>
                              <span class="test-overflow-chip">{{assign.nickname}}</span>
                            </v-chip>
                            <v-chip label color="#e6ecf3" outline text-color="#3a506d">
                              {{item.task_info.state.name}}
                            </v-chip>
                          </div>
                        </v-layout>
                        <v-card-actions style="padding-left: 0px !important;">
                          <span style=" color: #6981a1 !important;">
                            {{$t('ChatSide.Task.viewDetail')}}
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                        </v-card-actions>
                      </v-card>
                    </p>

                    <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="" @click="open_detail_task(item.task_id, item.tokenroom)">
                     <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                       <v-layout style="text-align: left;">
                         <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs11 sm11 md11 lg11 xl11>
                           <v-layout column wrap>
                             <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                             <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                           </v-layout>
                         </v-flex>
                       </v-layout>
                       <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                       <v-layout column wrap align-start>
                         <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                         <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                         <div style="margin-bottom: 5px; text-align: left;">
                           <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                             <v-avatar left color="#2662af" >
                               <img v-if="profile" :src="profile" class="alligator-turtle">
                               <span v-else style="color: white;">{{name[0]}}</span>
                             </v-avatar>
                             <span class="test-overflow-chip">{{name}}</span>
                           </v-chip>
                           <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                             <v-avatar left color="#2662af" >
                               <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                               <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                             </v-avatar>
                             <span class="test-overflow-chip">{{assign.nickname}}</span>
                           </v-chip>
                         </div>
                       </v-layout>
                       <v-card-actions style="padding-left: 0px !important;">
                         <span style=" color: #6981a1 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                         <v-spacer></v-spacer>
                         <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                       </v-card-actions>
                     </v-card>
                   </p>
                    <!-- type image -->
                    <p v-else-if="item.typeofmessage === 'image'" style="width:500px;" class="boxselfimage" @click="setting_dialog(item, 'addimage')">
                      <v-img :src="item.message" height="200px" style="border-radius: 10px;" ></v-img>
                      <!-- @click="zoom(item)" -->
                    </p>
                    <!-- type sticker -->
                    <p v-else-if="item.typeofmessage === 'sticker'" style="margin-top: 0; height: 100%;" @click="setting_dialog(item, 'unsend')">
                      <img :src="item.file_name" class="boxselfsticker">
                    </p>
                    <!-- type web -->
                    <div v-else-if="item.typeofmessage === 'web'" style="width:500px;" class="boxselffile" >
                      <iframe height="400" style="visibility:visible; max-width: 55vw !important;" frameborder='0' :src="item.message" ></iframe>
                    </div>
                    <!-- type note active-->
                    <div slot="activator" v-else-if="item.typeofmessage === 'note' && statemember === 'active'" style="font-weight: 500; cursor: pointer; width: 200px !important; margin-bottom: 10px;" class="chat_self" @click="detailNote(item.note_id)">
                       <p class="textchat" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                       <p v-if="item.message.length ==20"> ...</p>
                       <v-divider></v-divider>
                        <span style=" color: #5a616b !important;"> {{$t('ChatSide.note')}} </span>
                        <v-icon style=" color: #5a616b !important;   right: 0;position: absolute;">navigate_next </v-icon>
                    </div>
                    <!-- type note != active-->
                    <div slot="activator" v-else-if="item.typeofmessage === 'note' && statemember !== 'active'" style="font-weight: 500; width: 200px !important; margin-bottom: 10px;" class="chat_self" @click="detailNote(item.note_id)">
                       <p class="textchat" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" style=" color: #5a616b !important;"></p>
                       <p v-if="item.message.length ==20"> ...</p>
                       <v-divider></v-divider>
                        <span style=" color: #5a616b !important;"> {{$t('ChatSide.note')}} </span>
                        <v-icon style=" color: #5a616b !important;   right: 0;position: absolute;">navigate_next </v-icon>
                    </div>
                    <!-- type contact -->
                  <v-layout slot="activator" v-else-if="item.typeofmessage === 'contact'" row align-center justify-start class="chat_selfcontact" style="font-weight: 500; cursor: pointer; margin-top: 15px;" @click="setting_dialog(item, 'forwardunsend')">
                    <v-flex xs5 md5 sm5>
                      <v-layout align-center justify-center row wrap>
                        <v-avatar size="40px" class="user-photo" >
                          <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                          <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type_contact === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-avatar>
                      </v-layout>
                    </v-flex>
                    <v-flex xs5 md5 sm5>
                      <v-layout align-center justify-center row wrap style="margin-top: 12px;">
                        <p class="text2">{{item.nickname_contact}}</p>
                      </v-layout>
                    </v-flex>
                    <v-flex xs2 md2 sm2>
                      <v-layout align-center justify-end row wrap>
                        <v-icon>navigate_next </v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <!-- type video -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'video'" style="width:500px; cursor: pointer;" class="boxselffile" @click="setting_dialog(item, 'forward')">
                      <v-flex xs12 v-if="extension(item.message) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <video width="180" height="130" controls>
                          <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </video>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <audio controls>
                          <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </audio>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <div style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                          <vplayer
                            style="height: 150px !important;"
                            :playerOptions="{
                              type: 'application/x-mpegURL',
                              src: item.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }"
                            @onplay="play"
                          />
                        </div>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message">
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <!-- @click="loadfile(item)" -->
                        <v-btn flat icon color="white" @click="setting_dialog(item, 'download')" >
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn>
                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)">
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <!-- type file -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')"  style="width:500px; cursor: pointer;" class="boxselffile">
                      <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center; cursor: pointer;"  @click="setting_dialog(item, 'forwardunsend')">
                        <!-- @click="zoomfile(item, false)" -->
                        <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                          <pdf
                          :src="item.message"
                          :page="1"
                          ref="myPdfComponent"
                          @password="passwordPdf($event, i, item)"
                          @error="errorPdf"
                          >
                          </pdf>
                        </v-card-media>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;" @click="setting_dialog(item, 'forward')">
                        <video width="200" height="130" controls>
                          <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </video>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;" @click="setting_dialog(item, 'forward')">
                        <audio controls>
                          <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </audio>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <v-icon style="color: white !important; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon>
                      </v-flex>
                    <v-card-title primary-title>
                      <div>
                        <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                      </div>
                    </v-card-title>
                    <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                      <v-spacer></v-spacer>
                      <!-- <v-btn flat icon color="blue" :href="item.message" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                      </v-btn> -->
                      <!-- // @click="loadfile(item)" -->
                      <v-btn flat icon color="white"  @click="setting_dialog(item, 'download')" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                       <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                      </v-btn>
                    </v-card-actions>
                    </p>
                    <p slot="activator" v-else-if="item.typeofmessage === 'file'" class="boxselffile" style="width:500px;" @click="setting_dialog(item, 'forwardunsend')">
                      <v-flex xs12>
                        <v-icon style="color: white; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message" :disabled="statemember !== 'active'">
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <!-- <v-btn flat icon color="white" @click="loadfile(item)" :disabled="statemember !== 'active'"> -->
                          <!-- <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon> -->
                        <!-- </v-btn> -->
                         <v-icon dark v-if="extension(item.file_name) == 'pdf'" @click="setting_dialog(item, 'forward')">visibility</v-icon>
                        <v-icon dark v-else @click="setting_dialog(item, 'download')">file_download</v-icon>

                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" :disabled="statemember !== 'active'">
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <!-- type location -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'location'" class=""  @click="setting_dialog(item, 'forwardunsend')" style="width: 180px; cursor: pointer; margin-top: 15px;">
                      <!-- @click="openlocation(item)" -->
                      <v-card style="background-color:  #b4d1f5; border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" class="white--text">
                        <v-layout style="text-align: left;" raw wrap>
                          <v-flex xs2 sm2 md2>
                            <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                          </v-flex>
                          <v-flex xs10 sm10 md10 style="color: black; padding-left: 5px;">
                            <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                            <span v-else>  {{$t('ChatSide.location')}}</span>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </p>
                    <!-- pdf password กรณีที่ไฟล์ pdf มีรหัสแล้วไม่สามารถ preview ได้ -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'pdf_password'" style="width:500px; cursor: pointer;" class="boxselffile">
                      <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center; cursor: pointer;"  @click="setting_dialog(item, 'forwardunsend')">
                        <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                          <pdf
                          src="https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf"
                          :page="1"
                          ref="myPdfComponent"
                          >
                          </pdf>
                        </v-card-media>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                    </p>
                    <!-- type date -->
                    <p slot="activator" v-else-if="item.typeofmessage=='date'" class="chat_self"><v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}</p>
                    <!-- type datetime -->
                    <p slot="activator" v-else-if="item.typeofmessage=='datetime'" class="chat_self"><v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}<br>
                    <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; {{item.message.split('T')[1]}} </p>
                    <!-- type call -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'call'" class="chat_self" style="text-align: center;width: 100px;">
                      <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='decline'">phone</v-icon>
                      <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                    <br>
                      <span v-if="item.message =='cancel' || item.message =='decline'">
                        {{checktypeCall(item.message)}}
                      </span>
                      <span v-else>{{secondsToHms(item.time_count)}}</span>
                    </p>

                    <!-- type conference -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'conference_msg'" class="chat_self" style="text-align: center;font-weight: 500 !important;">
                      <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#4065b4;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
                      <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#4065b4;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
                      <br>
                      <v-btn class="joinBtn" @click="backCall_conference_msg(item.information)">{{$t('ChatSide.conference.joinCall')}} </v-btn>
                    </div>

                    <!-- call agora -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'agora_call'" class="chat_self" style="text-align: center; font-weight: 500 !important;">
                      <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
                      <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                      <br>
                      <span v-if="item.message =='cancel'">
                        {{checktypeCall(item.message)}}
                      </span>
                      <span v-else>{{item.time}}</span>
                    </div>

                    <!-- type albums -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0" style="width: 180px; display: none;" class="chat_self_createablums" @click="detailAlbums(item.file_name)">
                      <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                      <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                      <v-layout row wrap justify-center align-center>
                        <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                      </v-layout>
                      <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', {count: item.image_add.length})}}</p>
                      <v-divider></v-divider>
                      <v-layout row wrap justify-center align-center class="mt-2">
                        <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                        <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                        <v-spacer></v-spacer>
                        <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                      </v-layout>
                    </div>

                    <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length !== 0" style="width: 180px;" class="chat_self_createablums" @click="detailAlbums(item.file_name)">
                      <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                      <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                      <v-layout row wrap justify-center align-center>
                        <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                      </v-layout>
                      <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', {count: item.image_add.length})}}</p>
                      <v-divider></v-divider>
                      <v-layout row wrap justify-center align-center class="mt-2">
                        <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                        <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                        <v-spacer></v-spacer>
                        <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                      </v-layout>
                    </div>
                    <!-- type official_template -->
                    <div v-else-if="item.typeofmessage === 'official_template'" class="chat_self" style="overflow: hidden;display: -webkit-inline-box; background: none; ">
                      <div>
                        <!-- width: 150px;  -->
                        <v-card style="border-radius: 10px;margin-right: 10px;background: #b4d1f5 !important;">
                          <h3 class="mb-0" style="color: #2562af;padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>

                          <v-img :src="item.element.image" v-if="item.element.image" style="height: 120px;" contain></v-img>
                          <v-card-title primary-title style="padding-top: 15px !important;">
                            <div style="width: 150px;">
                              <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="20" style="color:#343433;"></read-more>
                              <v-divider light v-if="!item.element.image"></v-divider>
                              <div v-for="(choice, index) in item.element.choice">
                                <v-btn flat style="text-transform: none; width: 100%;margin: 0;font-size: 13px; border-radius: 20px;">
                                  {{choice.label}}
                                </v-btn>
                              </div>
                            </div>
                          </v-card-title>
                        </v-card>
                      </div>
                    </div>
                    <!-- no type -->
                    <p slot="activator" v-else class="chat_self" >
                      {{$t('ChatSide.notSupportVersion')}}
                    </p>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <!--========= OTHER ========-->
            <div :ref="item.tokenmessage" :id="item.tokenmessage" class="chat other" v-if="item.tokenuser !== token && tokenrooomSelect === item.tokenroom" style="margin-bottom: 10px;">
              <v-layout align-center row wrap v-if="item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task'">
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
                  <v-layout justify-center>
                    <p class="boxother_unsend">
                      <!-- {{item.nickname}} ยกเลิกข้อความ -->
                      {{$t('ChatSide.system.other.cancelMsg', { name: item.nickname})}}
                    </p>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
                  <v-layout justify-center>
                    <p class="boxother_unsend">
                      {{item.message}}
                    </p>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
                  <p class="boxother_system" v-if="item.message === 'active'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} เข้าร่วมกลุ่ม. -->
                    {{$t('ChatSide.system.other.joinGroup', { name: item.nickname})}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message === 'kick'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.default.kickMemberGroup', { name_active: item.nickname, name_passive: item.file_name})}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message === 'invite'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} เชิญ {{item.file_name}} -->
                    {{$t('ChatSide.system.default.inviteMemberGroup', { name_active: item.nickname, name_passive: item.file_name})}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message === 'leave'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} ออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.other.leftGroup', { name: item.nickname})}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_albums'">
                  <p class="boxother_system" v-if="item.message == 'edit_name_albums'">
                    <!-- {{item.nickname}} แก้ไขชื่ออัลบั้ม -->
                    {{$t('ChatSide.system.other.editNameAlbum', { name: item.nickname})}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message == 'create_albums'">
                    <!-- {{item.nickname}} สร้างอัลบั้ม {{ item.albums_name}} -->
                    {{$t('ChatSide.system.other.createAlbum', { name: item.nickname, album_name: item.albums_name })}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message == 'delete_albums'">
                    <!-- {{item.nickname}} ลบอัลบั้ม -->
                    {{$t('ChatSide.system.other.deleteAlbum', { name: item.nickname})}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message == 'delete_images_albums'">
                    <!-- {{item.nickname}} ลบรูปภาพในอัลบั้ม -->
                    {{$t('ChatSide.system.other.deleteImageAlbum', { name: item.nickname})}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_task'">
                  <p class="boxself_system" v-if="item.message == 'edit_task'">
                    {{$t('ChatSide.system.other.editTask', {name: item.nickname})}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'create_project'">
                    {{$t('ChatSide.system.other.createProject', {name: item.nickname})}}
                  </p>
                </v-flex>
              </v-layout>
              <v-layout justify-start row v-else style="margin-top: 15px;">
                <v-flex xs2 sm2 md2 @click="detailFriend(item.tokenuser)" style="cursor: pointer; padding-right: 10px;" v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action'">
                  <div style="display: none;" v-if="item.typeofmessage == 'albums_message' && item.image_add.length == 0">
                  </div>
                  <div v-else>
                    <v-avatar size="40px" class="user-photo" v-if="item.path_pic !== ''">
                      <img :src="item.path_pic" class="alligator-turtle">
                    </v-avatar>
                    <v-avatar size="40px" class="user-photo" v-else>
                      <img src='/static/img/default_profile/man-white.png' v-if="item.type === 'user'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/bot-white.png' v-else-if="item.type === 'bot'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/business-white.png' v-else-if="item.type === 'company'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/business-white.png' v-else-if="item.type === 'government'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" v-else/>
                    </v-avatar>
                  </div>
                </v-flex>
                <v-flex xs10 style="float: left;">
                  <v-layout row wrap align-end style="float: left; padding-left: 0px;">
                    <!-- message -->
                    <!-- <p v-if="item.typeofmessage === 'message'" style="height: 100%;" class="chat_other" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" @click="setting_dialog(item, 'forward')">
                    </p> -->
                    <div slot="activator" v-if="item.typeofmessage === 'message'" class="chat_other" v-longclick="() => setting_dialog(item, 'forward')">
                      <p style="margin: 0 !important;"  @click="handleClickTest" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
                      </p>
                      <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
                        <link-prevue :url="x">
                          <template slot-scope="props">
                            <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                              <v-flex xl3 lg3 md3 sm3 class="border_website">
                                <p class="title_website" >{{props.title}}</p>
                                <span class="description_website">{{props.description}}</span>
                              </v-flex>
                              <v-flex xl9 lg9 md9 sm9 class="centerimg_website">
                                <img class="img_website" :src="props.img"  v-if="props.img">
                              </v-flex>
                            </v-layout>
                          </template>
                          <template slot="loading">
                            <span></span>
                          </template>
                        </link-prevue>
                      </div>
                    </div>
                    <!-- image -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'image'" style="width:500px; cursor: pointer;" class="boxfriendimage" @click="setting_dialog(item, 'forwardimagedialog')">
                    <v-img :src="item.message" height="200px" style="border-radius: 10px;"></v-img>
                    <!-- @click="zoom(item)" -->
                  </p>
                  <!-- type question_detail -->
                  <!-- <p slot="activator" v-else-if="item.typeofmessage === 'template'">
                    <v-layout style="width: 200px;" class="scrolling-wrapper-template">
                      <v-layout row wrap>
                        <v-flex
                          v-for="(infoans, index) in item.info_ans"
                          :key="index"
                          v-bind="{ [`xs${12}`]: true }"
                          style="padding-right: 20px;"
                        >
                          <v-card style="border-radius: 15px; width: 170px;">
                            <v-container
                              fill-height
                              fluid
                              pa-2
                            >
                              <v-layout column wrap justify-center align-center>
                                <v-flex xs12 align-start flexbox style="word-break: break-all; width: 100%;">
                                  <v-card-media v-if="infoans.image" :src="infoans.image" height="75px"></v-card-media>
                                  <h4 style="color: #2562ae;" v-if="selected === false">{{infoans.title}}</h4>
                                  <h4 style="color: #61666d;" v-else>{{infoans.title}}</h4>
                                  <read-more class="mb-0" more-str="อ่านเพิ่มเติม" :text="convert(infoans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" less-str="แสดงน้อยลง" :max-chars="50" style="margin-bottom: 0px !important;"></read-more>
                                  <br v-if="!infoans.image">
                                  <v-divider light v-if="!infoans.image"></v-divider>
                                </v-flex>
                                <v-flex xs12 align-start flexbox v-for="(question, index) in infoans.choice" :key="index">
                                  <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'text' && selected === false" style="text-transform: none;">
                                    <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                  <v-btn disabled flat color="primary"  v-if="question.type === 'text' && selected === true" style="text-transform: none;">
                                    <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>

                                  <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'link' && selected === false" style="text-transform: none;">
                                    <p class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                  <v-btn disabled flat color="primary"  v-if="question.type === 'link' && selected === true"  style="text-transform: none;">
                                    <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>

                                  <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'file' && selected === false" style="text-transform: none;"><v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp;{{question.label}}</v-btn>
                                  <v-btn disabled flat color="primary" v-if="question.type === 'file' && selected === true" style="text-transform: none;"><v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp;
                                    <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                  <v-btn
                                    style="text-transform: none;"
                                    slot="activator"
                                    v-if="question.type === 'webview' && selected === false" flat color="primary"
                                    @click="ans_question(question, item.tokenmessage, item.tokenuser)"
                                  >
                                  <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                  <v-btn
                                    disabled
                                    style="text-transform: none;"
                                    slot="activator"
                                    v-if="question.type === 'webview' && selected === true" flat color="primary"
                                  >
                                  <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                  <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'ekyc' && selected === false" style="text-transform: none;">
                                    <p class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                  <v-btn disabled flat color="primary" v-if="question.type === 'ekyc' && selected === true" style="text-transform: none;">
                                    <p class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-flex>
                      </v-layout>
                  </v-layout>
                  </p> -->
                  <div slot="activator" v-else-if="item.typeofmessage === 'template'" class="boxfriendquestion scrolling-wrapper-template" style="overflow-x: scroll;overflow-y: hidden;display: flex; background: none; width: 275px; padding: 10px; align-items: end;">
                    <!-- -webkit-inline-box -->
                    <div v-for="(info_ans, index) in item.info_ans">
                      <v-card style="border-radius: 10px; width: 200px;margin-right: 10px;" >
                        <!-- class="height-template" -->
                        <v-img :src="info_ans.image" aspect-ratio="2.75" v-if="info_ans.image" style="height: 120px;"></v-img>
                        <v-card-title primary-title style="padding-top: 15px !important;">
                          <div style="width: 176px;">
                            <h3 class="mb-0" style="color: #2562ae;">{{info_ans.title}}</h3>
                            <!-- <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="50" style="margin-bottom: 0px !important;"></read-more> -->
                            <p style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;" class="mb-0" v-html="convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                            <a v-if="info_ans.detail.length >= 40" @click="clickReadmore(info_ans)"><b>{{$t('ChatSide.Read.readmore')}}</b></a>
                            <v-divider light v-if="!info_ans.image" class="mt-2"></v-divider>
                            <!-- <div style="bottom: 7px; position: absolute; width: 85%;"> -->
                              <div v-for="(choice, index) in info_ans.choice">
                                <v-btn block v-if="choice.type=='file'" flat color="primary" style="text-transform: none; width: 100%;margin: 0; font-size: 13px;" @click="ans_question(choice, item.tokenmessage, item.tokenuser)">
                                  <v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp; <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                </v-btn>
                                <v-btn v-else flat color="primary" style="text-transform: none; width: 100%;margin: 0;font-size: 13px;" @click="ans_question(choice, item.tokenmessage, item.tokenuser)">
                                  <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                </v-btn>
                              </div>
                            <!-- </div> -->
                          </div>
                        </v-card-title>
                      </v-card>
                    </div>
                  </div>

                  <!-- type mention_message -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="chat_other" v-longclick="() => setting_dialog(item, 'forwardunsend')">
                    <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                      <v-flex xs1>
                        <v-avatar>
                          <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                          <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                        </v-avatar>
                      </v-flex>
                      <v-flex xs11 style="padding-left: 40px;">
                        <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                          <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                          <span @click="handleClickTest" v-html="convertMention(item.source_message.message)"></span>
                          <!-- <span>{{item.source_message.message}}</span> -->
                        </v-layout>
                        <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                          <v-flex xs8>
                            <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                            <br>
                            <span v-if="item.source_message.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                            <span v-else>{{$t('ChatSide.sticker')}}</span>
                          </v-flex>
                          <v-flex xs4>
                            <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                          </v-flex>
                        </v-layout>
                        <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                          <v-flex xs8>
                            <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                            <br>
                            <span>{{$t('ChatSide.file')}}</span>
                          </v-flex>
                          <v-flex xs4>
                            <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                            <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                          </v-flex>
                        </v-layout>
                        <v-layout row v-else-if="item.source_message.typeofmessage === 'video'">
                          <v-flex xs12>
                            <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                            <br>
                            <!-- <video width="100" height="100" controls style="justify-content: center; align-items: center;">
                              <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                            </video> -->
                            <video v-if="extension(item.source_message.message) === 'media'" width="150" height="150" controls style="justify-content: center; align-items: center;">
                              <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                            </video>
                            <div v-else style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                              <vplayer
                                style="height: 150px !important;"
                                :playerOptions="{
                                  type: 'application/x-mpegURL',
                                  src: item.source_message.message,
                                  preload: true,
                                  autoplay: false,
                                  isLoop: false,
                                  playsinline: false,
                                  poster: '',
                                  controls: 'progress,current,durration,volume',
                                  crossOrigin: false
                                }"
                                @onplay="play"
                              />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                          <v-flex xs8>
                            <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                            <br>
                            <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                            <span v-else>{{item.source_message.message}}</span>
                          </v-flex>
                          <v-flex xs4>
                            <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap style="padding-bottom: 10px;" v-else>
                      <span>{{$t('ChatSide.noMsg')}}</span>
                    </v-layout>
                    <v-divider></v-divider>
                    <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                  </p>
                  <!-- type task_message -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="" @click="open_detail_task(item.task_id, item.tokenroom)">
                    <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                      <v-layout style="text-align: left;">
                        <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                        </v-flex>
                        <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                        </v-flex>
                        <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                        </v-flex>
                        <v-flex xs11 sm11 md11 lg11 xl11>
                          <v-layout column wrap>
                            <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                            <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                      <v-layout column wrap align-start>
                        <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                        <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                        <div style="margin-bottom: 5px; text-align: left;">
                          <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                            <v-avatar left color="#2662af" >
                              <img v-if="profile" :src="profile" class="alligator-turtle">
                              <span v-else style="color: white;">{{name[0]}}</span>
                            </v-avatar>
                            <span class="test-overflow-chip">{{name}}</span>
                          </v-chip>
                          <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                            <v-avatar left color="#2662af" >
                              <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                              <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                            </v-avatar>
                            <span class="test-overflow-chip">{{assign.nickname}}</span>
                          </v-chip>
                          <v-chip label color="#dcd9d9" outline text-color="#3a506d">
                            {{item.task_info.state.name}}
                          </v-chip>
                        </div>
                      </v-layout>
                      <v-card-actions style="padding-left: 0px !important;">
                        <span style=" color: #818181 !important;">
                          {{$t('ChatSide.Task.viewDetail')}}
                        </span>
                        <v-spacer></v-spacer>
                        <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                      </v-card-actions>
                    </v-card>
                  </p>

                  <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="" @click="open_detail_task(item.task_id, item.tokenroom)">
                   <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                     <v-layout style="text-align: left;">
                       <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                       </v-flex>
                       <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                       </v-flex>
                       <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                       </v-flex>
                       <v-flex xs11 sm11 md11 lg11 xl11>
                         <v-layout column wrap>
                           <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                           <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                         </v-layout>
                       </v-flex>
                     </v-layout>
                     <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                     <v-layout column wrap align-start>
                       <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                       <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                       <div style="margin-bottom: 5px; text-align: left;">
                         <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                           <v-avatar left color="#2662af" >
                             <img v-if="profile" :src="profile" class="alligator-turtle">
                             <span v-else style="color: white;">{{name[0]}}</span>
                           </v-avatar>
                           <span class="test-overflow-chip">{{name}}</span>
                         </v-chip>
                         <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                           <v-avatar left color="#2662af" >
                             <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                             <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                           </v-avatar>
                           <span class="test-overflow-chip">{{assign.nickname}}</span>
                         </v-chip>
                       </div>
                     </v-layout>
                     <v-card-actions style="padding-left: 0px !important;">
                       <span style=" color: #818181 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                       <v-spacer></v-spacer>
                       <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                     </v-card-actions>
                   </v-card>
                 </p>
                  <!-- type approve_message -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'approve_message' && item.disable === 'false' && selected === false" @click="openapprove(item)" style="cursor: pointer; width: 150px;">
                    <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 145px;" class="white--text">
                      <v-layout>
                        <v-flex xs12 sm12 md12>
                          <h3 style="color: #2562ae !important;">{{item.info_ans[0].title}}</h3>
                          <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                      <span style=" color: #2562ae !important;"> {{$t('ChatSide.approve_message.viewDetail')}} </span>
                      <v-spacer></v-spacer>
                      <v-icon style=" color: #2562ae !important;   right: 0;position: absolute;">navigate_next </v-icon>
                      </v-card-actions>
                    </v-card>
                  </p>
                  <p slot="activator" v-else-if="item.typeofmessage === 'approve_message' && item.disable === 'true' && selected === false" style="width: 150px;">
                    <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 145px;" class="white--text">
                      <v-layout>
                        <v-flex xs12 sm12 md12>
                          <h3 style="color: #757575 !important;">{{item.info_ans[0].title}}</h3>
                          <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                      <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.receiveAns')}} </span>
                      </v-card-actions>
                    </v-card>
                  </p>
                  <p slot="activator" v-else-if="item.typeofmessage === 'approve_message' && selected === true" style="width: 150px;">
                    <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 145px;" class="white--text">
                      <v-layout>
                        <v-flex xs12 sm12 md12>
                          <h3 style="color: #757575 !important;">{{item.info_ans[0].title}}</h3>
                          <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions v-if="item.disable === 'false'">
                      <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.viewDetail')}} </span>
                      <v-spacer></v-spacer>
                      <v-icon style=" color: #757575 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                      </v-card-actions>
                      <v-card-actions v-else>
                      <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.receiveAns')}} </span>
                      </v-card-actions>
                    </v-card>
                  </p>
                  <!-- type date -->
                  <p slot="activator" v-else-if="item.typeofmessage == 'date'" class="chat_other"><v-icon style="font-size: 18px; color: #4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
                  </p>
                  <!-- type datetime -->
                  <p slot="activator" v-else-if="item.typeofmessage == 'datetime'" class="chat_other"><v-icon style="font-size: 18px; color: #4065b4;"> far fa-calendar-alt</v-icon> &nbsp;{{momentday(item.message)}}<br>
                    <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; {{item.message.split('T')[1]}}
                  </p>
                  <!-- type web -->
                  <div slot="activator" v-else-if="item.typeofmessage == 'web'" class="boxfriendfile" style="width: 500px;">
                    <iframe height="400" style="visibility:visible; max-width: 55vw !important;" frameborder='0' :src="item.message" ></iframe>
                  </div>
                  <!-- type note active-->
                  <div slot="activator" v-else-if="item.typeofmessage === 'note' && statemember === 'active'" style="font-weight: 500; cursor: pointer; width: 200px !important; margin-bottom: 10px;" class="chat_other" @click="detailNote(item.note_id)">
                    <p class="textchat" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    <p v-if="item.message.length == 20"> ...</p>
                    <v-divider></v-divider>
                    <span style=" color: #5a616b !important;"> {{$t('ChatSide.note')}} </span>
                      <v-icon style=" color: #5a616b !important;right: 0;position: absolute;">navigate_next </v-icon>
                  </div>
                  <!-- type note != active-->
                  <div slot="activator" v-else-if="item.typeofmessage === 'note' && statemember !== 'active'" style="font-weight: 500; width: 200px !important; margin-bottom: 10px;" class="chat_other"  @click="detailNote(item.note_id)">
                    <p class="textchat" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" style=" color: #5a616b !important;"></p>
                    <p v-if="item.message.length == 20"> ...</p>
                    <v-divider></v-divider>
                    <span style=" color: #5a616b !important;"> {{$t('ChatSide.note')}} </span>
                      <v-icon style=" color: #5a616b !important;right: 0;position: absolute;">navigate_next </v-icon>
                  </div>
                  <!-- type sticker -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'sticker'"  style="margin-top: 0; height: 100%;" @click="setting_dialog(item, 'mention')">
                    <img :src="item.file_name" class="boxfriendsticker">
                  </p>
                  <!-- type video -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'video'"  style="width:500px; cursor: pointer;" class="boxfriendfile" @click="setting_dialog(item, 'forward')">
                    <v-flex xs12 v-if="extension(item.message) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;">
                      <video width="180" height="130" controls>
                        <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                      </video>
                    </v-flex>
                    <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;">
                      <audio controls>
                        <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                      </audio>
                    </v-flex>
                    <v-flex xs12 v-else>
                      <div style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                        <vplayer
                          style="height: 150px !important;"
                          :playerOptions="{
                            type: 'application/x-mpegURL',
                            src: item.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }"
                          @onplay="play"
                        />
                      </div>
                    </v-flex>
                    <v-card-title primary-title>
                      <div>
                        <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white;">{{item.file_name}}</div>
                      </div>
                    </v-card-title>
                    <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                      <v-spacer></v-spacer>
                      <!-- <v-btn flat icon color="blue" :href="item.message">
                        <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                      </v-btn> -->
                      <v-btn flat icon color="white" @click="loadfile(item)" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                       <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)">
                        <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </p>
                  <!-- type file -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf')"  style="width:500px; cursor: pointer;" class="boxfriendfile" @click="setting_dialog(item, 'forward')">
                      <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center; cursor: pointer;">
                        <!-- @click="zoomfile(item, false)" -->
                        <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                          <pdf
                          :src="item.message"
                          :page="1"
                          ref="myPdfComponent"
                          @password="passwordPdf($event, i, item)"
                          @error="errorPdf"
                          >
                          </pdf>
                        </v-card-media>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;">
                      <video width="200" height="130" controls>
                        <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                      </video>
                    </v-flex>
                    <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;">
                      <audio controls>
                        <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                      </audio>
                    </v-flex>
                      <v-flex xs12 v-else>
                        <v-icon style="color: white !important; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon>
                      </v-flex>
                    <v-card-title primary-title>
                      <div>
                        <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                      </div>
                    </v-card-title>
                    <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                      <v-spacer></v-spacer>
                      <!-- <v-btn flat icon color="blue" :href="item.message" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                      </v-btn> -->
                      <v-btn flat icon color="white" @click="loadfile(item)" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                      </v-btn>
                       <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </p>
                  <p slot="activator" v-else-if="item.typeofmessage === 'file' || item.typeofmessage === 'password_file' " class="boxfriendfile" style="width:500px;">
                    <v-flex xs12 @click="setting_dialog(item, 'forward')">
                       <!-- <v-icon v-if="extension(item.file_name) === 'pdf'" style="color: white; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon> -->
                            <!-- <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.file_name)}}</v-icon> -->
                      <v-icon v-if="extension(item.file_name) === 'pdf'" style="color: white; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">fas fa-file-pdf</v-icon>
                      <v-icon v-else style="color: white; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon>
                    </v-flex>
                    <v-card-title primary-title>
                      <div>
                        <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                      </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-icon dark v-if="item.typeofmessage == 'password_file'">mdi-lock</v-icon>
                      <!-- <p v-else>{{item.typeofmessage}}</p> -->
                      <v-spacer></v-spacer>
                      <!-- <v-btn flat icon color="blue" :href="item.message" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                      </v-btn> -->
                      <v-btn flat icon color="white" :disabled="statemember !== 'active'">
                        <v-icon v-if="extension(item.file_name) == 'pdf'" @click="setting_dialog(item, 'forward')">visibility</v-icon>
                        <v-icon v-else @click="setting_dialog(item, 'download')">file_download</v-icon>
                      </v-btn>
                       <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" :disabled="statemember !== 'active'">
                        <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </p>
                  <!-- pdf password กรณีที่ไฟล์ pdf มีรหัสแล้วไม่สามารถ preview ได้ -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'pdf_password'" style="width:500px; cursor: pointer;" class="boxfriendfile">
                    <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center; cursor: pointer;"  @click="setting_dialog(item, 'forward')">
                      <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                        <pdf
                        src="https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf"
                        :page="1"
                        ref="myPdfComponent"
                        >
                        </pdf>
                      </v-card-media>
                    </v-flex>
                    <v-card-title primary-title>
                      <div>
                        <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                      </div>
                    </v-card-title>
                  </p>
                  <!-- type location -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'location'" style="width: 180px; cursor: pointer;" class="" @click="setting_dialog(item, 'forward')">
                    <!-- @click="openlocation(item)" -->
                    <v-card style="background-color: #efefef; border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" class="white--text">
                      <v-layout style="text-align: left;">
                        <v-flex xs2 sm2 md2>
                          <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                        </v-flex>
                        <v-flex xs10 sm10 md10 style="color: black; padding-left: 5px;">
                          <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                          <span v-else>  {{$t('ChatSide.location')}}</span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </p>
                  <!-- type contact -->
                  <v-layout slot="activator" v-else-if="item.typeofmessage === 'contact'" row align-center justify-start class="chat_othercontact" style="font-weight: 500; cursor: pointer; margin-bottom: 15px;" @click="setting_dialog(item, 'forwardunsend')">
                    <v-flex xs5 md5 sm5>
                      <v-layout align-center justify-center row wrap>
                        <v-avatar size="40px" class="user-photo" >
                          <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                          <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type_contact === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-avatar>
                      </v-layout>
                    </v-flex>
                    <v-flex xs5 md5 sm5>
                      <v-layout align-center justify-center row wrap style="margin-top: 12px;">
                        <p class="text2">{{item.nickname_contact}}</p>
                      </v-layout>
                    </v-flex>
                    <v-flex xs2 md2 sm2>
                      <v-layout align-center justify-end row wrap>
                        <v-icon>navigate_next </v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <!-- type call -->
                  <p slot="activator" v-else-if="item.typeofmessage === 'call'" class="chat_other" style="text-align: center;width: 100px;">
                    <v-icon style="font-size: 30px; color:#676767;" v-if="item.message =='cancel' || item.message =='decline'">phone</v-icon>
                    <v-icon style="font-size: 30px; color:#676767;" v-else>phone_in_talk</v-icon>
                    <br>
                    <span v-if="item.message =='cancel' || item.message =='decline'">
                      {{checktypeCall(item.message)}}
                    </span>
                    <span v-else>{{secondsToHms(item.time_count)}}</span>
                  </p>
                  <!-- type conference -->
                  <div slot="activator" v-else-if="item.typeofmessage === 'conference_msg'" class="chat_other" style="text-align: center;font-weight: 500 !important;">
                    <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#4065b4;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
                    <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#4065b4;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
                    <br>
                    <v-btn class="joinBtn" @click="joinCall_conference_msg(item.information)">{{$t('ChatSide.conference.joinCall')}} </v-btn>
                  </div>

                  <!-- call agora -->
                  <div slot="activator" v-else-if="item.typeofmessage === 'agora_call'" class="chat_other" style="text-align: center; font-weight: 500 !important;">
                    <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
                    <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                    <br>
                    <span v-if="item.message =='cancel'">
                      {{checktypeCall(item.message)}}
                    </span>
                    <span v-else>{{item.time}}</span>
                  </div>
                  <!-- type albums_message -->
                  <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0" style="width: 180px; display: none;" class="chat_other_createablums" @click="detailAlbums(item.file_name)">
                    <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                    <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                    <v-layout row wrap justify-center align-center>
                      <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                    </v-layout>
                    <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', { count: item.image_add.length })}}</p>
                    <v-divider></v-divider>
                    <v-layout row wrap justify-center align-center class="mt-2">
                      <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                      <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                      <v-spacer></v-spacer>
                      <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                    </v-layout>
                  </div>

                  <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length !== 0" style="width: 180px;" class="chat_other_createablums" @click="detailAlbums(item.file_name)">
                    <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                    <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                    <v-layout row wrap justify-center align-center>
                      <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                    </v-layout>
                    <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', { count: item.image_add.length })}}</p>
                    <v-divider></v-divider>
                    <v-layout row wrap justify-center align-center class="mt-2">
                      <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                      <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                      <v-spacer></v-spacer>
                      <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                    </v-layout>
                  </div>
                  <!-- type official_template -->
                  <div slot="activator"  v-else-if="item.typeofmessage === 'official_template'" class="chat_other" style="overflow: hidden;display: -webkit-inline-box; background: none; ">
                   <div>
                     <!-- width: 150px;  -->
                     <v-card style="border-radius: 10px; margin-right: 10px;background: #efefef !important;">
                       <h3 class="mb-0" style="color: #2562af;padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>
                       <v-img :src="item.element.image" v-if="item.element.image" style="height: 120px; cursor: pointer;" @click="btn_img_official_template(item.element.onclick_img, item.tokenuser)" contain></v-img>
                       <v-card-title primary-title style="padding-top: 15px !important;">
                         <div style="width: 150px;">
                           <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="20" style="color:#343433;"></read-more>
                           <v-divider light v-if="!item.element.image"></v-divider>
                           <div v-for="(choice, index) in item.element.choice">
                             <v-btn flat :style="checkbutton(choice.color,choice.background)" @click="btn_official_template(choice, item.tokenuser, item.tokenmessage)" :disabled="(choice.disable == '0')? false: true">
                               {{choice.label}}
                             </v-btn>
                           </div>
                         </div>
                       </v-card-title>
                     </v-card>
                   </div>
                 </div>
                 <!-- type carousel -->
                 <div v-else-if="item.typeofmessage === 'carousel'" class="chat_other" style="overflow-x: scroll;overflow-y: hidden; display: -webkit-inline-box; background: none;">
                   <div v-for="(info_carousel, index) in item.elements">
                     <v-card style="border-radius: 20px; width: 200px; margin-right: 10px;">
                       <v-img
                         @click="btn_answer_carousel(info_carousel)"
                         :src="info_carousel.image"
                         :aspect-ratio="16/9"
                         v-if="info_carousel.image"
                         style="height: 180px; cursor: pointer;"
                       >
                         <v-layout v-if="info_carousel.type !== 'image'" row wrap align-end justify-center style="height: 180px;">
                           <v-btn v-if="info_carousel.button" round color="#0000009c" dark>
                             <span class="text-transform">{{info_carousel.button}}</span>
                           </v-btn>
                         </v-layout>
                       </v-img>
                     </v-card>
                   </div>
                 </div>
                  <!-- no type -->
                  <p v-else slot="activator" class="chat_other" style="color: #757575 !important;" >
                    {{$t('ChatSide.notSupportVersion')}}
                  </p>
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px; display: none;" v-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0">{{timeMoment(item.timestamp)}} </span>
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px;" v-else>{{timeMoment(item.timestamp)}} </span>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <!-- selected == true -->
          <div v-for="(item, i) in items" :key="item.id" v-if="selected">
            <v-layout justify-center row align-center>
              <div v-if="i == 0">
                <div class="text-xs-center" @click="loadchathistory" v-if="statusload">
                  <v-btn round outline color="primary" style="background: #ff000000 !important;text-transform: none;"><v-icon left style="font-size: 18px !important;" @click="loadchathistory">refresh</v-icon>โหลดข้อความเพิ่ม</v-btn>
                </div>
                <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect === item.tokenroom">
                    <span>{{dateMoment(item.timestamp)}} </span>
                </div>
              </div>
              <div v-else-if="dateMoment(item.timestamp) !== dateMoment(items[i-1].timestamp)">
                <br>
                <v-flex xs2 md12 sm12>
                <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect === item.tokenroom">
                  <span>{{dateMoment(item.timestamp)}}</span>
                </div>
               </v-flex>
              </div>
            </v-layout>
            <!--========= SELF =========-->
            <div :ref="item.tokenmessage" :id="item.tokenmessage" class="chat self" v-if="item.tokenuser === token && tokenrooomSelect === item.tokenroom">
              <v-layout align-center justify-end row v-if="item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task'">
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
                  <p class="boxself_unsend">
                    {{$t('ChatSide.system.self.cancelMsg')}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
                  <p class="boxself_unsend">
                    {{item.message}}
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
                  <p class="boxself_system" v-if="item.message === 'active'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    {{$t('ChatSide.system.self.joinGroup')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message === 'kick'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.default.kickMemberGroup', { name_active: item.nickname, name_passive: item.file_name})}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message === 'invite'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} เชิญ {{item.file_name}} -->
                    {{$t('ChatSide.system.default.inviteMemberGroup', { name_active: item.nickname, name_passive: item.file_name})}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message === 'leave'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- คุณออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.self.leftGroup')}}
                  </p>
                </v-flex>
                <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'system_action_albums'">
                  <p class="boxself_system" v-if="item.message == 'edit_name_albums'">
                    <!-- คุณแก้ไขชื่ออัลบั้ม -->
                    {{$t('ChatSide.system.self.editNameAlbum')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'create_albums'">
                    <!-- คุณสร้างอัลบั้ม {{ item.albums_name}} -->
                    {{$t('ChatSide.system.self.createAlbum', { name: item.albums_name})}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'delete_albums'">
                    <!-- คุณลบอัลบั้ม -->
                    {{$t('ChatSide.system.self.deleteAlbum')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'delete_images_albums'">
                    <!-- คุณลบรูปภาพในอัลบั้ม -->
                    {{$t('ChatSide.system.self.deleteImageAlbum')}}
                  </p>
                </v-flex>
                <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'system_action_task'">
                  <p class="boxself_system" v-if="item.message == 'edit_task'">
                    {{$t('ChatSide.system.self.editTask')}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'create_project'">
                    {{$t('ChatSide.system.self.editTask')}}
                  </p>
                </v-flex>
              </v-layout>
              <v-layout align-center justify-end row v-else style="margin-bottom: 15px; margin-top: 15px;">
                <v-flex xs10 style="float: right;">
                  <v-layout row wrap align-end style="float: right;">
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px; display: none;" v-if="item.typeofmessage == 'albums_message' && item.image_add.length == 0">{{timeMoment(item.timestamp)}} </span>
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px;" v-else>{{timeMoment(item.timestamp)}} </span>
                    <!-- message -->
                    <!-- <p slot="activator" v-if="item.typeofmessage === 'message'" style="height: 100%;" class="chat_self" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
                    </p> -->
                    <div slot="activator" v-if="item.typeofmessage === 'message'" class="chat_self">
                      <p style="margin: 0 !important;"  v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
                      </p>
                      <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
                        <link-prevue :url="x">
                          <template slot-scope="props">
                            <!-- {{props}} -->
                            <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                              <v-flex xl3 lg3 md3 sm3 class="border_website">
                                <p class="title_website" >{{props.title}}</p>
                                <span class="description_website">{{props.description}}</span>
                              </v-flex>
                              <v-flex xl9 lg9 md9 sm9 class="centerimg_website">
                                <img class="img_website" :src="props.img"  v-if="props.img">
                              </v-flex>
                            </v-layout>
                          </template>
                          <template slot="loading">
                            <span></span>
                          </template>
                        </link-prevue>
                      </div>
                    </div>
                    <!-- type mention_message -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="chat_self" >
                      <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                        <v-flex xs1>
                          <v-avatar>
                            <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                            <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                          </v-avatar>
                        </v-flex>
                        <v-flex xs11 style="padding-left: 40px;">
                          <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                            <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                            <span >{{item.source_message.message}}</span>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span v-if="item.source_message.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                              <span v-else>{{$t('ChatSide.sticker')}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span>{{$t('ChatSide.file')}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                              <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'video'">
                            <v-flex xs12>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <video width="100" height="100" controls style="justify-content: center; align-items: center;">
                                <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                              </video>
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                              <span v-else>{{item.source_message.message}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="padding-bottom: 10px;" v-else>
                        <span>{{$t('ChatSide.noMsg')}}</span>
                      </v-layout>
                      <v-divider></v-divider>
                      <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                    </p>
                    <!-- type task -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="" @click="">
                      <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                        <v-layout style="text-align: left;">
                          <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs11 sm11 md11 lg11 xl11>
                            <v-layout column wrap>
                              <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                              <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                        <v-layout column wrap align-start>
                          <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                          <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                          <div style="margin-bottom: 5px; text-align: left;">
                            <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                              <v-avatar left color="#2662af" >
                                <img v-if="profile" :src="profile" class="alligator-turtle">
                                <span v-else style="color: white;">{{name[0]}}</span>
                              </v-avatar>
                              <span class="test-overflow-chip">{{name}}</span>
                            </v-chip>
                            <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                              <v-avatar left color="#2662af" >
                                <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                                <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                              </v-avatar>
                              <span class="test-overflow-chip">{{assign.nickname}}</span>
                            </v-chip>
                            <v-chip label color="#e6ecf3" outline text-color="#3a506d">
                              {{item.task_info.state.name}}
                            </v-chip>
                          </div>
                        </v-layout>
                        <v-card-actions style="padding-left: 0px !important;">
                          <span style=" color: #6981a1 !important;">
                            {{$t('ChatSide.Task.viewDetail')}}
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                        </v-card-actions>
                      </v-card>
                    </p>

                    <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="" @click="">
                     <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                       <v-layout style="text-align: left;">
                         <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs11 sm11 md11 lg11 xl11>
                           <v-layout column wrap>
                             <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                             <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                           </v-layout>
                         </v-flex>
                       </v-layout>
                       <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                       <v-layout column wrap align-start>
                         <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                         <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                         <div style="margin-bottom: 5px; text-align: left;">
                           <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                             <v-avatar left color="#2662af" >
                               <img v-if="profile" :src="profile" class="alligator-turtle">
                               <span v-else style="color: white;">{{name[0]}}</span>
                             </v-avatar>
                             <span class="test-overflow-chip">{{name}}</span>
                           </v-chip>
                           <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                             <v-avatar left color="#2662af" >
                               <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                               <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                             </v-avatar>
                             <span class="test-overflow-chip">{{assign.nickname}}</span>
                           </v-chip>
                         </div>
                       </v-layout>
                       <v-card-actions style="padding-left: 0px !important;">
                         <span style=" color: #6981a1 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                         <v-spacer></v-spacer>
                         <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                       </v-card-actions>
                     </v-card>
                   </p>
                    <!-- type image -->
                    <p v-else-if="item.typeofmessage === 'image'" style="width:500px;" class="boxselfimage">
                      <v-img :src="item.message" height="200px" style="border-radius: 10px;"></v-img>
                    </p>
                    <!-- type sticker -->
                    <p v-else-if="item.typeofmessage === 'sticker'" style="margin-top: 0; height: 100%;" >
                      <img :src="item.file_name" class="boxselfsticker">
                    </p>
                    <!-- type web -->
                    <div v-else-if="item.typeofmessage === 'web'" style="width:500px;" class="boxselffile" >
                      <iframe height="400" style="visibility:visible; max-width: 55vw !important;" frameborder='0' :src="item.message" ></iframe>
                    </div>
                    <!-- type note -->
                    <div v-else-if="item.typeofmessage === 'note'" style="font-weight: 500; width: 200px !important; margin-bottom: 10px;" class="chat_self">
                       <p class="textchat" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" style=" color: #5a616b !important;"></p>
                       <p v-if="item.message.length ==20"> ...</p>
                       <v-divider></v-divider>
                        <span style=" color: #5a616b !important;"> {{$t('ChatSide.note')}} </span>
                        <v-icon style=" color: #5a616b !important;   right: 0;position: absolute;">navigate_next </v-icon>
                    </div>
                    <!-- type contact -->
                    <v-layout v-else-if="item.typeofmessage === 'contact'" row align-center justify-start class="chat_selfcontact" style="font-weight: 500; margin-top: 15px;">
                      <v-flex xs5 md5 sm5>
                        <v-layout align-center justify-center row wrap>
                          <v-avatar size="40px" class="user-photo" >
                            <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                            <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                            <img v-else-if="item.type_contact === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                            <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                            <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                          </v-avatar>
                        </v-layout>
                      </v-flex>
                      <v-flex xs5 md5 sm5>
                        <v-layout align-center justify-center row wrap style="margin-top: 12px;">
                          <p class="text2">{{item.nickname_contact}}</p>
                        </v-layout>
                      </v-flex>
                      <v-flex xs2 md2 sm2>
                        <v-layout align-center justify-end row wrap>
                          <v-icon>navigate_next </v-icon>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- type video -->
                    <p v-else-if="item.typeofmessage === 'video'"  style="width:500px; cursor: pointer;" class="boxselffile" >
                      <v-flex xs12 v-if="extension(item.message) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <video width="180" height="130" controls>
                          <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </video>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <audio controls>
                          <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </audio>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <div style="width: 100%; height: 130px; justify-content: center; align-items: center;">
                          <vplayer
                            style="height: 130px !important;"
                            :playerOptions="{
                              type: 'application/x-mpegURL',
                              src: item.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }"
                            @onplay="play"
                          />
                        </div>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message">
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <v-btn flat icon color="white" @click="loadfile(item)" :disabled="statemember !== 'active'">
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn>
                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)">
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <!-- type file -->
                    <p v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf')"  style="width:500px;" class="boxselffile" >
                        <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center;">
                          <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                            <pdf
                            :src="item.message"
                            :page="1"
                            ref="myPdfComponent"
                            @password="passwordPdf($event, i, item)"
                            @error="errorPdf"
                            >
                            </pdf>
                          </v-card-media>
                        </v-flex>
                        <v-flex xs12 v-else-if="extension(item.file_name) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <video width="200" height="130" controls>
                          <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </video>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <audio controls>
                          <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </audio>
                      </v-flex>
                        <v-flex xs12 v-else>
                          <v-icon style="color: white !important; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh; color: white;">{{extension(item.file_name)}}</v-icon>
                        </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <v-btn flat icon color="white" @click="loadfile(item)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn>
                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <p v-else-if="item.typeofmessage === 'file'" class="boxselffile" style="width:500px;">
                      <v-flex xs12>
                        <v-icon style="color: white; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <v-btn flat icon color="white" @click="loadfile(item)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn>
                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <!-- pdf password กรณีที่ไฟล์ pdf มีรหัสแล้วไม่สามารถ preview ได้ -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'pdf_password'" style="width:500px; cursor: pointer;" class="boxselffile">
                      <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center; cursor: pointer;">
                        <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                          <pdf
                          src="https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf"
                          :page="1"
                          ref="myPdfComponent"
                          >
                          </pdf>
                        </v-card-media>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                    </p>
                    <!-- type location -->
                    <p v-else-if="item.typeofmessage === 'location'" style="width: 180px;margin-top: 15px;">
                     <v-card style="background-color: #b4d1f5; border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" class="white--text">
                        <v-layout style="text-align: left;" raw wrap>
                          <v-flex xs2 sm2 md2>
                            <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                          </v-flex>
                          <v-flex xs10 sm10 md10 style="color: black; padding-left: 5px;">
                            <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                            <span v-else>  {{$t('ChatSide.location')}}</span>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </p>
                    <!-- type date -->
                    <p v-else-if="item.typeofmessage=='date'" class="chat_self"><v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}</p>
                    <!-- type datetime -->
                    <p v-else-if="item.typeofmessage=='datetime'" class="chat_self"><v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}<br>
                    <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; {{item.message.split('T')[1]}}</p>
                    <!-- type call -->
                    <p v-else-if="item.typeofmessage === 'call'" class="chat_self" style="text-align: center;width: 100px;">
                      <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='decline'">phone</v-icon>
                      <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                      <br>
                      <span v-if="item.message =='cancel' || item.message =='decline'">
                        {{checktypeCall(item.message)}}
                      </span>
                      <span v-else>{{secondsToHms(item.time_count)}}</span>
                    </p>
                    <!-- type conference -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'conference_msg'" class="chat_self" style="text-align: center;font-weight: 500 !important;">
                      <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#4065b4;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
                      <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#4065b4;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
                      <br>
                      <v-btn class="joinBtn" disabled>{{$t('ChatSide.conference.joinCall')}} </v-btn>
                    </div>

                    <!-- call agora -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'agora_call'" class="chat_self" style="text-align: center; font-weight: 500 !important;">
                      <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
                      <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                      <br>
                      <span v-if="item.message =='cancel'">
                        {{checktypeCall(item.message)}}
                      </span>
                      <span v-else>{{item.time}}</span>
                    </div>
                    <!-- type albums_message -->
                    <div v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0" style="width: 180px; display: none;" class="chat_self_createablums">
                      <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                      <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                      <v-layout row wrap justify-center align-center>
                        <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                      </v-layout>
                      <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', { count: item.image_add.length })}}</p>
                      <v-divider></v-divider>
                      <v-layout row wrap justify-center align-center class="mt-2">
                        <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                        <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                        <v-spacer></v-spacer>
                        <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                      </v-layout>
                    </div>

                    <div v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length !== 0" style="width: 180px;" class="chat_self_createablums">
                      <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                      <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                      <v-layout row wrap justify-center align-center>
                        <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                      </v-layout>
                      <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', { count: item.image_add.length })}}</p>
                      <v-divider></v-divider>
                      <v-layout row wrap justify-center align-center class="mt-2">
                        <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                        <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                        <v-spacer></v-spacer>
                        <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                      </v-layout>
                    </div>
                    <!-- type official_template -->
                    <div v-else-if="item.typeofmessage === 'official_template'" class="chat_self" style="overflow: hidden;display: -webkit-inline-box; background: none; ">
                      <div>
                        <!-- width: 150px;  -->
                        <v-card style="border-radius: 10px;margin-right: 10px;background: #b4d1f5 !important;">
                          <h3 class="mb-0" style="color: #2562af;padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>

                          <v-img :src="item.element.image" v-if="item.element.image" style="height: 120px;" contain></v-img>
                          <v-card-title primary-title style="padding-top: 15px !important;">
                            <div style="width: 150px;">
                              <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="20" style="color:#343433;"></read-more>
                              <v-divider light v-if="!item.element.image"></v-divider>
                              <div v-for="(choice, index) in item.element.choice">
                                <v-btn flat disabled style="text-transform: none; width: 100%;margin: 0;font-size: 13px; border-radius: 20px;">
                                  {{choice.label}}
                                </v-btn>
                              </div>
                            </div>
                          </v-card-title>
                        </v-card>
                      </div>
                    </div>
                    <!-- no type -->
                    <p v-else class="chat_self">
                      {{$t('ChatSide.notSupportVersion')}}
                    </p>
                  </v-layout>
                </v-flex>
                <v-flex xs2>
                  <v-checkbox v-model="selectedmessage" :value="item.tokenmessage" v-if="item.typeofmessage == 'message' || item.typeofmessage == 'image' || item.typeofmessage == 'file' || item.typeofmessage == 'pdf_password' || item.typeofmessage == 'location' || item.typeofmessage == 'video'" style="float: right;"></v-checkbox>
                  <v-checkbox v-else-if="item.typeofmessage == 'albums_message' && item.image_add.length === 0" style="float: right; display: none;"></v-checkbox>
                  <v-checkbox v-else disabled style="float: right;"></v-checkbox>
                </v-flex>
              </v-layout>
            </div>
            <!--========= OTHER ========-->
            <div :ref="item.tokenmessage" :id="item.tokenmessage" class="chat other" v-if="item.tokenuser !== token && tokenrooomSelect === item.tokenroom" style="margin-bottom: 10px;">
              <v-layout align-center row wrap v-if="item.typeofmessage === 'unsend_message' || item.typeofmessage === 'system_action' || item.typeofmessage === 'system' || item.typeofmessage === 'system_action_albums' || item.typeofmessage === 'system_action_task'">
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
                  <v-layout justify-center>
                    <p class="boxother_unsend">
                      <!-- {{item.nickname}} ยกเลิกข้อความ -->
                      {{$t('ChatSide.system.other.cancelMsg', { name: item.nickname })}}
                    </p>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
                  <v-layout justify-center>
                    <p class="boxother_unsend">
                      {{item.message}}
                    </p>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding-right: 0px; margin-top: 25px; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
                  <p class="boxother_system" v-if="item.message === 'active'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} เข้าร่วมกลุ่ม. -->
                    {{$t('ChatSide.system.other.joinGroup', { name: item.nickname })}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message === 'kick'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.default.kickMemberGroup', { name_active: item.nickname, name_passive: item.file_name })}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message === 'invite'">
                    <span>{{timeMoment(item.timestamp)}}</span>
                    <br>
                    <!-- {{item.nickname}} เชิญ {{item.file_name}} -->
                    {{$t('ChatSide.system.default.inviteMemberGroup', { name_active: item.nickname, name_passive: item.file_name })}}
                  </p>
                  <p class="boxother_system" v-else-if="item.message === 'leave'">
                    <span>{{timeMoment(item.timestamp)}} </span>
                    <br>
                    <!-- {{item.nickname}} ออกจากกลุ่ม. -->
                    {{$t('ChatSide.system.other.leftGroup', { name: item.nickname })}}
                  </p>
                </v-flex>
                <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'system_action_albums'">
                  <p class="boxself_system" v-if="item.message == 'edit_name_albums'">
                    <!-- {{item.nickname}} แก้ไขชื่ออัลบั้ม -->
                    {{$t('ChatSide.system.other.editNameAlbum', { name: item.nickname })}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'create_albums'">
                    <!-- {{item.nickname}} สร้างอัลบั้ม {{ item.albums_name}} -->
                    {{$t('ChatSide.system.other.createAlbum', { name: item.nickname, album_name: item.albums_name })}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'delete_albums'">
                    <!-- {{item.nickname}} ลบอัลบั้ม -->
                    {{$t('ChatSide.system.other.deleteAlbum', { name: item.nickname })}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'delete_images_albums'">
                    <!-- {{item.nickname}} ลบรูปภาพในอัลบั้ม -->
                    {{$t('ChatSide.system.other.deleteImageAlbum', { name: item.nickname })}}
                  </p>
                </v-flex>
                <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 1vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'system_action_task'">
                  <p class="boxself_system" v-if="item.message == 'edit_task'">
                    {{$t('ChatSide.system.other.editTask', {name: item.nickname})}}
                  </p>
                  <p class="boxself_system" v-else-if="item.message == 'create_project'">
                    {{$t('ChatSide.system.other.editTask', {name: item.nickname})}}
                  </p>
                </v-flex>
              </v-layout>
              <v-layout justify-start row v-else style="margin-top: 15px;">
                <v-flex xs1 style="padding-right: 10px;" v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system'">
                  <div v-if="item.typeofmessage == 'albums_message' && item.image_add.length == 0" style="display: none;">
                    <v-avatar size="40px" class="user-photo" v-if="item.path_pic !== ''">
                      <img :src="item.path_pic" class="alligator-turtle">
                    </v-avatar>
                    <v-avatar size="40px" class="user-photo" v-else>
                      <img src='/static/img/default_profile/man-white.png' v-if="item.type === 'user'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/bot-white.png' v-else-if="item.type === 'bot'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/business-white.png' v-else-if="item.type === 'company'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/business-white.png' v-else-if="item.type === 'government'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" v-else/>
                    </v-avatar>
                  </div>
                  <div v-else>
                    <v-avatar size="40px" class="user-photo" v-if="item.path_pic !== ''">
                      <img :src="item.path_pic" class="alligator-turtle">
                    </v-avatar>
                    <v-avatar size="40px" class="user-photo" v-else>
                      <img src='/static/img/default_profile/man-white.png' v-if="item.type === 'user'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/bot-white.png' v-else-if="item.type === 'bot'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/business-white.png' v-else-if="item.type === 'company'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/business-white.png' v-else-if="item.type === 'government'" class="alligator-turtle"/>
                      <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" v-else/>
                    </v-avatar>
                  </div>
                </v-flex>
                <v-flex xs10 style="float: left;">
                  <v-layout row wrap align-end style="float: left; padding-left: 0px;">
                    <!-- message -->
                    <!-- <p v-if="item.typeofmessage === 'message'" style="height: 100%;" class="chat_other" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
                    </p> -->
                    <div slot="activator" v-if="item.typeofmessage === 'message'" class="chat_other">
                      <p style="margin: 0 !important;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
                      </p>
                      <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
                        <link-prevue :url="x">
                          <template slot-scope="props">
                            <!-- {{props}} -->
                            <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                              <v-flex xl3 lg3 md3 sm3 class="border_website">
                                <p class="title_website" >{{props.title}}</p>
                                <span class="description_website">{{props.description}}</span>
                              </v-flex>
                              <v-flex xl9 lg9 md9 sm9 class="centerimg_website">
                                <img class="img_website" :src="props.img"  v-if="props.img">
                              </v-flex>
                            </v-layout>
                          </template>
                          <template slot="loading">
                            <span></span>
                          </template>
                        </link-prevue>
                      </div>
                    </div>
                    <!-- image -->
                    <p v-else-if="item.typeofmessage === 'image'" style="width:500px;" class="boxfriendimage">
                      <v-img :src="item.message" height="200px" style="border-radius: 10px;"></v-img>
                    </p>
                    <!-- type question_detail -->
                    <!-- <p slot="activator" v-else-if="item.typeofmessage === 'template'">
                      <v-layout style="width: 200px;" class="scrolling-wrapper-template">
                        <v-layout row wrap>
                          <v-flex
                            v-for="(infoans, index) in item.info_ans"
                            :key="index"
                            v-bind="{ [`xs${12}`]: true }"
                            style="padding-right: 20px;"
                          >
                            <v-card style="border-radius: 15px; width: 170px;">
                              <v-container
                                fill-height
                                fluid
                                pa-2
                              >
                                <v-layout column wrap justify-center align-center>
                                  <v-flex xs12 align-start flexbox style="word-break: break-all;">
                                    <v-card-media v-if="infoans.image" :src="infoans.image" height="75px"></v-card-media>
                                    <h4 style="color: #2562ae;" v-if="selected === false">{{infoans.title}}</h4>
                                    <h4 style="color: #61666d;" v-else>{{infoans.title}}</h4>
                                    <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(infoans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="50" style="margin-bottom: 0px !important;"></read-more>
                                    <br v-if="!infoans.image">
                                    <v-divider light v-if="!infoans.image"></v-divider>
                                  </v-flex>
                                  <v-flex xs12 align-start flexbox v-for="(question, index) in infoans.choice" :key="index">
                                    <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'text' && selected === false" style="text-transform: none;">
                                      <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>
                                    <v-btn disabled flat color="primary"  v-if="question.type === 'text' && selected === true" style="text-transform: none;">
                                      <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>

                                    <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'link' && selected === false" style="text-transform: none;">
                                      <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>
                                    <v-btn disabled flat color="primary"  v-if="question.type === 'link' && selected === true"  style="text-transform: none;">
                                      <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>

                                    <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'file' && selected === false" style="text-transform: none;"><v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp;{{question.label}}</v-btn>
                                    <v-btn disabled flat color="primary" v-if="question.type === 'file' && selected === true" style="text-transform: none;"><v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp;
                                      <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>

                                    <v-btn
                                      style="text-transform: none;"
                                      slot="activator"
                                      v-if="question.type === 'webview' && selected === false" flat color="primary"
                                      @click="ans_question(question, item.tokenmessage, item.tokenuser)"
                                    >
                                    <span class="span-trext-overflow">{{question.label}}</span>
                                    </v-btn>
                                    <v-btn
                                      disabled
                                      style="text-transform: none;"
                                      slot="activator"
                                      v-if="question.type === 'webview' && selected === true" flat color="primary"
                                    >
                                    <p style="word-break: break-all; width: 120px;" class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>

                                    <v-btn flat color="primary" @click="ans_question(question, item.tokenmessage, item.tokenuser)" v-if="question.type === 'ekyc' && selected === false" style="text-transform: none;">
                                      <p class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>
                                    <v-btn disabled flat color="primary" v-if="question.type === 'ekyc' && selected === true" style="text-transform: none;">
                                      <p class="mb-0" v-html="convert(question.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                          </v-flex>
                        </v-layout>
                    </v-layout>
                    </p> -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'template'" class="boxfriendquestion scrolling-wrapper-template" style="overflow-x: scroll;overflow-y: hidden;display: flex; background: none; width: 275px; padding: 10px; align-items: end;">
                      <!-- -webkit-inline-box -->
                      <div v-for="(info_ans, index) in item.info_ans">
                        <!-- หลาย template -->
                        <v-card style="border-radius: 10px; width: 200px;margin-right: 10px;" >
                          <!-- class="height-template" -->
                          <v-img :src="info_ans.image" aspect-ratio="2.75" v-if="info_ans.image" style="height: 120px;"></v-img>
                          <v-card-title primary-title style="padding-top: 15px !important;">
                            <div style="width: 176px;">
                              <h3 class="mb-0" style="color: #2562ae;">{{info_ans.title}}</h3>
                              <!-- <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="50" style="margin-bottom: 0px !important;"></read-more> -->
                              <p style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;" class="mb-0" v-html="convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                              <a v-if="info_ans.detail.length >= 40" @click="clickReadmore(info_ans)"><b>{{$t('ChatSide.Read.readmore')}}</b></a>
                              <v-divider light v-if="!info_ans.image" class="mt-2"></v-divider>
                              <!-- <div style="bottom: 7px; position: absolute; width: 85%;"> -->
                                <div v-for="(choice, index) in info_ans.choice">
                                  <v-btn disabled block v-if="choice.type=='file'" flat color="primary" style="text-transform: none; width: 100%;margin: 0; font-size: 13px;" @click="ans_question(choice, item.tokenmessage, item.tokenuser)">
                                    <v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp; <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                  <v-btn disabled v-else flat color="primary" style="text-transform: none; width: 100%;margin: 0;font-size: 13px;" @click="ans_question(choice, item.tokenmessage, item.tokenuser)">
                                    <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                  </v-btn>
                                </div>
                              <!-- </div> -->
                            </div>
                          </v-card-title>
                        </v-card>
                      </div>
                    </div>

                    <!-- type mention_message -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="chat_other" >
                      <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                        <v-flex xs1>
                          <v-avatar>
                            <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                            <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                          </v-avatar>
                        </v-flex>
                        <v-flex xs11 style="padding-left: 40px;">
                          <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                            <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                            <span > {{item.source_message.message}}</span>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span v-if="item.source_message.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                              <span v-else>{{$t('ChatSide.sticker')}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span>{{$t('ChatSide.file')}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                              <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'video'">
                            <v-flex xs12>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <video width="100" height="100" controls style="justify-content: center; align-items: center;">
                                <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                              </video>
                            </v-flex>
                          </v-layout>
                          <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                            <v-flex xs8>
                              <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                              <br>
                              <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                              <span v-else>{{item.source_message.message}}</span>
                            </v-flex>
                            <v-flex xs4>
                              <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="padding-bottom: 10px;" v-else>
                        <span>{{$t('ChatSide.noMsg')}}</span>
                      </v-layout>
                      <v-divider></v-divider>
                      <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                    </p>
                    <!-- type task_message -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="" @click="">
                      <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                        <v-layout style="text-align: left;">
                          <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                          </v-flex>
                          <v-flex xs11 sm11 md11 lg11 xl11>
                            <v-layout column wrap>
                              <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                              <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                        <v-layout column wrap align-start>
                          <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                          <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                          <div style="margin-bottom: 5px; text-align: left;">
                            <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                              <v-avatar left color="#2662af" >
                                <img v-if="profile" :src="profile" class="alligator-turtle">
                                <span v-else style="color: white;">{{name[0]}}</span>
                              </v-avatar>
                              <span class="test-overflow-chip">{{name}}</span>
                            </v-chip>
                            <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                              <v-avatar left color="#2662af" >
                                <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                                <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                              </v-avatar>
                              <span class="test-overflow-chip">{{assign.nickname}}</span>
                            </v-chip>
                            <v-chip label color="#dcd9d9" outline text-color="#3a506d">
                              {{item.task_info.state.name}}
                            </v-chip>
                          </div>
                        </v-layout>
                        <v-card-actions style="padding-left: 0px !important;">
                          <span style=" color: #818181 !important;">
                            {{$t('ChatSide.Task.viewDetail')}}
                          </span>
                          <v-spacer></v-spacer>
                          <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                        </v-card-actions>
                      </v-card>
                    </p>

                    <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="" @click="">
                     <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                       <v-layout style="text-align: left;">
                         <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                         </v-flex>
                         <v-flex xs11 sm11 md11 lg11 xl11>
                           <v-layout column wrap>
                             <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                             <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                           </v-layout>
                         </v-flex>
                       </v-layout>
                       <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                       <v-layout column wrap align-start>
                         <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                         <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                         <div style="margin-bottom: 5px; text-align: left;">
                           <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                             <v-avatar left color="#2662af" >
                               <img v-if="profile" :src="profile" class="alligator-turtle">
                               <span v-else style="color: white;">{{name[0]}}</span>
                             </v-avatar>
                             <span class="test-overflow-chip">{{name}}</span>
                           </v-chip>
                           <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                             <v-avatar left color="#2662af" >
                               <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                               <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                             </v-avatar>
                             <span class="test-overflow-chip">{{assign.nickname}}</span>
                           </v-chip>
                         </div>
                       </v-layout>
                       <v-card-actions style="padding-left: 0px !important;">
                         <span style=" color: #818181 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                         <v-spacer></v-spacer>
                         <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                       </v-card-actions>
                     </v-card>
                   </p>
                    <!-- type approve_message -->
                    <p v-else-if="item.typeofmessage === 'approve_message' && item.disable === 'false' && selected === false" style="width: 150px;">
                      <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 145px;" class="white--text">
                        <v-layout>
                          <v-flex xs12 sm12 md12>
                            <h3 style="color: #2562ae !important;">{{item.info_ans[0].title}}</h3>
                            <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                          </v-flex>
                        </v-layout>
                        <v-divider light></v-divider>
                        <v-card-actions>
                        <span style=" color: #2562ae !important;"> {{$t('ChatSide.approve_message.viewDetail')}} </span>
                        <v-spacer></v-spacer>
                        <v-icon style=" color: #2562ae !important;   right: 0;position: absolute;">navigate_next </v-icon>
                        </v-card-actions>
                      </v-card>
                    </p>
                    <p v-else-if="item.typeofmessage === 'approve_message' && item.disable === 'true' && selected === false" style="width: 150px;">
                      <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 145px;" class="white--text">
                        <v-layout>
                          <v-flex xs12 sm12 md12>
                            <h3 style="color: #757575 !important;">{{item.info_ans[0].title}}</h3>
                            <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                          </v-flex>
                        </v-layout>
                        <v-divider light></v-divider>
                        <v-card-actions>
                        <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.receiveAns')}} </span>
                        </v-card-actions>
                      </v-card>
                    </p>
                    <p v-else-if="item.typeofmessage === 'approve_message' && selected === true" style="width: 150px;">
                      <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 145px;" class="white--text">
                        <v-layout>
                          <v-flex xs12 sm12 md12>
                            <h3 style="color: #757575 !important;">{{item.info_ans[0].title}}</h3>
                            <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                          </v-flex>
                        </v-layout>
                        <v-divider light></v-divider>
                        <v-card-actions v-if="item.disable === 'false'">
                        <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.viewDetail')}} </span>
                        <v-spacer></v-spacer>
                        <v-icon style=" color: #757575 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                        </v-card-actions>
                        <v-card-actions v-else>
                        <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.receiveAns')}} </span>
                        </v-card-actions>
                      </v-card>
                    </p>
                    <!-- type official_template -->
                    <div v-else-if="item.typeofmessage === 'official_template'" class="chat_other" style="overflow: hidden;display: -webkit-inline-box; background: none; ">
                      <div>
                        <!-- width: 150px;  -->
                        <v-card style="border-radius: 10px;margin-right: 10px;background: #efefef !important;">
                          <h3 class="mb-0" style="color: #2562af;padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>

                          <v-img :src="item.element.image" v-if="item.element.image" style="height: 120px;" contain></v-img>
                          <v-card-title primary-title style="padding-top: 15px !important;">
                            <div style="width: 150px;">
                              <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="20" style="color:#343433;"></read-more>
                              <v-divider light v-if="!item.element.image"></v-divider>
                              <div v-for="(choice, index) in item.element.choice">
                                <v-btn flat disabled style="text-transform: none; width: 100%;margin: 0;font-size: 13px; border-radius: 20px;">
                                  {{choice.label}}
                                </v-btn>
                              </div>
                            </div>
                          </v-card-title>
                        </v-card>
                      </div>
                    </div>
                    <!-- type date -->
                    <p v-else-if="item.typeofmessage == 'date'" class="chat_other"><v-icon style="font-size: 18px; color: #4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
                    </p>
                    <!-- type datetime -->
                    <p v-else-if="item.typeofmessage == 'datetime'" class="chat_other"><v-icon style="font-size: 18px; color: #4065b4;"> far fa-calendar-alt</v-icon> &nbsp;{{momentday(item.message)}}<br>
                      <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; {{item.message.split('T')[1]}}
                    </p>
                    <!-- type web -->
                    <div v-else-if="item.typeofmessage == 'web'" class="boxfriendfile" style="width: 500px;">
                      <iframe height="400" style="visibility:visible; max-width: 55vw !important;" frameborder='0' :src="item.message" ></iframe>
                    </div>
                    <!-- type note -->
                    <div v-else-if="item.typeofmessage === 'note'" style="font-weight: 500; width: 200px !important; margin-bottom: 10px;" class="chat_other">
                      <p class="textchat" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" style=" color: #5a616b !important;"></p>
                      <p v-if="item.message.length == 20"> ...</p>
                      <v-divider></v-divider>
                      <span style=" color: #5a616b !important;"> {{$t('ChatSide.note')}} </span>
                        <v-icon style=" color: #5a616b !important;right: 0;position: absolute;">navigate_next </v-icon>
                    </div>
                    <!-- type sticker -->
                    <p v-else-if="item.typeofmessage === 'sticker'" style="margin-top: 0; height: 100%;">
                      <img :src="item.file_name" class="boxfriendsticker">
                    </p>
                    <!-- type video -->
                    <p v-else-if="item.typeofmessage === 'video'"  style="width:500px;" class="boxfriendfile">
                      <v-flex xs12 v-if="extension(item.message) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <video width="180" height="130" controls>
                          <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </video>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <audio controls>
                          <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </audio>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <div style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                          <vplayer
                            style="height: 150px !important;"
                            :playerOptions="{
                              type: 'application/x-mpegURL',
                              src: item.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }"
                            @onplay="play"
                          />
                        </div>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <v-btn flat icon color="white" @click="loadfile(item)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn>
                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <!-- type file -->
                    <p v-else-if="item.typeofmessage === 'file' && (extension(item.file_name)) === 'pdf'"  style="width:500px;" class="boxfriendfile">
                        <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center;">
                          <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                            <pdf
                            :src="item.message"
                            :page="1"
                            ref="myPdfComponent"
                            @password="passwordPdf($event, i, item)"
                            @error="errorPdf"
                            >
                            </pdf>
                          </v-card-media>
                        </v-flex>
                        <v-flex xs12 v-else-if="extension(item.message) === 'media'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <video width="200" height="130" controls>
                          <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </video>
                      </v-flex>
                      <v-flex xs12 v-else-if="extension(item.file_name) === 'audio'" style="margin-top: 1vh; display: flex; justify-content: center;">
                        <audio controls>
                          <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                        </audio>
                      </v-flex>
                        <v-flex xs12 v-else>
                          <v-icon style="color: white !important; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon>
                        </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions v-if="extension(item.file_name) !== 'pdf'">
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <v-btn flat icon color="white" @click="loadfile(item)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn>
                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <p v-else-if="item.typeofmessage === 'file' || item.typeofmessage === 'password_file' " class="boxfriendfile" style="width:500px;">
                      <v-flex xs12>
                        <v-icon v-if="extension(item.file_name) === 'pdf'" style="color: white; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">fas fa-file-pdf</v-icon>
                      <v-icon v-else style="color: white; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon>
                        <!-- <v-icon style="color: white; font-size: 60px !important; display: flex; justify-content: center; margin-top: 1vh;">{{extension(item.file_name)}}</v-icon> -->
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions>
                                      <v-icon dark v-if="item.typeofmessage == 'password_file'">mdi-lock</v-icon>
                        <v-spacer></v-spacer>
                        <!-- <v-btn flat icon color="blue" :href="item.message" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">file_download</v-icon>
                        </v-btn> -->
                        <v-btn flat icon color="white" @click="loadfile(item)" disabled>
                          <v-icon v-if="extension(item.file_name) == 'pdf'">visibility</v-icon>
                          <v-icon v-else>file_download</v-icon>
                        </v-btn>
                         <v-btn flat icon color="blue" @click="sendimgonebox(item.tokenmessage)" disabled>
                          <v-icon style="color: inherit; font-size: 25px !important;">cloud_upload</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </p>
                    <!-- pdf password กรณีที่ไฟล์ pdf มีรหัสแล้วไม่สามารถ preview ได้ -->
                    <p slot="activator" v-else-if="item.typeofmessage === 'pdf_password'" style="width:500px; cursor: pointer;" class="boxfriendfile">
                      <v-flex xs12 v-if="extension(item.file_name) === 'pdf'" style="display: flex; justify-content: center; cursor: pointer;">
                        <v-card-media height="70px" style="width: 45vw; border-radius: 10px;">
                          <pdf
                          src="https://testchat.one.th/alpine/api/v1/file/J0CDcdbm1zUba7cb86c384f5fa5b3eae7269b4993ce_2022-08-17_18:29:28:894891.pdf"
                          :page="1"
                          ref="myPdfComponent"
                          >
                          </pdf>
                        </v-card-media>
                      </v-flex>
                      <v-card-title primary-title>
                        <div>
                          <div style="text-align:left; word-break: break-all !important; font-size:12px; color: white !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                    </p>
                    <!-- type location -->
                    <p v-else-if="item.typeofmessage === 'location'" style="width: 180px;" class="">
                      <v-card style="background-color: #efefef; border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" class="white--text">
                        <v-layout style="text-align: left;">
                          <v-flex xs2 sm2 md2>
                            <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                          </v-flex>
                          <v-flex xs10 sm10 md10 style="color: black; padding-left: 5px;">
                            <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                            <span v-else>  {{$t('ChatSide.location')}}</span>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </p>
                    <!-- type contact -->
                    <v-layout slot="activator" v-else-if="item.typeofmessage === 'contact'" row align-center justify-start class="chat_othercontact" style="font-weight: 500;margin-bottom: 15px;">
                      <v-flex xs5 md5 sm5>
                        <v-layout align-center justify-center row wrap>
                          <v-avatar size="40px" class="user-photo" >
                            <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                            <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                            <img v-else-if="item.type_contact === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                            <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                            <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                          </v-avatar>
                        </v-layout>
                      </v-flex>
                      <v-flex xs5 md5 sm5>
                        <v-layout align-center justify-center row wrap style="margin-top: 12px;">
                          <p class="text2">{{item.nickname_contact}}</p>
                        </v-layout>
                      </v-flex>
                      <v-flex xs2 md2 sm2>
                        <v-layout align-center justify-end row wrap>
                          <v-icon>navigate_next </v-icon>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- type call -->
                    <p v-else-if="item.typeofmessage === 'call'" class="chat_other" style="text-align: center;width: 100px;">
                      <v-icon style="font-size: 30px; color:#676767;" v-if="item.message == 'cancel' || item.message == 'decline'">phone</v-icon>
                      <v-icon style="font-size: 30px; color:#676767;" v-else>phone_in_talk</v-icon>
                      <br>
                      <span v-if="item.message == 'cancel' || item.message == 'decline'">
                        {{checktypeCall(item.message)}}
                      </span>
                      <span v-else>{{secondsToHms(item.time_count)}}</span>
                    </p>
                    <!-- type conference -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'conference_msg'" class="chat_other" style="text-align: center;font-weight: 500 !important;">
                      <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#4065b4;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
                      <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#4065b4;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
                      <br>
                      <v-btn class="joinBtn" disabled>{{$t('ChatSide.conference.joinCall')}} </v-btn>
                    </div>

                    <!-- call agora -->
                    <div slot="activator" v-else-if="item.typeofmessage === 'agora_call'" class="chat_other" style="text-align: center; font-weight: 500 !important;">
                      <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
                      <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                      <br>
                      <span v-if="item.message =='cancel'">
                        {{checktypeCall(item.message)}}
                      </span>
                      <span v-else>{{item.time}}</span>
                    </div>
                    <!-- type albums_message -->
                    <div v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0" style="width: 180px; display: none;" class="chat_other_createablums">
                      <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                      <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                      <v-layout row wrap justify-center align-center>
                        <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                      </v-layout>
                      <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', { count: item.image_add.length })}}</p>
                      <v-divider></v-divider>
                      <v-layout row wrap justify-center align-center class="mt-2">
                        <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                        <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                        <v-spacer></v-spacer>
                        <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                      </v-layout>
                    </div>

                    <div v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length !== 0" style="width: 180px;" class="chat_other_createablums">
                      <h3 class="mb-1" v-if="item.message !== 'addimage_albums'">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                      <h3 class="mb-1" v-else>{{$t('ChatSide.Album.insertImageAlbum', { name: item.albums_name })}}</h3>
                      <v-layout row wrap justify-center align-center>
                        <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                      </v-layout>
                      <p class="mt-1 mb-0">{{$t('ChatSide.Album.numberImage', { count: item.image_add.length })}}</p>
                      <v-divider></v-divider>
                      <v-layout row wrap justify-center align-center class="mt-2">
                        <h4 v-if="item.albums_name != ''">{{item.albums_name}}</h4>
                        <h4 v-else>{{dateMoment(item.create_date)}}</h4>
                        <v-spacer></v-spacer>
                        <v-icon color="black" style="font-size: 16px;">fas fa-chevron-right</v-icon>
                      </v-layout>
                    </div>

                    <!-- type carousel -->
                    <div v-else-if="item.typeofmessage === 'carousel'" class="chat_other" style="overflow-x: scroll;overflow-y: hidden; display: -webkit-inline-box; background: none;">
                      <div v-for="(info_carousel, index) in item.elements">
                        <v-card style="border-radius: 20px; width: 200px; margin-right: 10px;">
                          <v-img
                            :src="info_carousel.image"
                            :aspect-ratio="16/9"
                            v-if="info_carousel.image"
                            style="height: 180px; cursor: pointer;"
                          >
                            <v-layout v-if="info_carousel.type !== 'image'" row wrap align-end justify-center style="height: 180px;">
                              <v-btn v-if="info_carousel.button" round color="#0000009c" dark disabled>
                                <span class="text-transform">{{info_carousel.button}}</span>
                              </v-btn>
                            </v-layout>
                          </v-img>
                        </v-card>
                      </div>
                    </div>
                    <!-- no type -->
                    <p v-else slot="activator" class="chat_other" style="color: #757575 !important;" >
                      {{$t('ChatSide.noMsg')}}
                    </p>
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px; display: none;" v-if="item.typeofmessage == 'albums_message' && item.image_add.length == 0">{{timeMoment(item.timestamp)}} </span>
                    <span style="font-size: 10px; color: #616161; margin-bottom: 0px;" v-else>{{timeMoment(item.timestamp)}} </span>
                  </v-layout>
                </v-flex>
                <v-flex xs1>
                  <v-checkbox v-model="selectedmessage" :value="item.tokenmessage" v-if="item.typeofmessage == 'message' || item.typeofmessage == 'image' || item.typeofmessage == 'file' || item.typeofmessage == 'pdf_password' || item.typeofmessage == 'location' || item.typeofmessage == 'video'" style="float: right;"></v-checkbox>
                  <v-checkbox v-else-if="item.typeofmessage == 'albums_message' && item.image_add.length === 0" style="float: right; display: none;"></v-checkbox>
                  <v-checkbox v-else disabled style="float: right;"></v-checkbox>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <!-- quick reply -->
          <v-date-picker v-model="dateselect" v-if="datepicker" :max="maxdate" :min="mindate" :landscape="landscape">
            <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="datepicker = false">{{$t('AnswerQuestion.cancel')}}</v-btn>
              <v-btn flat color="primary" @click="senddate()">{{$t('AnswerQuestion.ok')}}</v-btn>
          </v-date-picker>

          <v-time-picker v-model="timeselect" :max="maxtime" :min="mintime" v-if="timepicker" format="24hr" :landscape="landscape">
               <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="timepicker = false">{{$t('AnswerQuestion.cancel')}}</v-btn>
                <v-btn flat color="primary" @click="sendtime()">{{$t('AnswerQuestion.ok')}}</v-btn>
          </v-time-picker>

          <div class="scrolling-wrapper" v-if="selected === false">
            <a v-for="(item,index) in Quickreply.quick_reply" :key="index" style="">
              <v-btn v-if="item.type == 'text'" round small class="quick_reply" @click="ans_quickreply(item, 'text')"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn v-if="item.type == 'datepicker' || item.type == 'datetimepicker'" round small class="quick_reply" @click="setpicker(item)"><v-icon style="font-size: 12px;">fas fa-calendar-alt</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn v-if="item.type == 'link'" round small class="quick_reply" @click="ans_quicklink(item)"><v-icon style="font-size: 12px;">fas fa-link</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn v-if="item.type == 'link_market'" round small class="quick_reply" @click="ans_quicklink_market(item)"><v-icon style="font-size: 12px;">fas fa-link</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn
                slot="activator"
                v-if="item.type == 'webview'" round small class="quick_reply"
                @click="ans_quickwebview(item)"
              >
                <v-icon style="font-size: 12px;">web</v-icon> &nbsp;&nbsp; {{item.label}}
              </v-btn>
              <!-- ocr -->
              <v-btn v-else-if="item.type == 'ocr'" round small class="quick_reply" @click="ocropen(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <!-- quickreply file image -->
              <v-btn v-else-if="item.type == 'file'" round small class="quick_reply" @click="selectfile_quickreply(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <v-btn v-else-if="item.type == 'image'" round small class="quick_reply" @click="selectfile_quickreply(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <!-- location -->
              <v-btn v-else-if="item.type == 'location'" round small class="quick_reply" @click="sendlocation_quickreply(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <!-- ekyc -->
              <v-btn v-if="item.type == 'ekyc'" round small class="quick_reply" @click="ans_ekyc(item, Quickreply)"><v-icon style="font-size: 12px;">fas fa-id-card</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
            </a>
          </div>
          <div class="scrolling-wrapper" v-if="selected === true">
            <a v-for="(item,index) in Quickreply.quick_reply" :key="index" style="">
              <v-btn v-if="item.type == 'text'" round small class="quick_replydis" @click="ans_quickreply(item, 'text')" disabled><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn v-if="item.type == 'datepicker' || item.type == 'datetimepicker'" round small class="quick_replydis" @click="setpicker(item)" disabled><v-icon style="font-size: 12px;">fas fa-calendar-alt</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn v-if="item.type == 'link'" round small class="quick_replydis" @click="ans_quicklink(item)" disabled><v-icon style="font-size: 12px;">fas fa-link</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn v-if="item.type == 'link_market'" round small class="quick_replydis" @click="ans_quicklink_market(item)" disabled><v-icon style="font-size: 12px;">fas fa-link</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
              <v-btn
                slot="activator"
                v-if="item.type == 'webview'" round small class="quick_replydis"
                @click="ans_quickwebview(item)"
                disabled
              >
                <v-icon style="font-size: 12px;">web</v-icon> &nbsp;&nbsp; {{item.label}}
              </v-btn>
              <!-- ocr -->
              <v-btn v-else-if="item.type == 'ocr'" disabled round small class="quick_reply" @click="ocropen(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <!-- quickreply file image -->
              <v-btn v-else-if="item.type == 'file'" disabled round small class="quick_reply" @click="selectfile_quickreply(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <v-btn v-else-if="item.type == 'image'" disabled round small class="quick_reply" @click="selectfile_quickreply(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <!-- location -->
              <v-btn v-else-if="item.type === 'location'" disabled round small class="quick_reply" @click="sendlocation_quickreply(item)">
                <span class="text-overflow-quickreply">{{item.label}}</span>
              </v-btn>

              <!-- ekyc -->
              <v-btn v-if="item.type == 'ekyc'" disabled round small class="quick_reply" @click="ans_ekyc(item, Quickreply)"><v-icon style="font-size: 12px;">fas fa-id-card</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
            </a>
          </div>
        </div>
        <!-- forward and unsend dialog -->
        <v-dialog v-model="settingdialog" max-width="290">
          <v-card>
            <v-list>
              <v-list-tile @click="loadfile(announce_message)" v-if="announce_message.typeofmessage == 'file' && extension(announce_message.message) != 'pdf'">{{$t('ChatSide.RightClickMenu.openfile')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'file' && extension(announce_message.message) != 'pdf'"></v-divider>
              <v-list-tile @click="zoomfile(false, announce_message)" v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password' && extension(announce_message.message) == 'pdf'">{{$t('ChatSide.RightClickMenu.openfile')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password' && extension(announce_message.message) == 'pdf'"></v-divider>
              <v-list-tile @click="openlocation(announce_message)" v-if="announce_message.typeofmessage == 'location'">{{$t('ChatSide.RightClickMenu.openlocation')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'location'"></v-divider>
              <v-list-tile v-if="announce_message.typeofmessage !== 'mention_message' && announce_message.typeofmessage !== 'contact'" @click="farwardmessage()">{{$t('ChatSide.RightClickMenu.forward')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage !== 'mention_message' && announce_message.typeofmessage !== 'contact'"></v-divider>
              <v-list-tile @click="mention_message()" v-if="announce_message.typeofmessage !== 'contact'">{{$t('ChatSide.RightClickMenu.mention')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage !== 'contact'"></v-divider>
              <v-list-tile @click="SelectBotMessage('sendmail')" v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password'">{{$t('ChatSide.RightClickMenu.sendmail')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password'"></v-divider>
              <v-list-tile @click="detailFriend(announce_message.message)" v-if="announce_message.typeofmessage === 'contact'">{{$t('ChatSide.RightClickMenu.profile')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage === 'contact' && announce_message.tokenuser === token"></v-divider>
              <v-list-tile @click="announce_msg()" v-if="announce_message.typeofmessage == 'message'">{{$t('ChatSide.RightClickMenu.announce')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'message'"></v-divider>
              <v-list-tile @click="unsendmessage()" v-if="announce_message.tokenuser === token">{{$t('ChatSide.RightClickMenu.cancelMsg')}}</v-list-tile>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- add image dialog -->
        <v-dialog v-model="imagealbumsdialog" max-width="290">
          <v-card>
            <v-list>
              <v-list-tile @click="zoom()">{{$t('ChatSide.RightClickMenu.openimage')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="farwardmessage()">{{$t('ChatSide.RightClickMenu.forward')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="SelectBotMessage('sendmail')">{{$t('ChatSide.RightClickMenu.sendmail')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="mention_message()">{{$t('ChatSide.RightClickMenu.mention')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="add_image_albums()">{{$t('ChatSide.RightClickMenu.addImageAlbum')}}</v-list-tile>
              <v-divider v-if="announce_message.tokenuser === token"></v-divider>
              <v-list-tile @click="unsendmessage()" v-if="announce_message.tokenuser === token">{{$t('ChatSide.RightClickMenu.cancelMsg')}}</v-list-tile>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- unsend dialog -->
        <v-dialog v-model="unsenddialog" max-width="290">
          <v-card>
            <v-list>
              <v-list-tile @click="mention_message()">{{$t('ChatSide.RightClickMenu.mention')}}</v-list-tile>
              <v-divider></v-divider>
              <!-- <v-list-tile @click="announce_msg()">ประกาศ</v-list-tile>
              <v-divider></v-divider> -->
              <v-list-tile @click="unsendmessage()">{{$t('ChatSide.RightClickMenu.cancelMsg')}}</v-list-tile>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- forward dialog -->
        <v-dialog v-model="forwarddialog" max-width="290">
          <v-card>
            <v-list>
              <v-list-tile @click="zoom()" v-if="announce_message.typeofmessage == 'image'">{{$t('ChatSide.RightClickMenu.image')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'image'"></v-divider>
              <v-list-tile @click="zoomfile(false, announce_message)" v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password' && extension(announce_message.message) == 'pdf'">{{$t('ChatSide.RightClickMenu.openfile')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password' && extension(announce_message.message) == 'pdf'"></v-divider>
              <v-list-tile @click="openlocation(announce_message)" v-if="announce_message.typeofmessage == 'location'">{{$t('ChatSide.RightClickMenu.openlocation')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'location'"></v-divider>
              <v-list-tile @click="mention_message()">{{$t('ChatSide.RightClickMenu.mention')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="SelectBotMessage('sendmail')" v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password'">{{$t('ChatSide.RightClickMenu.sendmail')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'file' || announce_message.typeofmessage == 'pdf_password'"></v-divider>
              <v-list-tile @click="announce_msg()" v-if="announce_message.typeofmessage == 'message'">{{$t('ChatSide.RightClickMenu.announce')}}</v-list-tile>
              <v-divider v-if="announce_message.typeofmessage == 'message'"></v-divider>
              <v-list-tile @click="farwardmessage()">{{$t('ChatSide.RightClickMenu.forward')}}</v-list-tile>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- forward dialog -->
        <v-dialog v-model="forwardimagedialog" max-width="290">
          <v-card>
            <v-list>
              <v-list-tile @click="zoom()">{{$t('ChatSide.RightClickMenu.openimage')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="mention_message()">{{$t('ChatSide.RightClickMenu.mention')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="add_image_albums()">{{$t('ChatSide.RightClickMenu.addImageAlbum')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="farwardmessage()">{{$t('ChatSide.RightClickMenu.forward')}}</v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="SelectBotMessage('sendmail')">{{$t('ChatSide.RightClickMenu.sendmail')}}</v-list-tile>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- forward dialog -->
        <v-dialog v-model="mentiondialog" max-width="290">
          <v-card>
            <v-list>
              <v-list-tile @click="mention_message()">{{$t('ChatSide.RightClickMenu.mention')}}</v-list-tile>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- announce dialog -->
        <v-dialog v-model="announcedialog" max-width="290">
          <v-card>
            <v-list>
              <!-- <v-list-tile @click="delete_announce()">ไม่แสดงอีก</v-list-tile>
              <v-divider></v-divider> -->
              <v-list-tile @click="cancel_announce()">{{$t('ChatSide.RightClickMenu.cancelAnnounce')}}</v-list-tile>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- bot dialog message -->
        <v-dialog v-model="bot_dialog_message" max-width="290">
          <v-card>
            <v-list v-for="(item, index) in bot_dialog_list">
              <v-list-tile @click="SelectBotMessage(item.methods)">
                {{item.message}}
              </v-list-tile>
              <v-divider v-if="index < bot_dialog_list.length - 1"></v-divider>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- chip message-->
        <v-flex xs12 sm12 md12 style="margin: 0; bottom: 170px; position: fixed; width: 100%; height: 4vh; padding: 5px !important; cursor: pointer;" @click="lookmessage" v-if="showmessagebottom">
          <v-layout justify-center>
            <v-chip close v-model="chip" @click="closechip" style="cursor: pointer;">
              <v-avatar>
                <img :src="picturechip" v-if="picturechip" class="alligator-turtle">
                <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" v-else>
              </v-avatar>
              <span class="text2">{{showmessage}}</span>
            </v-chip>
          </v-layout>
        </v-flex>
        <!-- tab show mention -->
        <v-flex xs12 sm12 md12 class="showmention" v-if="showmention" :style="tabShowmention">
          <v-layout row align-center>
            <v-flex xs1>
              <v-avatar>
                <img style="height: 40px; width: 40px;" :src="mentionpathpic" v-if="mentionpathpic !== ''" class="alligator-turtle">
                <img style="height: 40px; width: 40px;" src="/static/img/default_profile/man-white.png" v-else class="alligator-turtle">
              </v-avatar>
            </v-flex>
            <v-flex xs10 style="margin-left: 22px;">
              <v-layout column v-if="mentiontypemsg == 'message' || mentiontypemsg == 'mention_message'">
                <span style="color: ghostwhite; white-space: nowrap; width: 50vw; overflow: hidden;text-overflow: ellipsis;">{{mentionname}}</span>
                <span style="color: ghostwhite; white-space: nowrap; width: 50vw; overflow: hidden;text-overflow: ellipsis;" v-if="mentionmessage" v-html="convertMention(mentionmessage)"></span>
              </v-layout>
              <v-layout row v-else-if="mentiontypemsg === 'image' || mentiontypemsg === 'sticker' || mentiontypemsg === 'file' || mentiontypemsg === 'pdf_password'">
                <span style="color: ghostwhite; white-space: nowrap; width: 50vw; overflow: hidden;text-overflow: ellipsis;">{{mentionname}}</span>
                  <v-spacer></v-spacer>
                  <img style="height: 40px; width: 40px; border-radius: 10px;" :src="mentionmessage" v-if="mentiontypemsg === 'image'">
                  <img style="height: 40px; width: 40px; border-radius: 10px;" :src="mentionimage" v-else-if="mentiontypemsg === 'sticker'">
                  <v-icon v-else-if="extension(mentionimage) === 'pdf'" style="color: white; font-size: 35px;">fas fa-file-pdf</v-icon>
                  <v-icon v-else style="color: white; font-size: 35px;">{{extension(mentionimage)}}</v-icon>
              </v-layout>
              <v-layout row v-else-if="mentiontypemsg === 'video'">
                <span style="color: ghostwhite; white-space: nowrap; width: 50vw; overflow: hidden;text-overflow: ellipsis;">{{mentionname}}</span>
                  <v-spacer></v-spacer>
                  <video width="40" height="40" style="justify-content: center; align-items: center;" autoplay>
                    <source :src="mentionmessage" :type="'video/' + mentionmessage.split('.')[mentionmessage.split('.').length - 1]">
                  </video>
              </v-layout>
              <v-layout row v-else-if="mentiontypemsg === 'location'">
                <span style="color: ghostwhite; white-space: nowrap; width: 50vw; overflow: hidden;text-overflow: ellipsis;">{{mentionname}}</span>
                  <v-spacer></v-spacer>
                  <v-icon style="color: white; font-size: 35px;">fas fa-map-marker-alt</v-icon>
              </v-layout>
            </v-flex>
            <v-flex xs1 style="padding-left: 9px; padding-bottom: 20px;">
              <v-icon color="white" @click="closemention">close</v-icon>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- download app -->
        <!-- <v-flex xs12 md12 style="background: #414141; margin: 0; width: 100%; height: 12vh; bottom: 0px; position: fixed; padding: 5px !important; z-index: 1;" v-if="snackbar" class="CSChatThai">
          <v-layout align-center justify-center row fill-height>
            <v-flex xs2 md2>
              <v-btn icon flat  @click="closedownload()"><v-icon style="font-size: 18px !important; color: white;">close</v-icon></v-btn>
            </v-flex>
            <v-flex xs5 md5 style="color: white !important;">
              {{ textsnackbar }}
            </v-flex>
            <v-flex xs5 md5>
              <v-btn color="info" @click="downloadios()" v-if="deviceos === 'ios'" drak>ดาวน์โหลด</v-btn>
            <v-btn color="info" @click="downloadandroid()" v-else drak>ดาวน์โหลด</v-btn>
            </v-flex>
          </v-layout>
        </v-flex> -->

        <!-- tag friend -->
        <v-flex xs12 sm12 md12 lg12 xl12 v-if="status_tag" class="friendList">
          <div>
            <v-list dense v-for="(item, index) in listfriend_filter" :key="index" >
              <v-list-tile  @click="tagFriend(item.name)">
                  <v-list-tile-avatar>
                    <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle">
                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                  </v-list-tile-avatar>
                <v-list-tile-content class="pl-2">
                  <v-list-tile-title v-text="item.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </v-flex>

        <v-flex sm12 md12 lg12 xl12 style="bottom: 0; position: fixed; width: 100%; border-width: thin; border-top-style: solid; border-color: #80808099;" v-if="selected === false">
            <v-layout  align-center justify-center wrap v-if="statemember === 'active'">
              <v-flex xs12 sm12 md12 v-if="!RichmenuState">
                <v-layout  align-center justify-center row style="margin-top: 6px;">
                  <!-- btn rich menu -->
                  <v-btn v-if="list_richmenu.length !== 0" flat icon @click="chsheetrichmenu" style="margin-bottom: 30px; argin-right: 0px;">
                    <v-icon style="font-size: 20px !important;">fas fa-list</v-icon>
                  </v-btn>
                  <v-btn flat icon @click="chsheetother" style="margin-bottom: 30px; margin-left: 0px; margin-right: 0px;">
                    <v-icon style="font-size: 25px !important;">add_circle_outline</v-icon>
                  </v-btn>
                  <v-text-field
                    v-model="sendmsg"
                    :append-icon="marker ? 'insert_emoticon' : 'insert_emoticon'"
                    :append-outer-icon="sendmsg ? 'send' : ''"
                    solo
                    clear-icon="clear"
                    :label="$t('ChatSide.textarea.normal')"
                    type="text"
                    @click:append="chsheetsticker"
                    @click:append-outer="sendMessage(sendmsg)"
                    @click:clear="clearMessage"
                    @keydown.enter = "sendMessage(sendmsg)"
                    @input="filterlistfriend()"
                    ref="textareaChat"
                    id="textareaChat"
                    class="mr-2"
                    ></v-text-field>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 v-else style="bottom: 0; width: 100%;">
                <!-- rich menu -->
                <Richmenudialogmobile v-if="sheetrichmenu" :type_richmenu="type_richmenu" :Richmenudialog="Richmenudialog" :inforrichmenu="inforrichmenu" @emitrichmenu="emitrichmenu"></Richmenudialogmobile>
                <v-layout align-center justify-center row style="margin-top: 6px;" v-if="!sheetrichmenu">
                  <v-btn flat icon @click="RichmenuState = false; sheetrichmenu = false" style="">
                    <v-icon style="font-size: 20px !important;">fas fa-keyboard</v-icon>
                  </v-btn>
                  <v-btn block outline color="#2561af" style="text-transform: none; margin-right: 5px;" @click="sheetrichmenu = true">{{richmenu_label}}</v-btn>
                </v-layout>
                <v-layout align-center justify-center row style="width: 100%;" v-else>
                  <v-btn flat icon @click="RichmenuState = false; sheetrichmenu = false" style="">
                    <v-icon style="font-size: 20px !important;">fas fa-keyboard</v-icon>
                  </v-btn>
                  <v-btn block outline color="#2561af" style="text-transform: none; margin-right: 5px;" @click="sheetrichmenu = false">
                    <v-layout column wrap justify-center align-center>
                      <v-icon style="color: #2561af; font-size: 14px !important;">fas fa-sort-down</v-icon>
                      <span>{{richmenu_label}}</span>
                    </v-layout>
                  </v-btn>
                </v-layout>
                <!-- <v-layout align-center justify-center row style="margin-top: 6px; bottom: 0; position: fixed; width: 100%;" v-else>
                  <v-btn flat icon @click="RichmenuState = false; sheetrichmenu = false" style="">
                    <v-icon style="font-size: 20px !important;">fas fa-keyboard</v-icon>
                  </v-btn>
                  <v-btn block outline color="#2561af" style="text-transform: none; margin-right: 5px;" @click="sheetrichmenu = false">
                    <v-layout column wrap justify-center align-center>
                      <v-icon style="color: #2561af; font-size: 14px !important;">fas fa-sort-down</v-icon>
                      <span>{{richmenu_label}}</span>
                    </v-layout>
                  </v-btn>
                </v-layout> -->
              </v-flex>
            </v-layout>
            <v-layout  align-center justify-end wrap v-else>
              <v-flex xs12 sm12 md12>
                <v-layout  align-center justify-center row style="margin-top: 6px;">
                  <!-- btn rich menu -->
                  <v-btn v-if="list_richmenu.length !== 0" flat icon style="margin-right: 0px; margin-bottom: 30px;" disabled>
                    <v-icon style="font-size: 25px !important;">fas fa-list</v-icon>
                  </v-btn>
                  <v-btn flat icon @click="chsheetother" style="margin-bottom: 30px;  margin-left: 0px; margin-right: 0px;" disabled>
                    <v-icon style="font-size: 25px !important;">add_circle_outline</v-icon>
                  </v-btn>
                  <v-text-field
                    disabled
                    v-model="sendmsg"
                    :append-icon="marker ? 'insert_emoticon' : 'insert_emoticon'"
                    :append-outer-icon="sendmsg ? 'send' : ''"
                    solo
                    clear-icon="clear"
                    clearable
                    :label="$t('ChatSide.textarea.inactive')"
                    type="text"
                    @click:append="chsheetsticker"
                    @click:append-outer="sendMessage(sendmsg)"
                    @click:clear="clearMessage"
                    @keydown.enter = "sendMessage(sendmsg)"
                    ></v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12 style="border-width: thin; border-top-style: solid; border-color: #80808099;" v-else>
            <v-layout column wrap>
              <v-flex xs12 sm12 md12>
                <v-layout justify-center align-center>
                  <span style="font-size: 16px; font-weight: 200px;" v-if="selectedmessage.length === 0">{{$t('ChatSide.numberMsgSent')}}</span>
                  <span style="font-size: 16px; font-weight: 200px;" v-else>{{$t('ChatSide.numberMsgSent')}} ({{selectedmessage.length}})</span>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout justify-center align-center row wrap>
                  <v-btn disabled class="btncreategroup" small round v-if="selectedmessage.length === 0">
                    {{$t('AnswerQuestion.forward')}}
                  </v-btn>
                  <v-btn class="btncreategroup" small round @click="toPageForward(selectedmessage.tokenmessage)" v-else>
                    {{$t('AnswerQuestion.forward')}}
                  </v-btn>
                  <v-btn class="btncanclegroup" small round @click="closeSeleted()">
                    {{$t('AnswerQuestion.cancel')}}
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
      </div>
    </v-layout>
    <!-- uppic upfile -->
    <div style="display:none;">
     <input multiple type="file" id="uploadpic" @change="onFileSelected" accept="image/*" />
     <input multiple type="file" id="uploadfileChat" @change="onFileSelected" />
     <input type="file" id="uploadpic_ocr" @change="onimgSelected_ocr($event)" @click="clearImage()" accept="image/*" />
     <input type="file" id="uploadpic_quickreply" @change="onimgSelected_quickreply($event)" @click="clearImage()" accept="image/*" />
     <input type="file" id="uploadfile_quickreply" @change="onimgSelected_quickreply($event)" @click="clearImage()" />
    </div>
    <!-- webview template -->
    <v-bottom-sheet v-model="sheetwebviewmenu">
      <v-card tile>
        <v-toolbar card dark>
          <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{inforwebview.label}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark :href="inforwebview.url" target="_blank">
            <v-icon color="white" style="font-size: 18px !important;">far fa-window-restore</v-icon>
          </v-btn>
          <v-btn icon dark @click="closewebviewmenu">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe style="width: 100%; height: 280px; visibility:visible;" frameborder='0' :src="inforwebview.url" v-if="inforwebview.size == 'compact'"></iframe>
        <iframe style="width: 100%; height: 500px; visibility:visible;" frameborder='0' :src="inforwebview.url" v-else-if="inforwebview.size == 'tall'"></iframe>
        <iframe style="width: 100%; height: calc(100vh - 110px); visibility:visible;" frameborder='0' :src="inforwebview.url" v-else-if="inforwebview.size == 'full'"></iframe>
      </v-card>
    </v-bottom-sheet>
    <!-- webview quick_reply -->
    <v-bottom-sheet v-model="sheetwebview">
      <v-card tile>
        <v-toolbar card dark>
          <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{inforquickreply.label}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark :href="inforquickreply.url" target="_blank">
            <v-icon color="white" style="font-size: 18px !important;">far fa-window-restore</v-icon>
          </v-btn>
          <v-btn icon dark @click="closewebview">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe style="width: 100%; height: 280px; visibility:visible;" frameborder='0' :src="inforquickreply.url" v-if="inforquickreply.size == 'compact'"></iframe>
        <iframe style="width: 100%; height: 500px; visibility:visible;" frameborder='0' :src="inforquickreply.url" v-else-if="inforquickreply.size == 'tall'"></iframe>
        <iframe style="width: 100%; height: calc(100vh - 110px); visibility:visible;" frameborder='0' :src="inforquickreply.url" v-else-if="inforquickreply.size == 'full'"></iframe>
      </v-card>
    </v-bottom-sheet>
    <!-- tab other -->
    <div style="display: none;">
      <v-bottom-sheet v-if="statemember=='active'" v-model="sheetother" id="tabother">
        <v-card tile style="text-transform: none !important;">
          <v-card-text style="padding-top:  0vh; text-transform: none; height: 225px;">
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 md4 sm4>
                <v-layout align-center justify-center wrap column>
                  <v-btn flat icon @click="uppic">
                    <v-icon style="font-size: 25px !important;">photo</v-icon>
                  </v-btn>
                  <p>{{$t('ChatSide.image')}}</p>
                </v-layout>
              </v-flex>
              <v-flex xs4 md4 sm4>
                <v-layout align-center justify-center column wrap>
                  <v-btn flat icon @click="upfile">
                    <v-icon style="font-size: 25px !important;">attach_file</v-icon>
                  </v-btn>
                  <p>{{$t('ChatSide.file')}}</p>
                </v-layout>
              </v-flex>
              <v-flex xs4 md4 sm4>
                <v-layout align-center justify-center column wrap>
                  <v-btn flat icon @click="dialogAccount = true; sheetother = false">
                    <v-icon style="font-size: 25px !important;">contacts</v-icon>
                  </v-btn>
                  <p>{{$t('ChatSide.friend')}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 md4 sm4>
                <v-layout align-center justify-center column wrap>
                  <v-btn flat icon @click="openmap">
                    <v-icon style="font-size: 25px !important;">location_on</v-icon>
                  </v-btn>
                  <p>{{$t('ChatSide.location')}}</p>
                </v-layout>
              </v-flex>
              <v-flex xs4 md4 sm4>
                <!-- <v-layout align-center justify-center column wrap>
                  <v-btn flat icon @click="clickforward()">
                    <v-icon style="font-size: 25px !important;">location_on</v-icon>
                  </v-btn>
                  <p>แชร์ข้อความ</p>
                </v-layout> -->
              </v-flex>
              <v-flex xs4 md4 sm4></v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
    </div>
    <!-- tab sticker -->
    <div style="display: none;">
      <v-bottom-sheet v-if="statemember=='active'" v-model="sheetsticker" id="tabsticker">
        <v-card tile style="text-transform: none !important;">
          <v-card-text style="padding-top:  0vh; text-transform: none; height: 225px;" >
            <v-tabs centered  v-model="activetapEmo" style="background: white !important; text-transform: none;" slot="extension">
              <v-tab style="font-size: 20px; text-transform: none !important; overflow-y: hidden;" href="#tab-Emo" >
                <p class="textemo">{{$t('ChatSide.emoji')}}</p>
              </v-tab>
              <v-tab style="font-size: 20px; text-transform: none !important; overflow-y: hidden;" href="#tab-Stick" >
                <p class="textemo">{{$t('ChatSide.sticker')}}</p>
              </v-tab>
            </v-tabs>
            <v-tabs-items  style="margin-top: 0.2vh;" v-model="activetapEmo">
              <v-tab-item id="tab-Emo" style="height: 50vh; overflow-y: scroll; text-transform: none;">
                 <div style="background: white !important;">
                  <v-tabs centered v-model="activeEmoji" style="background: white !important;" slot="extension">
                      <v-tab v-for="(emojiGroup, category) in emojiGroups" style="font-size: 20px;" :href="'#tab-'+ category" :key="category">
                        {{emojiGroup['smile']}}
                        {{emojiGroup['bear']}}
                        {{emojiGroup['soccer']}}
                        {{emojiGroup['house_with_garden']}}
                        {{emojiGroup['heart_decoration']}}
                      </v-tab>
                      </v-tabs>
                    <v-tabs-items  style="margin-top: 0.2vh;" v-model="activeEmoji">
                      <v-tab-item v-for="(emojiGroup, category) in emojiGroups" :id="'tab-'+category" style="height: 30vh; overflow-y: scroll;" :key="category">
                        <div class="emojis">
                          <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="append(emoji)" :title="emojiName">{{ emoji }}</span>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                </div>
              </v-tab-item>
              <v-tab-item id="tab-Stick" style="height: 50vh; overflow-y: scroll;  text-transform: none;">
                <div style="background: white !important;">
                  <v-tabs centered  style="background: white !important;" v-model="activeSticker" slot="extension">
                    <v-tab style="font-size: 20px;" :href="'#tabsticker-'+item.token_sticker"  v-for="(item,index) in sticker" :key="item.token_sticker">
                      <img style="width: 30px;" :src="item.path_title">
                    </v-tab>
                  </v-tabs>
                    <v-tabs-items  style="margin-top: 0.2vh;" v-model="activeSticker">
                      <v-tab-item v-for="(item,index) in sticker"  :id="'tabsticker-'+item.token_sticker" :key="index" style="height: 100px; overflow-y: scroll;">
                        <v-container wrap style="padding-top:  0px;">
                          <v-layout wrap style="flex-wrap: wrap;">
                            <v-flex sm4 md4 xs4 style=" justify-content: center;" v-for="(items,index) in item.list_sticker" :key="index">
                              <v-layout style=" justify-content: center;display: flex;text-align: center;">
                                <img style="width: 80px; height: 80px;" :src="items.s3_name" @click="pushSticker(items.message)">
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-tab-item>
                    </v-tabs-items>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>
      </div>
      <DialogGetpassword :dialogGetPassword="dialogGetPassword" :DetailFile="DetailFile"  @closeDialogpassword="closeDialogpassword" />
        <!-- <v-dialog v-model="dialogGetPassword" persistant  width="600">
    <v-toolbar card style="background: #1a222c !important;">
      <v-toolbar-title class="white--text"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark icon flat @click="dialogGetPassword = false">
        <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <div class="pt-4 pb-4 pr-4 pl-4">
        <span style="font-size:18px; font-weight:bold ;" >{{$t('File.textRequirePassword')}}</span>
        <br/>
            <v-text-field
              class="mt-2"
              v-model="passwordFile"
              solo
              :label="$t('File.passwordFile')"
              clearable
              append-icon="search"
            ></v-text-field>
            <v-layout justify-end>
              <v-btn outline round style="background-color:white; color:#2562af; border-color:#2562af;" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>
              <v-btn round :disabled="passwordFile == '' || passwordFile == null  ? true : false" style="background-color:#2562af; color:white;" @click="submitPassword()" :loading="progressBtn">{{$t('AnswerQuestion.ok')}}</v-btn>
            </v-layout>
      </div>
    </v-card>
  </v-dialog> -->
    <ReadmoreDialog :dialogReadmore="dialogReadmore" :detailReadmore="detailReadmore" @closeReadmoreDialog="closeReadmoreDialog"/>
    <AccountDialog :dialogAccount="dialogAccount" @closeAccount="closeAccount" @pushcontact="pushcontact"></AccountDialog>
    <NoteDialog :dialogNote="dialogNote" :note_id="note_id" :status_block="status_block" @closeNote="closeNote"></NoteDialog>
    <MapDialogMobile :dialogSendMap="dialogSendMap" @closeSendMap="closeSendMap" @send_location="send_location"></MapDialogMobile>
    <ApproveDialogMobile :dialogApprove="dialogApprove" :ApproveDetail="ApproveDetail" @sendansApprove="sendansApprove" @closeApprove="closeApprove"></ApproveDialogMobile>
    <AlbumsDialogMobile :dialogAlbums="dialogAlbums" :albums_id="albums_id" @closeAlbums="closeAlbums"></AlbumsDialogMobile>
    <AddImageDialogMobile :dialogAddImage="dialogAddImage" @closeAddImage="closeAddImage" :path_pic_albums="path_pic_albums" :file_name="file_name"></AddImageDialogMobile>
    <InforfriendDialogMobile :inforfrienddialog="inforfrienddialog" @closeInforfriend="closeInforfriend" :tokeninforfriend="tokeninforfriend"></InforfriendDialogMobile>
    <DetailTask :dialogDetailTask="dialogDetailTask" @closeDetailTask="closeDetailTask" :taskid="taskid" :roomid="roomid"></DetailTask>
    <SaveOnebox :dialogSaveOnebox="dialogSaveOnebox" @closeSaveOnebox="closeSaveOnebox" :tokenmessage_savebox="tokenmessage_savebox"></SaveOnebox>
    <WebviewBigOcrDialog :token="token" :tokenrooomSelect="tokenrooomSelect" :dialogWebviewbig_ocr="dialogWebviewbig_ocr" :Webview_item="Webview_item_ocr" @closewebview="closewebview"></WebviewBigOcrDialog>
    <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser" :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>
    <QrCodeRichMenuDialog :dialogQrcodRichMenu="dialogQrcodRichMenu" :tokenroom="tokenrooomSelect" @closedialogQrcode="closedialogQrcode" :QrcodeInfor="QrcodeInfor"></QrCodeRichMenuDialog>
    <CreateMailMobileDialog :dialogCreatemailMobile="dialogCreatemailMobile" @closeCreatemail="closeCreatemail" :message="SelectedMessageDetail" />
    <!-- dialog map -->
    <v-dialog v-model="dialogMap"  fullscreen style="overflow-y: hidden;">
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai" v-if="locationName.file_name != ''"> 🚩&nbsp;&nbsp;{{locationName.file_name}} </v-toolbar-title>
         <v-toolbar-title class="white--text CSChatThai" v-else> 🚩&nbsp;&nbsp;{{$t('ChatSide.location')}} </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click="dialogMap = false">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <div id = "map" style="height: 100%; width: 100%;" ></div>
    </v-dialog>
    <!-- webview official_template -->
    <v-dialog v-model="official_sheet" fullscreen>
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{official_item.label}}</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-btn dark icon flat @click.native="newtab">
              <v-icon style="color: white !important; font-size: 20px !important;">far fa-window-restore</v-icon>
            </v-btn>
          <v-btn dark icon flat @click.native="closeDialog_official">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe style="width: 100%; height: 280px; visibility:visible;" frameborder='0' :src="official_item.url" v-if="official_item.size == 'compact'"></iframe>
        <iframe style="width: 100%; height: 500px; visibility:visible;" frameborder='0' :src="official_item.url" v-else-if="official_item.size == 'tall'"></iframe>
        <iframe style="width: 100%; height: calc(100vh - 140px); visibility:visible;" frameborder='0' :src="official_item.url" v-else-if="official_item.size == 'full'"></iframe>
        <iframe style="width: 100%; height: calc(100vh - 140px); visibility:visible;" frameborder='0' :src="official_item.url" v-else></iframe>
      </v-card>
    </v-dialog>
  </div>
</vue100vh>
<!-- </Vue100vh> -->
</template>
<script>
import Vue from 'vue'
import pdf from 'vue-pdf'
import { Momenttime, Decode } from '@/services'
// import Forward from '@/components/mobile/manage/Forwardmessage'
import NoteDialog from '@/components/mobile/dialog/NoteDialogMobile'
import AccountDialog from '@/components/mobile/dialog/AccountDialogMobile'
import MapDialogMobile from '@/components/mobile/dialog/MapDialogMobile'
import ApproveDialogMobile from '@/components/mobile/dialog/ApproveDialogMobile'
import AlbumsDialogMobile from '@/components/mobile/dialog/AlbumsDialogMobile'
import AddImageDialogMobile from '@/components/mobile/dialog/AddImageDialogMobile'
import InforfriendDialogMobile from '@/components/mobile/dialog/InforfriendDialogMobile'
import DetailTask from '@/components/mobile/task/detail_task_dialog_mo'
import SaveOnebox from '@/components/mobile/dialog/SaveoneboxDialogMobile'
import Richmenudialogmobile from '@/components/mobile/dialog/RichmenuDialogMobile'
import WebviewBigOcrDialog from '@/components/mobile/dialog/WebviewOcrDialogMobile'
import CheckBrowserDialog from '@/components/chat/dialog/CheckBrowserDialog'
import QrCodeRichMenuDialog from '@/components/mobile/dialog/QrCodeRichMenuDialog'
import CreateMailMobileDialog from '@/components/mobile/dialog/CreatemailDialogMobile'
import ReadmoreDialog from '@/components/mobile/dialog/ReadmoreDialogMobile'
import DialogGetpassword from '@/components/chat/dialog/dialogGetPassword'
// import ModalImg from '@/components/chat/modal/ModalImg'
import { sync } from 'vuex-pathify'
import { VueContext } from 'vue-context'
import { Encode } from '@/services'
import vue100vh from 'vue-100vh'
import { vplayer } from 'vue-hls-player'
import LinkPrevue from 'link-prevue'
// import Vue100vh from 'vue-div-100vh'
import VueScreenSize from 'vue-screen-size'
import { longClickDirective } from 'vue-long-click'
// import VuePdfEmbed from 'vue-pdf-embed'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
const longClickInstance = longClickDirective({delay: 1000, interval: 1000})
Vue.directive('longclick', longClickInstance)

const emojiGroups = require('../../../../static/json/emoji')
var _ = require('lodash')
export default {
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    VuePdfEmbed,
    ReadmoreDialog,
    CreateMailMobileDialog,
    vplayer,
    QrCodeRichMenuDialog,
    CheckBrowserDialog,
    // EmojiPicker,
    WebviewBigOcrDialog,
    Richmenudialogmobile,
    pdf,
    // ModalImg,
    ApproveDialogMobile,
    MapDialogMobile,
    NoteDialog,
    AccountDialog,
    AddImageDialogMobile,
    AlbumsDialogMobile,
    InforfriendDialogMobile,
    VueContext,
    DetailTask,
    SaveOnebox,
    LinkPrevue,
    // Vue100vh
    vue100vh,
    DialogGetpassword
    // Forward
    // LeftSideMobile
    // shareContactDialog
  },
  // props: {infofriend: ''},
  data: () => ({
    showPdf: true,
    loadedRatio: 0,
    dialogReadmore: false,
    detailReadmore: {},
    dialogCreatemailMobile: false,
    bot_dialog_message: false,
    bot_dialog_list: [],
    status_tag: false,
    listfriend_filter: [],
    listfriend: [],
    infor_file: '',
    innerHeight: 0,
    ocr_detailItem: {},
    itemdetail_quickreply: {},
    dialogQrcodRichMenu: false,
    checkBrowserInfor: {},
    checkBrowserDialog: false,
    Webview_item: {},
    Webview_item_ocr: {},
    dialogWebviewbig_ocr: false,
    cycle: false,
    snackbar: false,
    textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
    deviceos: '',
    chatbox: '',
    list_richmenu: [],
    richmenu_label: '',
    type_richmenu: 0,
    Richmenudialog: false,
    inforrichmenu: {},
    sheetrichmenu: false,
    RichmenuState: false,
    default_behavior: 0,
    inforquickreply: {},
    inforwebview: {},
    dialogSaveOnebox: false,
    tokenmessage_savebox: '',
    official_item: {},
    official_sheet: false,
    tokeninforfriend: '',
    inforfrienddialog: false,
    showphone: false,
    tabShowmention: '',
    mentiondialog: false,
    showmention: false,
    picturechip: '',
    chip: false,
    forwarddialog: false,
    forwardimagedialog: false,
    unsenddialog: false,
    unsenddetail: {},
    settingdialog: false,
    imagealbumsdialog: false,
    ApproveDetail: {},
    dialogApprove: false,
    locationName: '',
    dialogSendMap: false,
    sheetmap: false,
    landscape: false,
    sheetwebviewmenu: false,
    sheetwebview: false,
    modalpic: false,
    temp: [],
    selectedmsg: false,
    sheetForward: false,
    showMenu: false,
    selected: false,
    selectedmessage: [],
    centerboxstyle: '',
    sheet: false,
    marker: true,
    iconIndex: 0,
    icons: [
      'mdi-emoticon',
      'mdi-emoticon-cool',
      'mdi-emoticon-dead',
      'mdi-emoticon-excited',
      'mdi-emoticon-happy',
      'mdi-emoticon-neutral',
      'mdi-emoticon-sad',
      'mdi-emoticon-tongue'
    ],
    textinput: false,
    showloc: '',
    dialogAccount: false,
    dialogMap: false,
    statemember: '',
    imgShow: false,
    messageQuickreply: true,
    Quickreply: {},
    datepicker: false,
    timepicker: false,
    dialogNote: false,
    dateselect: '',
    maxdate: '',
    mindate: '',
    timeselect: '',
    maxtime: '',
    mintime: '',
    typepicker: '',
    infodata: '',
    search: '',
    box_height: '',
    note_id: '',
    tabs: ['tab-1', 'tab-2', 'tab-3'],
    active: null,
    model: 'tab-2',
    filepdf: '',
    // shareContact: false,
    currentPage: 1,
    // pageCount: 0,
    // id: getGuid(),
    // select image
    scrollMaxOld: 0,
    firsttime: true,
    statePage: '',
    profile: '',
    members: {},
    offsetTop: 0, // test scroll
    dialog: false,
    tokenrooomSelect: '',
    image: '',
    alert: true,
    items: [],
    // items_friend: [],
    // items_self: [],
    itemShow: [],
    sendmsg: '',
    date: '',
    name: '',
    selectFile: null,
    typeofmessage: '',
    statusload: false,
    center: {lat: 45.508, lng: -73.587},
    markers: [],
    places: [],
    currentPlace: null,
    groupnameTest: '',
    currentLocation: {lat: 0, lng: 0},
    searchAddressInput: '',
    loadfileData:{},
    place: null,
    lat: '',
    lng: '',
    address: '',
    state: true,
    nicknameSend: '',
    filenameSend: '',
    timeSend: '',
    picSend: '',
    dateSend: '',
    tokenmsgSend: '',
    pathSend: '',
    typeuserSend: '',
    activeEmoji: null,
    activeSticker: null,
    activetapEmo: null,
    sheetother: false,
    sheetsticker: false,
    chatlogsFlex: '',
    showmessagebottom: false,
    showmessage: '',
    sticker: [
      {'list_sticker': []}
    ],
    typeuser: '',
    progressLoadChat: false,
    emojiGroups,
    business_id: '',
    map: '',
    x: 15,
    y: 30,
    locationArray: [],
    infofriend: {},
    windowWidth: '',
    dialogAlbums: false,
    dialogAddImage: false,
    albums_id: '',
    path_pic_albums: '',
    file_name: '',
    announce_message: {},
    listannounce: [],
    announcedialog: false,
    expansion_announce: false,
    less: false,
    show: false,
    rightclickdialog: false,
    SelectedMessageDetail: {},
    ListMenuRightClick: [],
    name: '',
    dialogDetailTask: false,
    roomid: '',
    taskid: '',
    imageData: '',
    bot_id_richmenu: '',
    progressBtn:false,
    numPages: 1,
    src: '',
    gotoTokenmessage: '',
    QrcodeInfor: '',
    text_search: '',
    one_id: '',
    status_block: '',
    block:'',
    dialogGetPassword: false,
    passwordFile: '',
    DetailFile: {},
    filetype : '',
    page: null,
    pageCount: 1,
  }),
  computed: {
    icon () {
      return this.icons[this.iconIndex]
    },
    ...sync('*')
  },
  mounted () {
    // this.geolocate()
    // this.initmapShow()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    });
  },
  updated () {
    // console.log('update')
    // // this.gotoMessage("5f6440e68bb547000bdb52a1")
    // console.log(this.gotoTokenmessage)
    setTimeout(this.gotoMessage(this.gotoTokenmessage), 2000)
  },
  watch: {
    bot_dialog_message () {
      if (!this.bot_dialog_message) {
        this.bot_dialog_list = []
      }
    },
    block_friend (data) {
      // console.log(data)
      if (data.event === 'block_friend') {
        this.statemember = 'block'
      } else {
        this.statemember = 'active'
      }
    },
    '$vssHeight' () {
      this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // console.log('height center ==> '+ this.$vssHeight)
      // console.log(this.box_height)
      this.checkHeightRichmenu()
    },
    innerHeight () {
      // console.log(this.innerHeight)
      // this.box_height = (this.innerHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      this.box_height = (this.innerHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // console.log(this.box_height)
    },
    // scrollval () {
    //   var container = this.$el.querySelector('#myscroll')
    //   this.scrollval = container.scrollTop
    //   console.log(this.scrollval)
    // },
    // scrollMaxOld () {
    //   console.log(this.scrollMaxOld)
    // },

    // filepdf () {
    //   console.log(this.filepdf)
    //   this.src = pdf.createLoadingTask(this.filepdf)
    //   console.log(this.src)
    //   this.src.promise.then(pdf => {
    //     console.log(pdf)
    //     this.numPages = pdf.numPages
    //     console.log(this.numPages)
    //   })
    //   // .catch((err) => {
    //   //   console.log(err)
    //   // })
    // },

    socket_drop_menu (data) {
      // console.log('drop_menu')
      if (data.tokenroom === this.$route.params.roomid) {
        this.sheetrichmenu = false
      }
    },
    socket_close_webview (data) {
      // console.log(data)
      this.official_item = {}
      this.official_sheet = false
    },
    socket_switch_keyboard (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.RichmenuState = false
        this.sheetrichmenu = false
      }
    },
    socket_switch_richmenu (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.RichmenuState = true
        this.sheetrichmenu = true
      }
    },
    socket_official_template (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        var index_target = data.target_index
        var index = _.findIndex(this.items, function(o) { return o.tokenmessage == data.tokenmessage })
        this.items[index].element.choice[index_target].disable = '1'
        // console.log(index_target)
      }
    },
    chat_wallpaper () {
      // console.log(this.chat_wallpaper.info)
      var room = this.$route.params.roomid
      var index = _.findIndex(this.chat_wallpaper.info, function (o) { return o.room === room })
      // console.log(index)
      if (index === -1) {
        this.imageData = ''
      } else {
        this.imageData = this.chat_wallpaper.info[index].background
      }
      this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - ' + '185px) !important; background-image: url(' + this.imageData + ');'
      // console.log(this.imageData)
    },
    less() {
      if (this.less) {
        this.$cookie.set(this.$route.params.roomid, 'less')
      } else {
        this.$cookie.delete(this.$route.params.roomid)
      }
    },
    socket_announce(data) {
      this.axios.post(process.env.APIpub + '/v1/user/get_announce_room_by_id', {
        tokenuser: this.token,
        token_announce: data.token_announce,
        tokenroom: this.tokenrooomSelect
      }).then((response) => {
        this.listannounce.unshift(response.data.data)
      })
    },
    showmention () {
      if (this.showmention === true && window.innerWidth <= 360) {
        this.tabShowmention = 'bottom: 67px !important;'
      } else if (this.showmention === true && window.innerWidth > 360) {
        this.tabShowmention = 'bottom: 84px !important;'
      }
    },
    box_height () {
      // console.log(this.box_height)
      // console.log(this.$vssHeight)
      if (this.sheetrichmenu !== true) {
        // console.log('obj')
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: '+ this.box_height + 'px !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: '+ this.box_height + 'px !important; background-image: url(' + this.imageData + ');'
        }
      } else {
      }
    },
    groupname (data) {
      this.infofriend.group_name = data
    },
    picturegroup (data) {
      this.infofriend.picture = data
    },
    socketquickreply (data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        // this.getreply()
        this.datepicker = false
        this.timepicker = false
        this.maxdate = ''
        this.mindate = ''
        this.maxtime = ''
        this.mintime = ''
        this.dateselect = ''
        this.timeselect = ''
        this.infodata = ''
        this.Quickreply = data
      }
    },
    socketdisablequickreply (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        // this.getreply()
        // this.Quickreply = ''
        this.datepicker = false
        this.timepicker = false
        this.maxdate = ''
        this.mindate = ''
        this.maxtime = ''
        this.mintime = ''
        this.dateselect = ''
        this.timeselect = ''
        this.infodata = ''
        this.Quickreply = ''
      }
    },
    socketdisableapprove (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) { return o.tokenmessage === data.tokenmessage && o.typeofmessage === 'approve_message' })
        this.items[indexid].disable = 'true'
      }
    },
    socket_unsendmessage (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function (o) { return o.tokenmessage === data.tokenmessage })
        var mentiontokenmessage = this.items[indexid].tokenmessage
        var indexmentionmsg = _.findIndex(this.items, function (o) { return o.file_name === mentiontokenmessage })
        if (indexmentionmsg === -1) {
          this.items[indexid].typeofmessage = 'unsend_message'
        } else {
          this.items[indexid].typeofmessage = 'unsend_message'
          this.items[indexmentionmsg].source_message.typeofmessage = 'unsend_message'
        }
      }
    },
    socket_kickmember (data) {
      var self = this
      data.listkick.forEach(function (item) {
        if (self.token === item) {
          self.statemember = 'leave'
        }
      })
    },
    socketactive_group (data) {
      var self = this
      if (self.token === data.tokenuser) {
        self.statemember = 'active'
      }
    },
    socket_announce (data) {
      // console.log(data)
      this.axios.post(process.env.APIpub + '/v1/user/get_announce_room_by_id', {
        tokenuser: this.token,
        token_announce: data.token_announce,
        tokenroom: this.tokenrooomSelect
      }).then((response) => {
        this.listannounce.unshift(response.data.data)
      })
    },
    selectedmessage () {
      if (this.selectedmessage.length > 5) {
        this.$swal(
          '',
          // 'เลือกข้อความได้สูงสุด 5 ข้อความ.',
          this.$t('Alert.Fail.Chat.maxMessage'),
          'error'
        )
        _.pullAt(this.selectedmessage, [5])
      }
    },
    windowWidth () {
      // console.log(this.windowWidth)
      // console.log(this.box_height)
      // console.log(this.$vssHeight)
      // console.log(this.windowWidth > 960)
      // if (this.windowWidth > 960) {
      //   // this.box_height = 0
      //   // console.log(this.box_height)
      //   if (localStorage.getItem('height_center') === undefined || localStorage.getItem('height_center') === null) {
      //     this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      //     localStorage.setItem('height_center', this.$vssHeight)
      //   } else {
      //     this.$vssHeight = parseInt(localStorage.getItem('height_center'))
      //     console.log(this.$vssHeight)
      //   }
      // } else {
      //   this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // }
      // if (this.windowWidth > 960) {
      //   this.box_height = 0
      //   this.$router.push('/chat/room/' + this.$route.params.roomid)
      // } else {
      //   this.$router.push('/mobile/room/' + this.$route.params.roomid)
      // }
    },
    dialogMap () {
      // console.log(this.dialogMap)
      if (this.dialogMap) {
        // console.log('dialogmap')
        this.initmapShow()
      }
    },
    sheetrichmenu () {
      // console.log('type_richmenu: ' + this.type_richmenu)
      // console.log('sheetrichmenu: ' + this.sheetrichmenu)
      // console.log('imageData: ' + this.imageData)
      if (this.type_richmenu <= 7) {
        if (this.sheetrichmenu) {
          // setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            // console.log('obj1')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 370px) !important; background-color: #fdfdfd;'
            // console.log(`${this.chatlogsFlex}`)
          } else {
            // console.log('obj2')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 370px) !important; background-image: url(' + this.imageData + ');'
          }
        } else {
          if (this.imageData === '') {
            // console.log('obj3')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-color: #fdfdfd;'
          } else {
            // console.log('obj4')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-image: url(' + this.imageData + ');'
          }
        }
      } else {
        if (this.sheetrichmenu) {
          // setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 245px) !important; background-color: #fdfdfd;'
          } else {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 245px) !important; background-image: url(' + this.imageData + ');'
          }
        } else {
          if (this.imageData === '') {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 120px) !important; background-color: #fdfdfd;'
          } else {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 120px) !important; background-image: url(' + this.imageData + ');'
          }
        }
      }
    },
    sheetsticker () {
      // if (this.sheetsticker === true) {
      //   this.chatlogsFlex = 'height:25vh !important;'
      // } else {
      //   this.chatlogsFlex = 'height:100% !important;'
      // }
      if (this.sheetsticker) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');'
        }
      } else {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');'
        }
      }
    },
    sheetother () {
      // if (this.sheetother === true) {
      //   this.chatlogsFlex = 'height:25vh !important;'
      // } else {
      //   this.chatlogsFlex = 'height:100% !important;'
      // }
      // console.log(this.$vssHeight)
      if (this.sheetother) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');'
        }
      } else {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');'
        }
      }
    },
    expansion_announce () {
      // console.log(this.expansion_announce)
      // if (this.expansion_announce === true) {
      //   this.chatlogsFlex = 'height: 35% !important;'
      // } else {
      //   this.chatlogsFlex = 'height: 90% !important;'
      // }
    },
    // listannounce () {
    //   if (this.listannounce.length !== 0) {
    //     this.chatlogsFlex = 'height:90% !important;'
    //   } else {
    //     this.chatlogsFlex = 'height:100% !important;'
    //   }
    // },
    sheetForward () {
      // if (this.sheetForward === true) {
      //   this.chatlogsFlex = 'height:25vh !important;'
      // } else {
      //   this.chatlogsFlex = 'height:100% !important;'
      // }
      if (this.sheetForward) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');'
        }
      } else {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');'
        }
      }
    },
    sheetmap () {
      // if (this.sheetmap === true) {
      //   this.chatlogsFlex = 'height:25vh !important;'
      // } else {
      //   this.chatlogsFlex = 'height:100% !important'
      // }
      if (this.sheetmap) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: 25vh !important; background-image: url(' + this.imageData + ');'
        }
      } else {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-color: #fdfdfd;'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: ' + this.box_height + 'px !important; background-image: url(' + this.imageData + ');'
        }
      }
    },
    myprofile () {
      this.profile = localStorage.getItem('profilepicture')
    },
    layout () {
      this.tokenrooomSelect = this.$route.params.roomid
    },
    '$route.params.roomid' () {
      this.less = false
      this.scrollMaxOldSet()
      this.statusload = false
      this.selected = false
      this.selectedmessage = []
      var container = this.$el.querySelector('#myscroll')
      container.scrollTop = container.scrollHeight
      this.tokenrooomSelect = this.$route.params.roomid
      this.items = []
      this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // this.get_list_richmenu(this.$route.params.roomid)
      this.getdataroom()
      this.getlistannounce()
      this.getOldMessageFirst('')
      this.getreply()
      var announce = this.$cookie.get(this.$route.params.roomid)
      // console.log(announce)
      if(announce !== null) {
        this.less = true
      }
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
      // console.log(this.chat_wallpaper)
      var room = this.tokenrooomSelect
      var index = _.findIndex(this.chat_wallpaper.info, function(o) { return o.room === room })
      // console.log(index)
      if (index === -1) {
        this.imageData = ''
      } else {
        this.imageData = this.chat_wallpaper.info[index].background
      }
    },
    // socket_update_agora (data) {
    //   console.log(`update agora`)
    //   // console.log(data)
    //   if (data.status === 'end' || data.status === 'cancel') {
    //     this.infor_call = {}
    //     this.AgoraCallDialog = false
    //     var index = _.findIndex(this.items, function(o) { return o.tokenmessage === data.tokenmessage })
    //     if (index !== -1) {
    //       this.items[index].time = data.time
    //       this.items[index].message = data.status
    //     }
    //   }
    // },
    socketmessage () {
      this.getMessageSocket(this.socketmessage)
      // this.getreply()
      // this.Quickreply = []
    },
    // socketinvite_group () {
    //   this.getMessageSocket(this.socketinvite_group)
    // },
    sendmsg () {
      if (event.keyCode === 13 && event.shiftKey) {
        if (event.type === 'keypress') {
          this.pasteIntoInput(this, '\n')
        }
        event.preventDefault()
      } else if (event.keyCode === 13) {
        if (event.type === 'keypress') {
          this.pasteIntoInput(this, '')
        }
        event.preventDefault()
      }
    }
  },
  created () {
    this.innerHeight = window.innerHeight
    // this.innerHeight = (window.innerHeight - ((34.0 + 40.0 + 82.0) - 10.0))
    this.gotoTokenmessage = this.$route.query.tokenmessage
    // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
    // this.box_height = (screen.height - 64.0) - 128.0 - 35.0
    this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
    // console.log(this.box_height)
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.tokenrooomSelect = this.$route.params.roomid
    this.profile = localStorage.getItem('profilepicture')
    this.typeuser = localStorage.getItem('type_user')
    this.business_id = localStorage.getItem('business_id')
    this.name = localStorage.getItem('name')
    // show download application
    const device = require('current-device').default
    this.deviceos = device.os
    this.snackbar = true
    // this.get_list_richmenu(this.$route.params.roomid)
    // check url redirect room
    this.CheckUrlRoom()
    this.getOldMessageFirst('')
    this.getreply()
    this.getdataroom()
    this.getlistannounce()
    this.get_oneid()
    this.axios.post(process.env.APIimage + '/sticker/gettitleallsticker', {tokenuser: this.token}).then((responsed) => {
      this.sticker = responsed.data['data']
    })
    var announce = this.$cookie.get(this.$route.params.roomid)
    if(announce !== null) {
      this.less = true
    }
    this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
    // console.log(this.chat_wallpaper)
    var room = this.tokenrooomSelect
    var index = _.findIndex(this.chat_wallpaper.info, function(o) { return o.room === room })
    // console.log(index)
    if (index === -1) {
      this.imageData = ''
    } else {
      this.imageData = this.chat_wallpaper.info[index].background
    }
    this.checkHeightRichmenu()
    // this.hideLayoutChat()
    // var winFeature = 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
    // window.open('', 'null', winFeature)
    // document.body.requestFullscreen()
  },
  methods: {
    handleDocumentRender() {
     // this.isLoading = false
     this.pageCount = this.$refs.myPdfComponent.pageCount
   },
   handlePasswordRequest(callback, retry) {
     callback(prompt(retry
       ? 'Enter password again'
       : 'This document is password protected. Please enter a password.'
     ))
   },
    passwordPdf (evt, index, item) {
      console.log(evt)
      this.items[index].typeofmessage = 'pdf_password'
    },
    errorPdf (err) {
      console.log(err)
    },
    errorPdfDialog (err) {
      console.log(err)
    },
    closeDialogpassword (value) {
      this.dialogGetPassword = value
    },
    // cancle() {
    //   this.passwordFile = ''
    //   this.dialogGetPassword = false
    // },
    // submitPassword() {
    //   this.progressBtn = true
    //   // console.log(this.passwordFile)
    //   var body = {
    //     tokenmessage: this.tokenmsg_file_pass,
    //     password: this.passwordFile
    //   }
    //   // console.log(body)
    //     this.axios.post(process.env.check_password + '/api/v1/check-password' , body).then((response) => {
    //       console.log(response)
    //       var path = response.data.path
    //       if(response.status == '200'){
    //         this.progressBtn = false
    //         if(response.data.message == 'wrong password'){
    //           this.$swal(this.$t('File.wrongPassword') , '', 'error')
    //         }else if(response.data.status == 'success'){
    //           var message = response.data.path
    //           var filename = response.data.path.split('.')
    //           this.dialogGetPassword = false
    //           this.passwordFile = ''
    //           this.axios.get(response.data.path, {
    //             responseType: 'blob'
    //           }).then((response) => {
    //             if(filename[filename.length - 1] == 'pdf'){
    //               this.zoomPasswordfile(false ,path , this.datafile)
    //             }else{
    //               const url = window.URL.createObjectURL(new Blob([response.data]))
    //               const link = document.createElement('a')
    //               link.href = url
    //               link.setAttribute('download', `${this.name_file_pass}.${filename[filename.length - 1]}`)
    //               document.body.appendChild(link)
    //               link.click()

    //             }
    //           })
    //         }
    //       }else{
    //       }
    //     }).catch((err) =>{
    //       console.log(JSON.stringify(err))
    //         // console.log(...err)
    //         this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
    //         .then((result) => {
    //           if(result){
    //             this.progressBtn = false
    //           }
    //         })

    //     })
    // },
    CheckUrlRoom () {
      if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null && JSON.parse(localStorage.getItem('botid_redirect_url')) !== undefined) {
        var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
        // console.log(data.url)
        var item = {}
        if (data.auth === 'share_token') {
          item = {
            label: '',
            url: data.url,
            size: 'full',
            type: 'webview',
            sign: 'true',
            onechat_token: 'false'
          }
          if (data.url !== undefined && data.url !== 'undefined') {
            this.check_get_accesstoken(item)
          }
        } else {
          item = {
            label: '',
            url: data.url,
            size: 'full',
            type: 'webview',
            sign: 'false',
            onechat_token: 'true'
          }
          if (data.url !== undefined && data.url !== 'undefined') {
            this.check_get_accesstoken(item)
          }
        }
      }
      // หลังเปิด webview ลบค่าตัวแปลที่ใช้เช็ค
      localStorage.removeItem('botid_redirect_url')
    },
    clickReadmore (item) {
      this.detailReadmore = item
      this.dialogReadmore = true
    },
    closeReadmoreDialog (value) {
      this.dialogReadmore = value
    },
    closeCreatemail (value) {
      this.dialogCreatemailMobile = value
    },
    get_oneid () {
      this.axios.get(process.env.APIgo_api + `/v1/getOneID/${this.token}`).then((response) => {
        if (response.data.status === 'success') {
          this.one_id = response.data.one_id
        }
      })
    },
    ans_ekyc (item, quickreply) {
      // console.log(item)
      this.ans_quickreply(item, 'ekyc')
      // console.log(this.one_id)
      this.axios.post(process.env.APIimage + '/api/v1/get_shared_token',
      { user_id: this.one_id }).then((response) => {
        if (response.data.status === 'success') {
          var url = `${process.env.urlEkyc}${response.data.data.shared_token}&bot_id=${quickreply.tokenuser}`
          var infor_webview = {
            label: item.label,
            type: 'ekyc',
            message: item.message,
            payload: '',
            url: url
          }
          // console.log(url)
          // this.official_item = infor_webview
          // this.official_sheet = true
          this.checkBrowser(url, infor_webview)
          // this.clearQuickreply()
        }
      }).catch(error => {
        console.log(error)
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    ans_ekyc_template (item, tokenbot) {
      // console.log(item)
      // console.log(tokenbot)
      this.axios.post(process.env.APIimage + '/api/v1/get_shared_token',
      { user_id: this.one_id }).then((response) => {
        if (response.data.status === 'success') {
          var url = `${process.env.urlEkyc}${response.data.data.shared_token}&bot_id=${tokenbot}`
          var infor_webview = {
            label: item.label,
            type: 'ekyc',
            message: item.message,
            payload: '',
            url: url
          }
          this.checkBrowser(url, infor_webview)
        }
      }).catch(error => {
        console.log(error)
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    handleClickTest(e){
      // console.log(e)
      const username = e.target.innerHTML.substring(1)
      // console.log(e.target.innerHTML.substring(1))
      const myUser = localStorage.name
      if(username != myUser){
        // const item = this.listfriend.filter(friend =>
        //   friend.name.toLowerCase().includes(username.toLowerCase())
        // )
        // console.log(item)
        // const tokenUser = item[0].tokenuser
        // this.detailFriend(tokenUser)
            this.listfriend.forEach(freind =>{
              const rex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug;
              var x = username.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
              var y = freind.name.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)

              if(x.includes(y)){
                // console.log(freind)
                const tokenUser = freind.tokenuser
                this.detailFriend(tokenUser)
              }
          })
      }else{
        var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
        this.detailFriend(decoded.tokenuser)
      }
    },
    convertMentionAnnounce(msg){
      msg = msg.replace(/\<tax>/g,'<span style="color:white;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    convertMention (msg) {
      msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2; cursor:pointer;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    tagFriend (nametag) {
      this.status_tag = false
      // console.log('tag')
      if(this.text_search == ''){
        this.sendmsg = this.sendmsg + nametag + " "
      }else{
        if(nametag.toLowerCase().includes(this.text_search)){
          // console.log()
          this.sendmsg = this.sendmsg.replace(this.text_search , nametag)
        }
      }

      // this.sendmsg = this.sendmsg + nametag + " "
      this.$refs.textareaChat.focus()
    },
    filterlistfriend () {
      if (this.showmention === false && this.infofriend.type === 'group') {
        // const sectionMsg = this.sendmsg.split(' ')
        // const lastSection = sectionMsg[sectionMsg.length - 1]
        // // console.log(lastSection)
        // const isTag = lastSection.charAt(0) === '@'
        // // console.log(isTag)
        // if(lastSection.charAt(0) === '@' && this.listfriend.length > 1){
        //   var textToSearch = lastSection.slice(1)
        //   this.listfriend_filter = this.listfriend.filter(friend =>
        //     friend.name.toLowerCase().includes(textToSearch.toLowerCase())
        //   )
        //   this.status_tag = true
        //   // console.log(this.listfriend_filter)
        // } else {
        //   this.status_tag = false
        // }
        const sectionMsg = this.sendmsg.split(' ')
        const lastSection = sectionMsg[sectionMsg.length - 1]
        // console.log(lastSection)
        const isTag = lastSection.charAt(0) === '@'
        // console.log(isTag)
        if(isTag){
          // var textToSearch = lastSection.slice(1)
          this.text_search = lastSection.slice(1)
          this.listfriend_filter = this.listfriend.filter(friend =>
            friend.name.toLowerCase().includes(this.text_search.toLowerCase())
          )
          this.status_tag = true
          // console.log(this.listfriend_filter)
          // console.log(this.status_tag)
        } else {
          this.status_tag = false
        }
      }
    },
    checkHeightRichmenu () {
      // console.log('type_richmenu: ' + this.type_richmenu)
      // console.log('sheetrichmenu: ' + this.sheetrichmenu)
      // console.log('imageData: ' + this.imageData)
      if (this.type_richmenu <= 7) {
        if (this.sheetrichmenu) {
          // setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            // console.log('obj1')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 300px) !important; background-color: #fdfdfd;'
            // console.log(this.chatlogsFlex)
          } else {
            // console.log('obj2')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 300px) !important; background-image: url(' + this.imageData + ');'
          }
        } else {
          if (this.imageData === '') {
            // console.log('obj3')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-color: #fdfdfd;'
          } else {
            // console.log('obj4')
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-image: url(' + this.imageData + ');'
          }
        }
      } else {
        if (this.sheetrichmenu) {
          // setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.box_height + 'px - 120px) !important; background-color: #fdfdfd;'
          } else {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.box_height + 'px - 120px) !important; background-image: url(' + this.imageData + ');'
          }
        } else {
          if (this.imageData === '') {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-color: #fdfdfd;'
          } else {
            // this.chatbox = 'width: 100%; height: calc(100% - 128px); background-color:#eceff1;'
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height: calc(' + this.$vssHeight + 'px - 117px) !important; background-image: url(' + this.imageData + ');'
          }
        }
      }
    },
    openCall (typecall, detailroom) {
      // console.log(detailroom.type)
      var name = ''
      if (detailroom.type === 'group') {
        name = detailroom.group_name
      }
      this.axios.post(process.env.APIimage + '/push_conference', {
        tokenuser: this.token,
        tokenroom: detailroom.tokenroom,
        // room_name: name,
        type_call: typecall
      }).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          window.open(response.data.data.information.urlroom)
        }
      })

      // localStorage.setItem('stateCall', 'true')
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // this.$router.push({
      //   path: '/video_call/' + typecall + '/' + this.room,
      //   force: true
      // })
      // this.$router.push({path: '/video_call/' + this.room, force: true})
    },
    backCall_conference_msg (detail) {
      window.open(detail.urlroom)
    },
    joinCall_conference_msg (detail) {
      // console.log(detail)
      this.axios.post(process.env.APIimage + '/join_room_conference', {
        meetingid: detail.meetingid,
        name: localStorage.getItem('name'),
        option: detail.option,
        key: detail.key
      }).then((response) => {
        if (response.data['status'] === 'success') {
          window.open(response.data.data.urlroom)
        }
      })
    },
    play (e) {
      // console.log(e)
    },
    closedialogQrcode (value) {
      this.dialogQrcodRichMenu = value
    },
    closeCheckBrowser (value) {
      this.checkBrowserDialog = value
      this.checkBrowserInfor = {}
    },
    selectfile_quickreply (item) {
      if (item.type == 'image') {
        $('#uploadpic_quickreply').click()
      } else {
        $('#uploadfile_quickreply').click()
      }
      this.itemdetail_quickreply = item
    },
    // jammmmmmmmmm
    sendlocation_quickreply () {
      // console.log(navigator.geolocation)
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition((position) => {
          // console.log(position.coords.latitude, position.coords.longitude)
          this.send_location(position.coords.latitude, position.coords.longitude, '')
        })
      } else {
        console.log('error geo')
      }
    },
    ocropen (item) {
      $('#uploadpic_ocr').click()
      this.ocr_detailItem = item
    },
    clearImage () {
      $('#uploadpic_ocr').val("")
      $('#uploadpic_quickreply').val("")
    },
    onimgSelected_ocr (data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      // console.log(this.ocr_detailItem)
      var me = this
      var reader = new FileReader();
      reader.readAsDataURL(data.target.files[0])
      reader.onloadend = function() {
        var body = {
          "tokenroom": me.$route.params.roomid,
          "tokenuser": me.token,
          "base64_image": reader.result,
          "multi_select": me.ocr_detailItem.multi_select
        }
        me.dialogWebviewbig_ocr = true
        // me.Webview_item = {url: "https://chat-develop.one.th/ocr_scantext?id=Ua4KAHvPEqd2wOXF28cD9", label: ''}

        me.axios.post('https://l.one.th/onechat-ocr/api/v1/send-ocr-image', body).then((response) => {
          // console.log(response.data.data.link)
          if (response.data.message === 'success') {
            // me.dialogWebviewbig = true
            me.Webview_item_ocr = {url: response.data.data.link, label: ''}
            me.clearQuickreply()
          }
        }, () => {
          me.$swal('Upload image fail', this.$t('Alert.Fail.Chat.uploadPic'), 'warning')
          // this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    onimgSelected_quickreply (data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenroom', this.$route.params.roomid)
      uploadFile.append('tokenuser', this.token)
      uploadFile.append('type_reply', this.itemdetail_quickreply.type)
      uploadFile.append('info_data', this.itemdetail_quickreply.payload)
      this.axios.post(process.env.APIalpine + '/api/v1/answer_quickreply', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          if (_.find(this.items, function(o) {
              return o.tokenmessage === response.data.data.tokenmessage
            }) === undefined) {
            // this.socketupdate_img = response.data.data
            // response.data.data.status = 'success'
            this.items.push(response.data.data)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function(dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
            document.querySelector('#uploadfile_quickreply').value = ''
            document.querySelector('#uploadpic_quickreply').value = ''
          }
          setTimeout(this.scrollDown, 1)
        } else {}
      }, (error) => {
        console.log(error)
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    btn_answer_carousel (item) {
      // console.log(item)
      // if (item.type === 'text' || item.type === 'postback') {
      //   this.ans_carousel(item)
      // } else if (item.type === 'webview' || item.type === 'link') {
      //   var infor = {
      //     sign: item.sign,
      //     url: item.action,
      //     type: item.type,
      //     label: item.button,
      //     onechat_token: item.onechat_token,
      //     size: 'full'
      //   }
      //   this.check_get_accesstoken(infor)
      // }
      if (item.type === 'webview' || item.type === 'link') {
        var infor = {
          sign: item.sign,
          url: item.action,
          type: item.type,
          label: item.button,
          onechat_token: item.onechat_token,
          payload: item.payload,
          size: 'full'
        }
        this.check_get_accesstoken(infor)
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      } else {
        this.ans_carousel(item)
      }
    },
    ans_carousel (item) {
      var payload = ''
      if (item.payload !== undefined) {
        payload = item.payload
      }
      var body = {
        tokenuser: this.token,
        tokenroom: this.tokenrooomSelect,
        action: item.action,
        type: item.type,
        payload: payload
      }
      // console.log(body)
      this.axios.post(process.env.APIalpine + '/api/v1/ansCarousel', body).then((response) => {
        // console.log(response.data)
      }).catch(error => {
        console.log(error)
      })
    },
    hideLayout () {
      window.addEventListener('load',function() {
        setTimeout(function() {
          // This hides the address bar:
          window.scrollTo(0, 1)
        }, 0)
      })
    },
    hideLayoutChat () {
      // console.log('fullscreen')
      alert('fullscreen')
      // var container = document.getElementById('container')
      // container.requestFullscreen()
      // document.body.requestFullscreen()
      document.body.webkitRequestFullScreen()
      // document.webkitCancelFullScreen()
    },
    gotoMessage (token) {
      // console.log('gotoMessage')
      // this.$route.query.tokenmessage
      // console.log(token)
      if (token) {
        var myElement = document.getElementById(token)
        // console.log(token)
        // console.log(myElement)
        // this.gotoTokenmessage = ''
        // if (myElement != null) {
        // this.$nextTick(() => {
        if (myElement) {
          // console.log('scrollIntoView')
          myElement.scrollIntoView({duration: true, behavior: 'smooth', block: 'end', queue: false, specialEasing: null})
          window.location.hash = token
          myElement.setAttribute('tabindex', '-1')
          myElement.removeAttribute('tabindex')
          this.gotoTokenmessage = ''
        }
      }
    },
    downloadios () {
      // window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus()
    },
    downloadandroid () {
      window.open('https://qrcode.chat.one.th/api/v1/go-to-onechat').focus()
      // window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
    },
    closedownload () {
      this.snackbar = false
    },
    emitrichmenu (item) {
      // console.log(item)
      // this.sheetrichmenu = false
      // this.RichmenuState = false
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)

      var expireddate = Date.parse(today)
      var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
      // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
      // var weburl = item.url + url
      var url = ''
      if (_.includes(item.url, ['?'])) {
        url = '&'
      } else {
        url = '?'
      }
      var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

      if (item.type === 'text') {
        this.sendMessage(item.message)
      } else if (item.type === 'link') {
        if (item.sign_share === 'true') {
          this.getSign(item.url, item, this.bot_id_richmenu)
        } else if (item.sign === 'true') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        }
         else {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item)
        }
      } else if (item.type === 'webview') {
        if (item.sign_share === 'true') {
          this.getSign(item.url, item, this.bot_id_richmenu)
        } else if (item.sign === 'true') {
          var infor_webview = {
            message: item.message,
            picture: item.picture,
            sign: item.sign,
            size: item.size,
            type: item.type,
            url: weburl
          }
          this.official_item = infor_webview
          this.official_sheet = true
        } else {
          this.official_item = item
          this.official_sheet = true
        }
      }  else if (item.type === 'link_market') {
        // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')

      } else if (item.type === 'location') {
        // console.log('rich menu type location')
        this.sendlocation_quickreply()
      } else if (item.type === 'qrcode' && item.location_status === 'false') {
        // console.log('rich menu type qrcode')
        this.dialogQrcodRichMenu = true
        this.QrcodeInfor = { status: item.location_status, lat: '', lng: '', address: '' }
      } else if (item.type === 'qrcode' && item.location_status === 'true') {
        // console.log('rich menu qrcode location')
        this.dialogQrcodRichMenu = true
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition((position) => {
            this.QrcodeInfor = { status: item.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: '' }
          })
        } else {
          console.log('error geo')
          this.QrcodeInfor = { status: item.location_status, lat: '', lng: '', address: '' }
        }
      }
    },
    chsheetrichmenu () {
      this.RichmenuState = true
      // console.log(this.RichmenuState)
    },
    checkBrowser (url, item) {
      // console.log(item)
      if (_.includes(url, `${process.env.APIQRcode}/qrcode/friend?id=`)) {
        var link = _.split(url, '?id=', 2)
        // console.log(link[1])
        // console.log(atob(link[1]))
        this.detailFriend(atob(link[1]))
      } else {
        // Get the user-agent string
        let userAgentString = navigator.userAgent;
        // Detect Chrome
        let chromeAgent = userAgentString.indexOf("Chrome") > -1;
        // Detect Internet Explorer
        let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
        // Detect Firefox
        let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        // Detect Safari
        let safariAgent = userAgentString.indexOf("Safari") > -1;
        // Discard Safari since it also matches Chrome
        let operaAgent = userAgentString.indexOf("OP") > -1;
         if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
           if (item.payload !== undefined && item.payload !== null) {
             if (item.payload.news_id !== undefined) {
               this.checkBrowserInfor = {
                 url: url,
                 payload: item.payload
               }
               this.checkBrowserDialog = true
             } else {
               this.checkBrowserInfor = {
                 url: url
               }
               this.checkBrowserDialog = true
             }
           } else {
             this.checkBrowserInfor = {
               url: url,
               payload: ''
             }
             this.checkBrowserDialog = true
           }
          // this.checkBrowserDialog = true
         } else if (safariAgent === true && chromeAgent === true) {
            //  console.log('savelog')
             window.open(url, '_blank')
             if (item.payload !== undefined && item.payload !== null) {
               if (item.payload.news_id !== undefined) {
                 this.saveLogNews(item)
               }
             }
         } else if (safariAgent === true) {
           // this.checkBrowserInfor =
           if (item.payload !== undefined && item.payload !== null) {
             if (item.payload.news_id !== undefined) {
               this.checkBrowserInfor = {
                 url: url,
                 payload: item.payload
               }
               this.checkBrowserDialog = true
             } else {
               this.checkBrowserInfor = {
                 url: url
               }
               this.checkBrowserDialog = true
             }
           } else {
             this.checkBrowserInfor = {
               url: url,
               payload: ''
             }
             this.checkBrowserDialog = true
           }
           // this.checkBrowserDialog = true
        } else {
          // console.log('savelog')
          window.open(url, '_blank')
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item)
            }
          }
        }
      }
    },
    clearQuickreply () {
      if (this.Quickreply.length !== 0) {
        if (this.Quickreply.timestamp < this.items[this.items.length - 1].timestamp) {
          this.Quickreply = []
        }
      }
    },
    closeDialog_official () {
      this.official_sheet = false
      this.official_item = {}
      this.closewebview_webhook()
    },
    newtab () {
      // this.Webview_item.url
      window.open(this.official_item.url, '_blank')
      this.official_sheet = false
    },
    btn_official_template(item, tokenuserBot, tokenmessage) {
      if (item.sign == 'true' && item.type !== 'text') {
        // this.getSign(item.url, item, tokenuserBot)
        var body = {
         "tokenuser": this.token,
         "url": item.url
        }
        this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
          var new_url = ''
          new_url = response.data.data.url
          // item.url = response.data.data.url
          if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
            // window.open(new_url, '_blank')
            // window.location.assign(new_url)
            this.checkBrowser(new_url, item)
          } else if (item.type === 'webview') {
            this.official_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            }
            this.official_sheet = true
          } else if (item.type === 'link_market') {
            // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
            this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
          }
        }, (error) => {
          console.log(erorr)
        })
      } else if (item.onechat_token === 'true' && item.type !== 'text') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)
        var expireddate = Date.parse(today)
        var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        } else if (item.type === 'webview') {
          this.official_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.official_sheet = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      } else {
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item)
        } else if (item.type === 'webview') {
          this.official_item = item
          this.official_sheet = true
        } else if (item.type === 'text') {
          this.ans_question(item, tokenmessage, tokenuserBot)
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      }
    },
    btn_img_official_template (item, tokenuserBot) {
      if (item.sign === 'true') {
        this.getSignImg(item.url, item, tokenuserBot)
      } else if (item.onechat_token === 'true') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)
        var expireddate = Date.parse(today)
        var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        } else if (item.type === 'webview') {
          this.official_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.official_sheet = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      } else {
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item)
        } else if (item.type === 'webview') {
          this.official_item = item
          this.official_sheet = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      }
    },
    getSign (url, item, tokenuserBot) {
      var body = {
       "tokenuser": this.token,
       "url": url
      }
      this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
        var new_url = ''
        new_url = response.data.data.url
        // item.url = response.data.data.url
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(new_url, '_blank')
          // window.location.assign(new_url)
          this.checkBrowser(new_url, item)
        } else if (item.type === 'webview') {
          this.official_item = {
            label: item.label,
            url: new_url,
            size: item.size,
            type: item.type
          }
          // console.log(this.official_item)
          this.official_sheet = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      }, (error) => {
        console.log(erorr)
      })
    },
    getSignImg (url,item, tokenuserBot) {
      var body = {
       "tokenuser": this.token,
       "url": url
      }
      this.axios.post(process.env.APIpub + '/old/api/v1/getAccesstoken', body).then((response) => {
        // item.url = response.data.data.url
        var new_url = ''
        new_url = response.data.data.url
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(new_url, '_blank')
          this.checkBrowser(new_url, item)
        } else if (item.type === 'webview') {
          this.official_item = {
            label: item.label,
            url: new_url,
            size: item.size,
            type: item.type
          }
          this.official_sheet = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      }, () => {})
    },
    checkbutton (color, bng) {
      var  text = {
        'text-transform': 'none',
        'width': '100%',
        'margin': '0',
        'font-size': '13px',
        'border-radius': '20px'
      }
      // [choice.color]? ('color': choice.color):('color':'black')
      if (color) {
        text['color']= color
      } else {
        text['color']= 'black'
      }
      if (bng) {
        text['background']= bng
      } else {
        text['background']= 'none'
      }
      return text
    },
    closeDetailTask (value) {
      this.dialogDetailTask = value
    },
    open_detail_task (taskid, tokenroom) {
      this.taskid = taskid
      this.roomid = tokenroom
      this.dialogDetailTask = true
    },
    checkuserinassign (item) {
      var tokenuser = this.token
      var index = _.findIndex(item, function (o) { return o.tokenuser === tokenuser })
      if (index >= 0) {
        return true
      } else {
        return false
      }
    },
    SelectMenuRightClick (selected) {
      // console.log(selected)
      if (selected == 'add_albums') {
        this.add_image_albums()
      } else if (selected == 'mention') {
        this.mention_message()
      } else if (selected == 'cancel') {
        this.unsendmessage()
      } else if (selected == 'sendmail') {
         this.sendemail()
      } else if (selected == 'announce') {
        this.announce_msg()
      } else if (selected == 'cancel_announce') {
        this.cancel_announce()
      }
    },
    RightClickDialog ($event, list, item) {
      // console.log(item)
      this.ListMenuRightClick = []
      if (this.statemember === 'active') {
        if (list.includes("albums")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.addImageAlbum'), methods:'add_albums'})
        }
        if (list.includes("mention")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.mention'), methods:'mention'})
        }
        if (list.includes("sendmail")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.sendmail'), methods:'sendmail'})
        }
        if (list.includes("cancel")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.cancelMsg'), methods:'cancel'})
        }
        if (list.includes("announce")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.announce'), methods:'announce'})
        }
        if (list.includes("cancel_announce")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.cancelAnnounce'), methods:'cancel_announce'})
        }
        this.rightclickdialog = true
        this.$refs.menucontext.open($event)
        this.SelectedMessageDetail = item
        // console.log(this.rightclickdialog)
        // console.log(this.ListMenuRightClick)
      }
    },
    announce_dialog (item) {
      this.announcedialog = true
      this.announce_message = item
      // console.log(this.announcedialog)
      // console.log(this.announce_message)
    },
    cancel_announce () {
      this.announcedialog = false
      this.rightclickdialog = false
      var token_announce = this.announce_message._id
      this.$swal({
        text: this.$t('Alert.Chat.announce.cancel'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/v1/user/disable_single_announce_room', {
          tokenuser: this.token,
          tokenroom: this.tokenrooomSelect,
          token_announce: token_announce}).then((responsed) => {
            if (responsed.data.status == 'success') {
              var index = _.findIndex(this.listannounce, function (o) { return o._id === token_announce })
              if (index >= 0) {
                this.listannounce.splice(index, 1)
              }
            } else {
              this.listannounce = []
            }
          })
        }
      })
    },
    delete_announce () {
      this.$swal({
        text: this.$t('Alert.Chat.announce.deleteAll'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/v1/user/disable_announce_room', {tokenuser: this.token, tokenroom: this.tokenrooomSelect}).then((responsed) => {
            if (responsed.data.status == 'success') {
              this.listannounce = []
            } else {
            }
          })
        }
      })
    },
    getlistannounce () {
      this.axios.post(process.env.APIpub + '/v1/user/get_announce_room', {tokenuser: this.token, tokenroom: this.tokenrooomSelect}).then((responsed) => {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          this.listannounce = responsed.data.data
          // this.listannounce = _.sortBy(this.listannouncee, function (dateObj) {
          //   return new Date(dateObj.timestamp)
          // }).reverse()
          this.listannounce = _.reverse(this.listannounce)
          // if (this.listannounce.length !== 0) {
          //   this.expansion_announce = true
          // } else {
          //   this.expansion_announce = false
          // }
          // this.listannounce = _.unionBy(this.listannounce, '_id')
          // console.log(this.listannounce)
        } else {
          this.listannounce = []
        }
      })
    },
    add_image_albums () {
      this.dialogAddImage = true
      this.unsenddialog = false
      this.settingdialog = false
      this.forwarddialog = false
      this.imagealbumsdialog = false
      this.forwardimagedialog = false
    },
    closeAlbums(value) {
      this.dialogAlbums = value
    },
    closeAddImage(value) {
      this.dialogAddImage = value
    },
    detailAlbums(id) {
      // console.log(id)
      this.dialogAlbums = true
      this.albums_id = id
    },
    open (typecall, detailroom) {
      // console.log(detailroom)
      localStorage.setItem('stateCall', 'true')
      localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // window.open('/video_call/' + typecall + '/' + this.room, '_blank').focus()
      this.$router.push({path: '/video_callmo/' + typecall + '/' + this.tokenrooomSelect, force: true})
      // this.$router.push({path: '/video_call/' + this.room, force: true})
    },
    closeshow () {
      this.showphone = false
    },
    secondsToHms (d) {
      d = Number(d)
      var hours = Math.floor(d / 3600)
      var minutes = Math.floor((d - (hours * 3600)) / 60)
      var seconds = d - (hours * 3600) - (minutes * 60)
      var time = ''

      if (hours !== 0) {
        time = hours + ':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
        time += minutes + ':'
      }
      if (time === '') {
        time = seconds + 's'
      } else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    checktypeCall (call) {
      if (call === 'cancel') {
        return this.$t('AnswerQuestion.cancel')
      } else if (call === 'decline') {
        return this.$t('LeftSide.chat.call.missed')
      } else if (call === 'end') {
        return this.$t('LeftSide.chat.call.end')
      } else {
        return ''
      }
    },
    setting_dialog (item, type) {
      if (this.statemember === 'active') {
        if (item.type !== 'bot') {
          this.SelectedMessageDetail = item
          if(item.typeofmessage == 'file' || item.typeofmessage == 'pdf_password') {
            if(type == 'download'){
              this.loadfile(item)
            }else{
              var file_split = item.message.split('.')
              var type_file = file_split[file_split.length - 1]

              if (type_file == 'pdf') {
                this.settingdialog = true
                this.temp = [item.tokenmessage]
                this.unsenddetail = item
                this.mentiondetail = item
                this.path_pic_albums = item.message
                this.file_name = item.file_name
                this.announce_message = item
              } else {
                this.temp = [item.tokenmessage]
                this.unsenddetail = item
                this.mentiondetail = item
                this.path_pic_albums = item.message
                this.file_name = item.file_name
                this.announce_message = item
              }

            }
          }else if(item.typeofmessage == 'video'){
            if( type == 'download'){
              this.loadfile(item)
            }
          }else{
            if (type === 'forwardunsend') {
            this.settingdialog = true
            this.temp = [item.tokenmessage]
            this.unsenddetail = item
            this.mentiondetail = item
            this.path_pic_albums = item.message
            this.file_name = item.file_name
            this.announce_message = item
          } else if (type === 'forward') {
            this.forwarddialog = true
            this.temp = [item.tokenmessage]
            this.mentiondetail = item
            this.announce_message = item
            this.path_pic_albums = item.message
            this.file_name = item.file_name
          } else if (type === 'unsend') {
            this.unsenddialog = true
            this.unsenddetail = item
            this.mentiondetail = item
            this.path_pic_albums = item.message
            this.file_name = item.file_name
          } else if (type === 'mention') {
            this.mentiondialog = true
            this.mentiondetail = item
            this.path_pic_albums = item.message
            this.file_name = item.file_name
          } else if (type === 'addimage') {
            this.imagealbumsdialog = true
            this.mentiondetail = item
            this.unsenddetail = item
            this.path_pic_albums = item.message
            this.file_name = item.file_name
            this.temp = [item.tokenmessage]
          } else if (type === 'forwardimagedialog') {
            this.forwardimagedialog = true
            this.mentiondetail = item
            this.unsenddetail = item
            this.path_pic_albums = item.message
            this.file_name = item.file_name
            this.temp = [item.tokenmessage]
          }
          }
        } else {
          this.bot_dialog_message = true
          this.temp = [item.tokenmessage]
          this.mentiondetail = item
          this.announce_message = item
          if (item.typeofmessage === 'password_file') {
            this.DetailFile = item
          }
          // this.DetailFile = item
          this.path_pic_albums = item.message
          this.file_name = item.file_name
          this.SelectedMessageDetail = item
          if (item.typeofmessage === 'message') {
            this.bot_dialog_list.push(
              { message: this.$t('ChatSide.RightClickMenu.announce'), methods: 'announce' },
              { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' }
            )
          } else if (item.typeofmessage === 'image') {
            this.bot_dialog_list.push(
              { message: this.$t('ChatSide.RightClickMenu.openimage'), methods: 'image' },
              { message: this.$t('ChatSide.RightClickMenu.addImageAlbum'), methods: 'addimage' },
              { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
              { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' }
            )
          } else if (item.typeofmessage === 'video') {
            this.bot_dialog_list.push(
              // { message: this.$t('ChatSide.RightClickMenu.openimage'), methods: 'image' },
              { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' }
            )
          } else if (item.typeofmessage === 'file' || item.typeofmessage === 'pdf_password' && this.extension(item.file_name) === 'pdf') {
            this.bot_dialog_list.push(
              { message: this.$t('ChatSide.RightClickMenu.openfile'), methods: 'file' },
              { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
              { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' }
            )
          } else if (item.typeofmessage === 'file' && this.extension(item.file_name) !== 'pdf') {
            if (type === 'download') {

              this.loadfile(item)
            } else {
              this.bot_dialog_list.push(
                { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
                { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' }
              )
            }
          } else if (item.typeofmessage === 'location') {
            this.bot_dialog_list.push(
              { message: this.$t('ChatSide.RightClickMenu.openlocation'), methods: 'location' },
              { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' }
            )
          } else if (item.typeofmessage === 'sticker') {
            this.bot_dialog_list = []
            this.bot_dialog_message = false
          } else if (item.typeofmessage === 'password_file') {
              this.datafile = item
              this.checkPasswordfile = item.typeofmessage
              this.tokenmsg_file_pass = item.tokenmessage
              this.name_file_pass = item.file_name
              this.filetype = this.extension(item.file_name)
              // console.log('filetype' , this.filetype)
              if(this.filetype == 'pdf' ) {
                this.bot_dialog_list.push(
                  { message: this.$t('ChatSide.RightClickMenu.openfile'), methods: 'password_file' },
                  // { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
                  // { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' }
                )
              } else {
                this.bot_dialog_list.push(
                  { message: this.$t('AnswerQuestion.download'), methods: 'password_file' },
                  // { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
                  // { message: this.$t('ChatSide.RightClickMenu.sendmail'), methods: 'sendmail' }
                )
              }
          } else {
            this.bot_dialog_list.push(
              { message: this.$t('ChatSide.RightClickMenu.forward'), methods: 'forward' },
              // { message: this.$t('ChatSide.RightClickMenu.openfile'), methods: 'password_file' }
            )
          }
          // console.log(this.bot_dialog_list)
        }

      }
    },
    SelectBotMessage (type) {
      console.log(type)
      if (type === 'announce') {
        this.announce_msg()
      } else if (type === 'forward') {
        this.farwardmessage()
      } else if (type === 'addimage') {
        this.add_image_albums()
      } else if (type === 'image') {
        this.zoom()
      } else if (type === 'file') {
        this.zoomfile()
      }
       else if (type === 'loadfile') {
        this.loadfile(this.loadfileData)
        this.loadfileData = ''
      }
       else if (type === 'location') {
        this.openlocation(this.mentiondetail)
      } else if (type === 'sendmail') {
        // console.log('send mail')
        this.dialogCreatemailMobile = true
        this.settingdialog = false
        this.forwarddialog = false
        this.unsenddialog = false
        this.forwardimagedialog = false
        this.imagealbumsdialog = false
      }
      else if (type === 'password_file') {
        // console.log('send mail')
        this.dialogGetPassword = true
        this.dialogCreatemailMobile = false
        this.settingdialog = false
        this.forwarddialog = false
        this.unsenddialog = false
        this.forwardimagedialog = false
        this.imagealbumsdialog = false
      }
      this.bot_dialog_message = false
    },
    farwardmessage () {
      this.selected = true
      this.settingdialog = false
      this.forwarddialog = false
      this.forwardimagedialog = false
      this.imagealbumsdialog = false
      this.selectedmessage = this.temp
    },
    announce_msg () {
      this.forwarddialog = false
      this.settingdialog = false
      this.axios.post(process.env.APIpub + '/v1/user/announce_room', {
        tokenuser: this.token,
        tokenmessage: this.announce_message.tokenmessage,
        tokenroom: this.announce_message.tokenroom
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.$swal(
            '',
            this.$t('Alert.Success.announce'),
            'success'
          )
        }
        this.show = false
      })
    },
    mention_message () {
      // console.log(this.mentiondetail)
      if (this.mentiondetail.path_pic === undefined) {
        this.mentionpathpic = localStorage.getItem('profilepicture')
      } else {
        this.mentionpathpic = this.mentiondetail.path_pic
      }
      this.settingdialog = false
      this.unsenddialog = false
      this.forwarddialog = false
      this.mentiondialog = false
      this.forwardimagedialog = false
      this.imagealbumsdialog = false
      this.showmention = true
      this.mentionname = this.mentiondetail.nickname
      this.mentionimage = this.mentiondetail.file_name
      this.mentionmessage = this.mentiondetail.message
      this.mentiontypemsg = this.mentiondetail.typeofmessage
    },
    closemention () {
      this.showmention = false
      this.mentionname = ''
      this.mentionimage = ''
      this.mentionpathpic = ''
      this.mentionmessage = ''
      this.mentiontypemsg = ''
    },
    unsendmessage () {
      this.settingdialog = false
      this.unsenddialog = false
      this.forwardimagedialog = false
      this.imagealbumsdialog = false
      this.$swal({
        text: this.$t('Alert.Chat.unsent'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIimage + '/delete_message', {tokenuser: this.token, tokenmessage: this.unsenddetail.tokenmessage}).then((response) => {
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.unsent'),
                'success'
              )
            }
          })
        }
      })
    },
    sendansApprove (item, tokenmessage) {
      var body = { tokenmessage: tokenmessage, tokenuser: this.token, answer: item }
      var indexid = _.findIndex(this.items, function (o) { return o.tokenmessage === tokenmessage && o.typeofmessage === 'approve_message' })
      this.items[indexid].disable = 'true'
      this.axios.post(process.env.APIimage + '/answer_approve', body).then((response) => {
        // console.log(response.data)
        if (_.find(this.items, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
          this.items.push(response.data.data)
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
        }
        setTimeout(this.scrollDown, 1)
      }, () => {
      })
    },
    openapprove (item) {
      this.ApproveDetail = item
      this.dialogApprove = true
    },
    initmapShow () {
      this.map = new longdo.Map({
        placeholder: document.getElementById('map'),
        lastView: true
      })
      this.map.Ui.Keyboard.enable(true)
      var control3 = new longdo.TagPanel()
      this.map.Ui.add(control3)
      // this.map.Ui.Crosshair.visible(false)
      this.map.Ui.LayerSelector.visible(false)
      var location = this.locationName.message.split(',')
      var marker = new longdo.Marker({lat: location[0], lon: location[1]}, {
        icon: {
          url: '../../../../static/img/icons/pin.png',
          offset: { x: this.x, y: this.y }
        },
        clickable: true
      })
      this.map.Overlays.add(marker)
      // this.GeometryOptions()
      // console.log(parseFloat(location[0]) - 1)
      // console.log(parseFloat(location[0]) + 1)
      this.map.bound({
        minLon: parseFloat(location[0]) - 1,
        minLat: parseFloat(location[1]) - 1,
        maxLon: parseFloat(location[0]) + 1,
        maxLat: parseFloat(location[1]) + 1
      }, {
        lat: location[0],
        lon: location[1]
      })
      // this.showloc = this.map.bound()
      this.map.zoom(15, true)
      // longdo.Search(this.map, true)
    },
    openlocation (item) {
      // console.log(item)
      this.sheetother = false
      // this.dialogMap = true
      // this.locationName = item
      window.open('http://maps.google.com/maps?daddr=' + item.message + '&amp;ll=')
      this.forwarddialog = false
      this.settingdialog = false
    },
    send_location (lat, long, address) {
      // console.log(lat, long, address)
      // var textaddress = ''
      // if (address === '') {
      //   textaddress = lat + ',' + long
      // } else {
      //   textaddress = address
      // }
      if (lat !== '' && long !== '') {
        this.axios.post(process.env.APIalpine + '/api/v1/pushLocation', { 'tokenroom': this.$route.params.roomid, 'tokenuser': this.token, 'lat': lat + '', 'long': long + '', 'address': address }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            if (_.find(this.items, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
              response.data.data.status = 'success'
              this.items.push(response.data.data)
              this.clearQuickreply()
              this.items = _.sortBy(this.items, function (dateObj) {
                return new Date(dateObj.timestamp)
              })
              this.items = _.unionBy(this.items, 'tokenmessage')
              this.clearQuickreply()
            }
            setTimeout(this.scrollDown, 1)
          } else {
          }
        }, (error) => {
          console.log(error)
          // this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    openmap () {
      // var myModalMap = document.getElementById('myModalMap')
      // myModalMap.style.display = 'block'
      this.sheetother = false
      // this.dialogMap = true
      this.dialogSendMap = true
    },
    closeSendMap (value) {
      // console.log(value)
      // console.log('closeSendMap')
      this.dialogSendMap = value
    },
    opensheetmap () {
      this.sheetmap = true
      this.initmapShow()
      this.sheetother = false
    },
    closeApprove (value) {
      this.dialogApprove = value
    },
    closewebview () {
      this.sheetwebview = false
      this.Quickreply = ''
      this.Webview_item = {}
      this.dialogWebviewbig_ocr = false
      // console.log(this.sheetwebview)
      this.closewebview_webhook()
    },
    closewebviewmenu () {
      this.sheetwebviewmenu = false
      this.inforwebview = {}
      // console.log(this.sheetwebviewmenu)
      this.closewebview_webhook()
    },
    closewebview_webhook () {
      this.axios.post(process.env.APIalpine + `/api/v1/close-webview`, {
        tokenroom: this.tokenrooomSelect,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data)
      }).catch(error => {
        console.log(error)
      })
    },
    ans_question (item, tokenmessage, tokenbot) {
      // console.log(item)
      this.answerquestion(item, tokenmessage)
      if (item.type === 'link' || item.type === 'webview') {
        this.check_get_accesstoken(item)
      } else if (item.type === 'file') {
        this.downloadFileMenu(item)
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      } else if (item.type === 'ekyc') {
        this.ans_ekyc_template(item, tokenbot)
      }
    },
    answerquestion (item, tokenmessage) {
      if (item.payload === undefined) {
        item.payload = null
      }
      var body = { tokenmessage: tokenmessage, tokenuser: this.token, answer: item }
      this.axios.post(process.env.APIalpine + '/answer_question', body).then((response) => {
        // console.log(response.data)
        if (item.type === 'text') {
          if (_.find(this.items, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
            this.items.push(response.data.data)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function (dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
          }
          setTimeout(this.scrollDown, 1)
        }
      }, () => {
      })
    },
    downloadFileMenu (item) {
      // console.log(item)
      var name = item.file.split('/')[item.file.split('/').length - 1]
      this.axios.get(item.file, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
    saveLogNews (item) {
      // console.log(item)
      this.axios.get(process.env.APIgo_api + '/v1/getOneID/' + this.token).then((response) => {
        var one_id = response.data.one_id
        // console.log(one_id)
        this.axios.post(process.env.Savelognews, {
          'one_id': one_id,
          'news_id': item.payload.news_id,
          'news_index': item.payload.news_index.toString(),
          'page_name': item.payload.page_name
        }).then((response) => {
          // console.log(response)
        }).catch(error => {
          console.log(error)
        })
      }, (error) => {
        console.log(error)
      })
    },
    check_get_accesstoken (item) {
      // console.log(item)
      if (item.sign === 'true') {
        var body = {
         "tokenuser": this.token,
         "url": item.url
        }
        this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
          // console.log(response.data.data)
          var new_url = ''
          new_url = response.data.data.url
          if (item.type === 'link') {
            // item.url = response.data.data.url
            // window.open(new_url, '_blank')
            // window.location.assign(new_url)
            this.checkBrowser(new_url, item)
          } else if (item.type === 'webview') {
            this.inforquickreply = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            }
            // console.log(this.inforquickreply)
            this.sheetwebview = true
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item)
            }
            // console.log(this.inforquickreply)
          }
        }, (error) => {
          console.log(error)
        })
      } else if (item.onechat_token === 'true') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)

        var expireddate = Date.parse(today)
        var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

        if (item.type === 'link') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        } else if (item.type === 'webview') {
          this.inforquickreply = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.sheetwebview = true
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item)
          }
          // console.log(this.inforquickreply)
        }
      } else {
        if (item.type === 'link') {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item)
        } else if (item.type === 'webview') {
          this.inforquickreply = item
          this.sheetwebview = true
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item)
          }
        }
      }
    },
    ans_quickwebview (item) {
      var message = {message: '', payload: ''}
      this.ans_quickreply(message, 'webview')
      // this.sheetwebview = true
      // this.inforquickreply = item
      this.check_get_accesstoken(item)
    },
    ans_quicklink_market (item) {
      var message = {message: '', payload: ''}
      this.ans_quickreply(message, 'link_market')
      // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
      this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      this.Quickreply = ''
    },
    ans_quicklink (item) {
      // console.log(item)
      var message = {message: '', payload: ''}
      this.ans_quickreply(message, 'link')
      // window.open(item.url, '_blank')
      this.check_get_accesstoken(item)
      this.Quickreply = ''
    },
    ans_quickreply (item, type) {
      // console.log(item)
      var body = {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        type_reply: type,
        message: item.message,
        info_data: item.payload
      }
      this.axios.post(process.env.APIimage + '/ans_quickreply', body).then((response) => {
        // console.log(response.data.data)
        if (_.find(this.items, function(o) {
            return o.tokenmessage === response.data.tokenmessage
          }) === undefined) {
          if(response.data.data !== undefined) {
            this.items.push(response.data.data)
          }
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function(dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
        }
        setTimeout(this.scrollDown, 1)
      }, () => {})
    },
    loadpic (filenameSend) {
      // console.log(filenameSend)
      // console.log(this.pathSend)
      this.axios.get(this.pathSend, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    loadfile (item) {
      // console.log(item)
      this.bot_dialog_message = false
      if (this.extension(item.message) === 'media') {
        this.axios.get(item.original_file, { responseType: 'blob' }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.file_name)
          document.body.appendChild(link)
          link.click()
        })
      } else {
        // this.dialogGetPassword = true
        this.axios.get(item.message, { responseType: 'blob' }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.file_name)
          document.body.appendChild(link)
          link.click()
        })
      }
    },
    toPageForward (selectedmessage) {
      this.tokenmsgforward = this.selectedmessage
      this.$router.push('/mobile/forward/' + this.$route.params.roomid)
    },
    clickforward (item) {
      // console.log(item)
      this.selected = true
      // this.selectedmessage = []
      // this.sheetother = false
      this.selectedmessage = [item]
    },
    closeSeleted () {
      this.selected = false
      this.selectedmessage = []
    },
    sendMessages () {
      this.resetIcon()
      this.clearMessage()
    },
    clearMessage () {
      this.message = ''
    },
    resetIcon () {
      this.iconIndex = 0
    },
    changeIcon () {
      this.iconIndex === this.icons.length - 1
        ? this.iconIndex = 0
        : this.iconIndex++
    },
    toPageinfo () {
      this.$emit('profile', true)
      this.selected = false
      this.$router.push('/mobile/room/infor/' + this.$route.params.roomid)
    },
    toPage (data) {
      this.$emit('data', true)
      this.$router.push(data)
      this.selected = false
      // localStorage.setItem('height_center', null)
      localStorage.removeItem('height_center')
    },
    addloc () {
      var loc = this.map.location('POINTER')
      this.locationArray.push(loc)
    },
    getdataroom () {
      this.progressBoxChat = true
      this.axios.post(process.env.APImanage + '/getroom', {tokenuser: this.token, tokenroom: this.$route.params.roomid}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.infofriend = response.data
          this.block = response.data.statemember
          // console.log(this.infofriend)
          var me = this
          this.listfriend = _.filter(response.data.data_room, function(o) { return o.tokenuser !== me.token && o.type === 'user' && o.statemember === 'active' })
          // console.log(this.listfriend)
          this.progressBoxChat = false
          this.statemember = response.data.statemember
          if (this.infofriend.data_room[0].type === 'bot') {
            this.getConsent(response.data.data_room[0].tokenuser, this.$route.params.roomid)
            // this.get_list_richmenu(response.data.data_room[0].tokenuser)
            // state member ต้องเป็น friend และ active ถึงเก็ท richmenu
            if (response.data.statemember === 'friend' || response.data.statemember == 'active') {
              this.get_list_richmenu(response.data.data_room[0].tokenuser)
            } else {
              this.list_richmenu = []
            }
          } else if (response.data.data_room.length == 1 && response.data.data_room[0].type == 'bot') {
            var bot_id = response.data.data_room[0].tokenuser
            // console.log(this.bot_id)
            // state member ต้องเป็น friend และ active ถึงเก็ท richmenu
            if (response.data.statemember === 'friend' || response.data.statemember == 'active') {
              this.get_list_richmenu(bot_id)
            } else {
              this.list_richmenu = []
            }
          }
          // console.log(this.statemember)
        } else {
          this.progressBoxChat = false
        }
      })
    },
    getConsent (botid, tokenroom) {
      this.axios.post(process.env.APIalpine + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = Encode.encode(response.data.data)
            this.$router.push('/check-consent/' + tokenroom + `/?data_consent=${dataConsent}`)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    pin () {
      // this.map.Overlays.clear()
      // var loc = this.map.location('POINTER')
      // console.log(loc)
      // this.showloc = loc
      // var marker = new longdo.Marker(loc, {
      //   icon: {
      //     url: '/static/img/icons/pin.png',
      //     offset: { x: this.x, y: this.y }
      //   },
      //   clickable: true,
      //   weight: longdo.OverlayWeight.Top
      // })
      // this.map.Overlays.add(marker)
      // this.map.Overlays.remove()
      var locat = this.map.location()
      var marker = new longdo.Marker(locat, {
        icon: {
          url: '/static/img/icons/pin.png',
          offset: { x: this.x, y: this.y }
        },
        clickable: true,
        weight: longdo.OverlayWeight.Top
      })
      this.map.Overlays.add(marker)
    },
    senddate () {
      if (this.typepicker === 'datepicker') {
        this.datepicker = false
        this.$swal({
          title: `<div class="CSChatThai">${this.$t('Alert.Chat.sendDatetime')}</div>`,
          html:
          '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + '</div>',
          confirmButtonColor: '#2562af',
          confirmButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.ok')}</div>`,
          cancelButtonColor: '#1b232db3',
          cancelButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.cancel')}</div>`,
          buttonsStyling: true,
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            var item = { message: this.dateselect, payload: this.infodata }
            this.ans_quickreply(item, 'datepicker')
          }
        })
      } else if (this.typepicker === 'datetimepicker') {
        this.datepicker = false
        this.timepicker = true
        if (this.dateselect === this.mindate) {
          this.maxtime = '24:00'
        } else if (this.dateselect === this.maxdate) {
          this.mintime = '00:00'
        } else {
          this.maxtime = '24:00'
          this.mintime = '00:00'
        }
      }
    },
    sendtime () {
      this.$swal({
        title: `<div class="CSChatThai">${this.$t('Alert.Chat.sendDatetime')}</div>`,
        html:
        '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + ' เวลา ' + this.timeselect + '</div>',
        confirmButtonColor: '#2562af',
        confirmButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.ok')}</div>`,
        cancelButtonColor: '#1b232db3',
        cancelButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.cancel')}</div>`,
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var item = { message: this.dateselect + 'T' + this.timeselect, payload: this.infodata }
          this.timepicker = false
          this.ans_quickreply(item, 'datetimepicker')
        }
      })
    },
    setpicker (data) {
      setTimeout(this.scrollDown, 1)
      if (data.type === 'datepicker') {
        this.typepicker = data.type
        this.datepicker = true
        this.maxdate = data.max
        this.mindate = data.min
        this.dateselect = data.initial
        this.infodata = data.payload
      } else if (data.type === 'datetimepicker') {
        this.typepicker = data.type
        this.datepicker = true
        this.maxdate = data.max.split('T')[0]
        this.mindate = data.min.split('T')[0]
        this.maxtime = data.max.split('T')[1]
        this.mintime = data.min.split('T')[1]
        this.dateselect = data.initial.split('T')[0]
        this.timeselect = data.initial.split('T')[1]
        this.infodata = data.payload
      }
      // console.log(data)
    },
    getreply () {
      this.datepicker = false
      this.timepicker = false
      this.maxdate = ''
      this.mindate = ''
      this.maxtime = ''
      this.mintime = ''
      this.dateselect = ''
      this.timeselect = ''
      this.infodata = ''
      this.axios.post(process.env.APIalpine + '/api/v1/get-quickreply', {tokenroom: this.$route.params.roomid, tokenuser: this.token}).then((response) => {
        // console.log(response)
        if (response.data.status === 'success') {
          this.Quickreply = response.data.data
          // setTimeout(this.scrollDown, 1)
          // console.log(this.Quickreply)
        } else {
          // console.log(response.data)
        }
      })
    },
    momentday (data) {
      return Momenttime.momentdatetimethai(data)
    },
    checkShowmessagwBottom (data) {
      var scroll = this.$el.querySelector('#myscroll')
      if (scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0))) {
        // เห็นข้อความแล้ว ไม่ต้องทำอะไร
        setTimeout(this.scrollDown, 1)
      } else {
        // มีปุ่นให้กดเลื่อนลงมา และแสดงข้อความล่างสุด ถ้าเค้ากดปุ่มแล้วปุ่มมายไปเลยย
        this.showmessagebottom = true
        this.chip = true
        this.picturechip = data.path_pic
        if (data.typeofmessage !== 'message') {
          this.showmessage = 'Send ' + data.typeofmessage
        } else {
          this.showmessage = data.message
        }
        // setTimeout(this.scrollDown, 1)
      }
    },
    lookmessage () {
      this.chip = false
      this.showmessagebottom = false
      setTimeout(this.scrollDown, 1)
    },
    closechip () {
      this.chip = false
    },
    scrollFunction () {
      var scroll = this.$el.querySelector('#myscroll')
      // console.log('box_height=> '+ this.box_height)
      // console.log(scroll.scrollTop)
      // console.log(scroll.scrollHeight - this.box_height - 70.0)
      // console.log(scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0)))
      if (scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0))) {
        this.chip = false
        this.showmessagebottom = false
      }
      // if (this.chip) {
      //   if (scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0))) {
      //     // เห็นข้อความแล้ว ไม่ต้องทำอะไร
      //     this.chip = false
      //     this.showmessagebottom = false
      //     // scroll.scrollTop = 0
      //     var scrollMaxNew = scroll.scrollHeight
      //     scroll.scrollTop = scrollMaxNew - this.scrollMaxOld
      //     this.scrollMaxOld = scrollMaxNew
      //     this.scrollval = scroll.scrollTop
      //   }
      // }
    },
    // scrollcheck () {
    //   var scroll = this.$el.querySelector('#myscroll')
    //   if(scroll.scrollTop >= ((scroll.scrollHeight - 492)-100)){
    //     // เห็นข้อความแล้ว ไม่ต้องทำอะไร

    //   } else {
    //     // มีปุ่นให้กดเลื่อนลงมา และแสดงข้อความล่างสุด ถ้าเค้ากดปุ่มแล้วปุ่มมายไปเลยย
    //     setTimeout(this.scrollDown, 1)
    //   }
    //   console.log(this.$el.querySelector('#myscroll').scrollHeight)
    //   console.log(this.$el.querySelector('#myscroll').scrollTop)
    //   // console.log(this.$el.querySelector('#myscroll').scrollMaxOld)
    // },
    chsheetForward () {
      this.sheetForward = !this.sheetForward
    },
    chsheetother () {
      document.getElementById('tabother').click()
      this.sheetother = !this.sheetother
    },
    chsheetsticker () {
      document.getElementById('tabsticker').click()
      this.sheetsticker = !this.sheetsticker
    },
    changelink (path) {
      return path
    },
    pushSticker (stickerid) {
      this.axios.post(process.env.APIimage + '/push_sticker', {tokenroom: this.$route.params.roomid, tokenuser: this.token, message: stickerid, type: this.typeuser, business_id: this.business_id}).then((response) => {
        var messageSendChat = response.data.data
        if (response.data.status === 'success') {
          this.sheetsticker = false
          messageSendChat['status'] = 'success'
          if (_.find(this.items, function (o) { return o.tokenmessage === messageSendChat.tokenmessage }) === undefined) {
            // console.log(messageSendChat)
            this.items.push(messageSendChat)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function (dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
          }
          setTimeout(this.scrollDown, 1)
          // this.sendmsg = ''
        }
      })
    },
    extension (path) {
      if(path !== undefined && path.includes('.') == true){
          var fullname_path = path.split('.')[path.split('.').length - 1].toLowerCase()
        if(fullname_path.includes(' ')){
          var path_space = fullname_path.split(' ')
          var extension = path_space[0]
        }else{
          var extension = fullname_path
        }
        // console.log( 'path' , path)
        // var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
        var pdf = ['pdf']
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm','xlsx']
        var presentation = ['ppt', 'pps', 'pot', 'pptx']
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
        var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
        var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat']
        var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
        if (pdf.includes(extension)) {
          return 'pdf'
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive'
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel'
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint'
        } else if (word.includes(extension)) {
          return 'fas fa-file-word'
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code'
        } else if (image.includes(extension)) {
          return 'fas fa-file-image'
        } else if (media.includes(extension)) {
          return 'media'
        } else if (audio.includes(extension)) {
          return 'audio'
        } else {
          return 'fas fa-file-alt'
        }
      } else {
          return 'fas fa-file-alt'
        }
    },
    pushcontact (item) {
      // console.log(item)
      if (item.status === 'success') {
        if (_.find(this.items, function (o) { return o.tokenmessage === item.data.tokenmessage }) === undefined) {
          // console.log(item.data)
          this.items.push(item.data)
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
          setTimeout(this.scrollDown, 1)
        }
      } else {
        this.items.push({
          tokenuser: this.token,
          message: item.data.tokenuser,
          tokenroom: this.$route.params.roomid,
          typeofmessage: 'contact',
          timestamp: Momenttime.momenttimestamp(),
          tokenmessage: btoa(Momenttime.momenttimestamp()),
          path_pic: this.profile,
          nickname: '',
          file_name: '',
          nickname_contact: item.data.name,
          pic_contact: item.data.profilepicture,
          type_contact: item.data.type,
          status: 'no'
        })
        this.clearQuickreply()
      }
    },
    closeInforfriend (value) {
      this.inforfrienddialog = value
    },
    detailFriend (user) {
      // console.log(user)
      this.tokeninforfriend = user
      this.inforfrienddialog = true
      this.settingdialog = false
    },
    chat (tokenroom) {
      this.$router.push('/mobile/room/' + tokenroom)
    },
    AcceptReq (tokenFriend) {
      this.axios.post(process.env.APInew_acceptfriend, {tokenfriend: tokenFriend, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'friend'
          // this.$store.dispatch('listFriend', JSON.stringify(tokenFriend))
          // this.$store.dispatch('Request', 'acceptrequest' + tokenFriend + ' ' + Math.random())
        }
      })
    },
    RemoveReq (tokenFriend) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: tokenFriend, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'unknown'
          // this.$store.dispatch('sendRequest', 'removerequestfriend' + tokenFriend)
        }
      })
    },
    AddFriend (tokenFriend) {
      this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenFriend, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          this.$store.dispatch('sendRequest', tokenFriend)
        } else {
          alert('Error!!!')
        }
      })
    },
    unblock (tokenFriend) {
      this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {tokenuser: this.token}).then((response) => {
        var room = response.data['listBlockFriend'][this.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom']
        this.axios.post(process.env.APImanage + '/unblockfriend', { tokenfriend: tokenFriend, tokenuser: this.token, tokenroom: room }).then((response) => {
          if (response.data['status'] === 'success') {
            this.$swal(
              'Unblocked!',
              this.$t('Alert.Success.unblock'),
              'success'
            )
            this.relation = 'friend'
            this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {tokenuser: this.token}).then((response) => {
              this.$store.dispatch('listFriend', 'listBlockFriend' + this.tokenFriend)
            })
          }
        })
      })
    },
    append (emoji) {
      // console.log(emoji)
      this.sendmsg += emoji
    },
    // onInput (event) {
    //   // console.log(event.data)
    //   this.sendmsg = event.data
    //     //event.data contains the value of the textarea
    // },
    forword () {
      if (this.currentPage < this.pageCount) {
        this.currentPage = this.currentPage + 1
      }
    },
    back () {
      if (this.currentPage !== 1) {
        this.currentPage = this.currentPage - 1
      }
    },
    setPlace (place) {
      this.currentPlace = place
      this.addMarker()
    },
    addMarker () {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        }
        this.lat = this.currentPlace.geometry.location.lat()
        this.lng = this.currentPlace.geometry.location.lng()
        this.address = this.currentPlace.name + ' ' + this.currentPlace.formatted_address
        this.markers.push({ position: marker })
        this.places.push(this.currentPlace)
        this.center = marker
        this.currentPlace = null
      }
    },
    sendmap () {
      if (this.lat !== '' && this.lng !== '') {
        this.axios.post(process.env.APIpub + '/push_map', {
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token,
          lat: this.lat + '',
          long: this.lng + '',
          address: this.address,
          type: this.typeuser,
          business_id: this.business_id
        }).then((response) => {
          var _ = require('lodash')
          if (response.data['status'] === 'success') {
            if (_.find(this.items, function (o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
              this.date = Momenttime.momentdatethai(response.data.data.timestamp)
              this.time = Momenttime.momenttimethai(response.data.data.timestamp)
              this.items.push({
                sender: 'self',
                message: response.data.data.message,
                room: response.data.data.tokenroom,
                tokenuser: response.data.data.tokenuser,
                date: this.date,
                timestamp: this.time,
                typeofmessage: response.data.data.typeofmessage,
                time: response.data.data.timestamp,
                tokenmessage: response.data.data.tokenmessage,
                path_pic: this.profile,
                chatname: response.data.data.nickname,
                file_name: response.data.data.file_name,
                status: 'success'
              })
              this.clearQuickreply()
            }
            setTimeout(this.scrollDown, 1)
            // this.axios.post(process.env.APIpub '/mark_read', {tokenuser: this.token, tokenroom: response.data.data.tokenroom}).then((response) => {
            // })
            this.lat = this.lat + ''
            this.lng = this.lng + ''
            this.address = this.address
            this.sheet = false
          } else {
            this.date = Momenttime.momentdatethai(response.data.source.timestamp)
            this.time = Momenttime.momenttimethai(response.data.source.timestamp)
            this.items.push({
              sender: 'self',
              message: this.sendmsg,
              tokenroom: this.$route.params.roomid,
              date: this.date,
              timestamp: this.time,
              typeofmessage: 'message',
              time: this.time,
              tokenmessage: '',
              path_pic: this.profile,
              chatname: '',
              file_name: '',
              status: 'no'
            })
            this.clearQuickreply()
            // this.lat = ''
            // this.lng = ''
            // this.address = ''
            // this.sheet = false
            this.lat = this.lat + ''
            this.lng = this.lng + ''
            this.address = this.address
            this.sheet = false
            this.sheetother = false
          }
        })
      } else {
        this.sheet = false
        this.sheetother = false
      }
    },
    setPlaceandAdd (place) {
      this.currentPlace = place
      this.addMarkerplace(this.currentPlace)
    },
    addMarkerplace (place) {
      if (place) {
        const marker = {
          lat: place.latLng.lat(),
          lng: place.latLng.lng()
        }
        this.lat = place.latLng.lat()
        this.lng = place.latLng.lng()
        this.markers.push({ position: marker })
        this.places.push(place)
        this.center = marker
        this.currentPlace = null
      }
      // let self = this
      // var geocoder = new google.maps.Geocoder
      // geocoder.geocode({placeId: place.placeId}, function (results, status) {
      //   if (status === 'OK') {
      //     if (results[0]) {
      //       self.address = results[0].formatted_address
      //     }
      //   }
      // })
    },
    other_noti (group, title, msg, pic) {
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, { body: msg, icon: pic, silent: true })
        notification.onclick = function () {
        }
      } else {
        Notification.requestPermission().then(function (result) {
          // console.log(result)
        })
      }
    },
    uppic () {
      // console.log('uppic')
      document.getElementById('uploadpic').click()
    },
    upfile () {
      document.getElementById('uploadfileChat').click()
      this.sheetother = false
    },
    pasteIntoInput (el, text) {
      el.focus()
      if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
        var val = el.value
        var selStart = el.selectionStart
        el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd)
        el.selectionEnd = el.selectionStart = selStart + text.length
      } else if (typeof document.selection !== 'undefined') {
        var textRange = document.selection.createRange()
        textRange.text = text
        textRange.collapse(false)
        textRange.select()
      }
    },
    // savefile (msg) {
    //   var button = document.getElementById('btn-download')
    //   button.addEventListener('click', function (e) {
    //     var dataURL = canvas.toDataURL('image/png')
    //     button.href = msg
    //   })
    // },
    closemodal () {
      this.filepdf = ''
      // console.log('close modal')
      // console.log(this.src)
      var modal = document.getElementById('myModalImage')
      var modalfile = document.getElementById('myModalFile')
      // var myModalMap = document.getElementById('myModalMap')
      modal.style.display = 'none'
      modalfile.style.display = 'none'
      // myModalMap.style.display = 'none'
    },
    zoomfile (close, item) {
      // console.log(item)
      this.settingdialog = false
      this.forwarddialog = false
      var modalfile = document.getElementById('myModalFile')
      modalfile.style.display = 'block'
      this.filepdf = this.announce_message.message
      this.nicknameSend = this.announce_message.nickname
      this.filenameSend = this.announce_message.file_name
      this.picSend = this.announce_message.path_pic
      this.dateSend = this.dateMoment(this.announce_message.timestamp)
      this.timeSend = this.timeMoment(this.announce_message.timestamp)
      this.tokenmsgSend = this.announce_message.tokenmessage
      this.typeuserSend = this.announce_message.type
      this.infor_file = this.announce_message
      // console.log(this.announce_message)
      if (close) {
        modalfile.style.display = 'none'
      }
    },
    zoomPasswordfile (close ,item, data) {
      this.settingdialog = false
      this.forwarddialog = false
      var modalfile = document.getElementById('myModalFile')
      modalfile.style.display = 'block'
      this.filepdf = item
      this.nicknameSend = data.nickname
      this.filenameSend = data.file_name
      this.picSend = data.path_pic
      this.dateSend = this.dateMoment(data.timestamp)
      this.timeSend = this.timeMoment(data.timestamp)
      this.tokenmsgSend = data.tokenmessage
      this.typeuserSend = data.type
      this.infor_file = data
      // console.log(this.announce_message)
      if (close) {
        modalfile.style.display = 'none'
      }
    },
    zoom () {
      // console.log(item)
      this.imagealbumsdialog = false
      this.forwarddialog = false
      this.forwardimagedialog = false
      var modal = document.getElementById('myModalImage')
      var modalImg = document.getElementById('img01')
      modal.style.display = 'block'
      modalImg.src = this.mentiondetail.message
      if (this.mentiondetail.path_pic === undefined) {
        this.picSend = localStorage.getItem('profilepicture')
      } else {
        this.picSend = this.mentiondetail.path_pic
      }
      this.nicknameSend = this.mentiondetail.nickname
      this.filenameSend = this.mentiondetail.file_name
      this.dateSend = this.dateMoment(this.mentiondetail.timestamp)
      this.timeSend = this.timeMoment(this.mentiondetail.timestamp)
      this.tokenmsgSend = this.mentiondetail.tokenmessage
      this.pathSend = this.mentiondetail.message
      this.typeuserSend = this.mentiondetail.type
    },
    sendimgonebox (tokenmessage) {
      this.dialogSaveOnebox = true
      this.tokenmessage_savebox = tokenmessage
    },
    closeSaveOnebox (value) {
      this.dialogSaveOnebox = false
    },
    scrollMaxOldSet () {
      // var container = this.$el.querySelector('#myscroll')
      this.scrollMaxOld = 0
    },
    scrollDown () {
      var container = this.$el.querySelector('#myscroll')
      // console.log(`scH: ${container.scrollHeight}`)
      container.scrollTop = container.scrollHeight
      this.scrollval = container.scrollTop
    },
    loadchathistory () {
      // this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // console.log(this.box_height)
      // alert(this.box_height + ' : ' + this.$vssHeight)
      this.progressLoadChat = true
      this.temp = this.selectedmessage
      this.selectedmessage = []
      this.getOldMessageFirst(this.items[0].timestamp)
      // var container = this.$el.querySelector('#myscroll')
      // this.scrollval = container.scrollTop
      // if (this.scrollval < 20) {
      //   this.getOldMessageFirst(this.items[0].timestamp)
      //   var scrollMaxNew = container.scrollHeight
      //   container.scrollTop = scrollMaxNew - this.scrollMaxOld
      //   this.scrollMaxOld = scrollMaxNew
      //   this.scrollval = container.scrollTop
      // }
    },
    getOldMessageFirst (time) {
      this.progressLoadChat = true
      if (time === '') {
        this.progressLoadChat = true
      }
      console.log('tokenroom mobile: ', this.$route.params.roomid !== null && this.$route.params.roomid !== undefined)
      if (this.$route.params.roomid !== null && this.$route.params.roomid !== undefined) {
        this.axios.post(process.env.APInew_getdict, {
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token,
          time_in: time,
          type: this.typeuser
        }).then((response) => {
          if (response.data['status'] === 'success') {
            this.progressLoadChat = false
            // console.log(response.data)
            this.statemember = response.data.state_member
            if (response.data.data.length === 20) {
              this.statusload = true
            } else if (response.data.data.length < 20) {
              this.statusload = false
            }
            this.selectedmessage = this.temp
            // if (time === '') {
            //   this.items.unshift.apply(this.items, response.data['data'].reverse())
            //   setTimeout(this.scrollDown, 1)
            // } else {
            //   this.gotoTokenmessage = response.data.data[0].tokenmessage
            //   this.items = response.data['data'].reverse().concat(this.items)
            // }
            // console.log(this.$route.query.tokenmessage)
            if (time === '') {
              // console.log('notime')
              this.items = response.data['data'].reverse()
              // setTimeout(this.scrollDown, 1)
              this.$nextTick(() => {
                // console.log('nextTick')
                // console.log(this.$route.query.tokenmessage)
                if (this.$route.query.tokenmessage) {
                  // console.log('have tokenmessage')
                  this.gotoMessage(this.$route.query.tokenmessage)
                } else {
                  // console.log('no tokenmessage')
                  setTimeout(this.scrollDown, 1)
                }
              })
            } else {
              this.gotoTokenmessage = response.data.data[0].tokenmessage
              this.items = response.data['data'].reverse().concat(this.items)
              // console.log(this.items)
              // console.log(this.gotoTokenmessage)
            }
          } else {
            if (response.data.message === 'not member.') {
              this.$router.push('/layouthompage')
            }
          }
        }).catch((error) => {
          this.progressLoadChat = false
          // this.progressLoadChatBox = false
          if (error.response.data.message === 'Tokenroom not found.') {
            this.$router.push('/layouthompage')
          }
        })
      } else {
        this.$router.push('/layouthompage')
      }
    },
    get_list_richmenu (botid) {
      // console.log(typeroom)
      // if (typeroom !== 'group') {
      this.axios.post(process.env.APIgo_api + '/v1/get-richmenu-by-botid', { bot_id: botid }).then((response) => {
        // console.log(response.data.data)
        // console.log(response.data.data.list_menu)
        if (response.data.status === 'success') {
          this.list_richmenu = response.data.data.list_menu
          this.type_richmenu = parseInt(response.data.data.type_menu)
          this.inforrichmenu = response.data.data.list_menu
          this.richmenu_label = response.data.data.menu_label
          this.bot_id_richmenu = response.data.data.bot_id
          // console.log(response.data.data.list_menu)
          this.default_behavior = parseInt(response.data.data.default_behavior)
          if (this.default_behavior === 1) {
            this.RichmenuState = true
            this.sheetrichmenu = true
          } else {
            this.RichmenuState = false
            this.sheetrichmenu = false
          }
          // console.log(this.type_richmenu)
          // console.log(this.inforrichmenu)
        } else {
          // console.log(response.data)
          this.list_richmenu = []
        }
      }).catch((error) => {
        console.log(error)
      })
      // }
    },
    isBlank (str) {
      return (!str || /^\s*$/.test(str))
    },
    isEmpty (str) {
      return (!str || str.length === 0)
    },
    resendMessage (data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage
      })
      this.sendMessage(data.message)
    },
    resendContact (data) {
      _.remove(this.items, function (n) {
        return n.tokenmessage === data.tokenmessage
      })
      this.sendContact(data)
    },
    dateMoment (data) {
      // return Momenttime.momentdatethai(data)
      if (this.$i18n.locale == 'th') {
        return Momenttime.momentdatethai(data)
      } else if (this.$i18n.locale == 'cn') {
        return Momenttime.momentdatecn(data)
      } else {
        return Momenttime.momentdateen(data)
      }
    },
    timeMoment (data) {
      return Momenttime.momenttimethai(data)
      // if (this.$i18n.locale == 'th') {
      //   return Momenttime.momenttimethaiformnow(data)
      // } else if (this.$i18n.locale == 'cn') {
      //   return Momenttime.momenttimethaiformnowcn(data)
      // } else {
      //   return Momenttime.momenttimethaiformnowen(data)
      // }
    },
    datetime (data) {
      return Momenttime.momentdatethai(data)
    },
    sendMessage (data) {
      // console.log(data)
      if (this.showmention === false) {
        try {
          if (event.keyCode === 13 && event.shiftKey) {
            if (event.type === 'keypress') {
              this.pasteIntoInput(this, '\n')
            }
            event.preventDefault()
          } else if (!this.isBlank(data) && !this.isEmpty(data)) {
            // console.log(this.listfriend.length)
            if (this.infofriend.type === 'group') {
              // tag friend
              var result
              this.listfriend.map((item) => {
                var pattern = /\B@([^\u0000-\u007F]|[\a-zA-Z])+/gi
                // var pattern = /\B@([^\u0000-\u007F]|[\a-zA-Z])+\s/gi
                // console.log(item.name)
                result = data.match(pattern)
              })
              // console.log(result)
              if (result) {
                var list_tag = []
                for (var i=0; i < result.length ; i++) {
                  // console.log(result[i])
                  const test = this.listfriend.find(person =>
                  person.name.includes(result[i].substring(1)))
                  list_tag.push(test)
                  // console.log(test2)
                }
                for (var j=0; j <list_tag.length; j++) {
                  if (list_tag[j] !== undefined) {
                    data = data.replace(('@'+ list_tag[j].name), '<tax>'+list_tag[j].tokenuser+'</tax>')
                  }
                }
              } else {
                // ถ้าข้อความมี spacebar แทยค่าด้วย \u00a0
                for (var k = 0; k < data.length; k++) {
                  data = data.replace(/ /g, '\u00a0')
                }
              }
            } else {
              // ถ้าข้อความมี spacebar แทยค่าด้วย \u00a0
              for (var l = 0; l < data.length; l++) {
                data = data.replace(/ /g, '\u00a0')
              }
            }

            this.axios.post(process.env.APInew_pushmessage, { tokenroom: this.$route.params.roomid, tokenuser: this.token, type: this.typeuser, message: data }).then((response) => {
              var messageSendChat = response.data.data
              if (response.data.status === 'success') {
                messageSendChat['status'] = 'success'
                if (_.find(this.items, function (o) { return o.tokenmessage === messageSendChat.tokenmessage }) === undefined) {
                  // console.log(messageSendChat)
                  this.items.push(messageSendChat)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function (dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                }
                setTimeout(this.scrollDown, 1)
                this.sendmsg = ''
              } else {
                this.items.push({tokenuser: this.token, message: data, tokenroom: this.$route.params.roomid, typeofmessage: 'message', timestamp: Momenttime.momenttimestamp(), tokenmessage: btoa(Momenttime.momenttimestamp()), path_pic: this.profile, nickname: '', file_name: '', status: 'no'})
                this.clearQuickreply()
                this.sendmsg = ''
              }
            }, (error) => {
              this.items.push({tokenuser: this.token, message: data, tokenroom: this.$route.params.roomid, typeofmessage: 'message', timestamp: Momenttime.momenttimestamp(), tokenmessage: btoa(Momenttime.momenttimestamp()), path_pic: this.profile, nickname: '', file_name: '', status: 'no'})
              this.clearQuickreply()
              this.sendmsg = ''
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
              setTimeout(this.scrollDown, 1)
              console.log(error)
            })
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        this.sendMessageMention(data)
      }
    },
    sendMessageMention (data) {
      this.showmention = false
      try {
        if (!this.isBlank(data) && !this.isEmpty(data)) {
          this.axios.post(process.env.APIimage + '/mention_message', { tokenroom: this.$route.params.roomid, tokenuser: this.token, tokenmessage: this.mentiondetail.tokenmessage, mention_message: data }).then((response) => {
            var messageSendChat = response.data.data
            // console.log(messageSendChat)
            if (response.data.status === 'success') {
              messageSendChat['status'] = 'success'
              if (_.find(this.items, function (o) { return o.tokenmessage === messageSendChat.tokenmessage }) === undefined) {
                this.items.push(messageSendChat)
                this.clearQuickreply()
                this.items = _.sortBy(this.items, function (dateObj) {
                  return new Date(dateObj.timestamp)
                })
                this.items = _.unionBy(this.items, 'tokenmessage')
              }
              setTimeout(this.scrollDown, 1)
              this.sendmsg = ''
            } else {
              this.items.push({tokenuser: this.token, message: data, tokenroom: this.$route.params.roomid, typeofmessage: 'mention_message', timestamp: Momenttime.momenttimestamp(), tokenmessage: btoa(Momenttime.momenttimestamp()), path_pic: this.profile, nickname: '', file_name: '', status: 'no'})
              this.clearQuickreply()
              this.sendmsg = ''
            }
          }, (error) => {
            this.items.push({tokenuser: this.token, message: data, tokenroom: this.$route.params.roomid, typeofmessage: 'mention_message', timestamp: Momenttime.momenttimestamp(), tokenmessage: btoa(Momenttime.momenttimestamp()), path_pic: this.profile, nickname: '', file_name: '', status: 'no'})
            this.clearQuickreply()
            this.sendmsg = ''
            // this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
            this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            console.log(error)
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    sendContact (data) {
      this.axios.post(process.env.APIimage + '/push_contact', {tokenroom: this.$route.params.roomid, tokenuser: this.token, tokencontact: data.message, type: this.typeuser}).then((response) => {
        if (response.data['status'] === 'success') {
          this.sheetother = false
          // console.log(response.data)
          if (_.find(this.items, function (o) { return o.tokenmessage === response.data.tokenmessage }) === undefined) {
            this.items.push(response.data)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function (dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
            setTimeout(this.scrollDown, 1)
          }
          // this.$swal('', 'ข้อมูลติดต่อถูกจัดส่งแล้ว', 'success')
          this.$swal('', this.$t('Alert.Success.account'), 'success')
        } else {
          this.items.push({tokenuser: this.token, message: data.tokenuser, tokenroom: this.$route.params.roomid, typeofmessage: 'contact', timestamp: Momenttime.momenttimestamp(), tokenmessage: btoa(Momenttime.momenttimestamp()), path_pic: this.profile, nickname: '', file_name: '', nickname_contact: data.name, pic_contact: data.profilepicture, type_contact: data.type, status: 'no'})
          this.clearQuickreply()
          setTimeout(this.scrollDown, 1)
          // this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น ไม่สามารถส่งข้อมูลติดต่อได้ กรุณาลองใหม่ในภายหลัง', 'error')
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        }
      }, () => {
        // this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    checksen (data) {
      if (!this.isBlank(data) && !this.isEmpty(data)) {
        return true
      } else {
        return false
      }
    },
    getMessageSocket (data) {
      // console.log(data)
      // this.clearQuickreply()
      if (data.tokenroom === this.$route.params.roomid) {
        if (data.tokenuser !== this.token) {
          this.checkShowmessagwBottom(data)
        }
        if (_.find(this.items, function (o) { return o.tokenmessage === data.tokenmessage }) === undefined) {
          this.items.push(data)
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function (dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
          // setTimeout(this.scrollDown, 1)
          if (data.typeofmessage === 'file') {
            this.socketupdate_file = data
          } else if (data.typeofmessage === 'image') {
            this.socketupdate_img = data
          }
          if (data.tokenuser !== this.token) {
            this.axios.post(process.env.APIalpine + '/api/v1/user-mark-read', {tokenuser: this.token, tokenroom: data.tokenroom}).then((response) => {
            })
          }
        }
      }
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },
    // onimgSelected (data) {
    //   console.log(data)
    //   this.sheetother = false
    //   let uploadedFiles = data.target.files
    //   var lengthfile = uploadedFiles.length
    //   var sizefile = []
    //   for (var i = 0; i < lengthfile; i++) {
    //     sizefile[i] = uploadedFiles[i].size
    //   }
    //   if (_.sum(sizefile)/ 1024 / 1024 > 100) {
    //     this.$swal({ title: 'ไม่สามารถส่งไฟล์ได้ เนื่องจากไฟล์มีขนาดเกิน 100 MB', type: 'warning' })
    //   } else {
    //     for (let i = 0; i < uploadedFiles.length; i++) {
    //       // this.selectFile = data.target.files[i]
    //       // console.log(data.target.files[i].type)
    //       if (data.target.files[i].type === 'image/jpeg' || data.target.files[i].type === 'image/png' || data.target.files[i].type === 'image/jpg') {
    //         // console.log(this.selectFile)
    //         this.selectFile = data.target.files[i]
    //         var uploadFile = new FormData()
    //         uploadFile.append('file', this.selectFile, this.selectFile.name)
    //         uploadFile.append('tokenroom', this.$route.params.roomid)
    //         uploadFile.append('tokenuser', this.token)
    //         uploadFile.append('type', this.typeuser)
    //         this.axios.post(process.env.APIimage + '/push_image', uploadFile).then((response) => {
    //           if (response.data.status === 'success') {
    //             if (_.find(this.items, function(o) {
    //                 return o.tokenmessage === response.data.data.tokenmessage
    //               }) === undefined) {
    //               this.socketupdate_img = response.data.data
    //               response.data.data.status = 'success'
    //               this.items.push(response.data.data)
    //               this.clearQuickreply()
    //               this.items = _.sortBy(this.items, function(dateObj) {
    //                 return new Date(dateObj.timestamp)
    //               })
    //               this.items = _.unionBy(this.items, 'tokenmessage')
    //               document.querySelector('#uploadpic').value = ''
    //               document.querySelector('#uploadfileChat').value = ''
    //             }
    //             setTimeout(this.scrollDown, 1)
    //           } else {}
    //         }, (error) => {
    //           console.log(error)
    //           this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
    //         })
    //       } else {
    //         // console.log(data.target.files[i].type)
    //         this.onFileSelected(data)
    //       }
    //     }
    //   }
    // },
    onimgSelected (data) {
      // console.log(data)
      this.sheetother = false
      var lengthfile = data.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size
      }
      if (_.sum(sizefile)/ 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' })
      } else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type === 'image/jpeg' || data[i].type === 'image/png' || data[i].type === 'image/jpg') {
            // console.log('it image')
            this.selectFile = data[i]
            // console.log(this.selectFile)
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenroom', this.$route.params.roomid)
            uploadFile.append('tokenuser', this.token)
            uploadFile.append('type', this.typeuser)
            this.axios.post(process.env.APIimage + '/push_image', uploadFile).then((response) => {
              if (response.data.status === 'success') {
                // console.log(response.data.data)
                if (_.find(this.items, function(o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
                  this.socketupdate_img = response.data.data
                  response.data.data.status = 'success'
                  this.items.push(response.data.data)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                  document.querySelector('#uploadpic').value = ''
                  document.querySelector('#uploadfileChat').value = ''
                }
                setTimeout(this.scrollDown, 1)
              } else {}
            }, (error) => {
              console.log(error)
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          } else {
          }
        }
      }
    },
    onFileSelected (data) {
      // console.log(data)
      // console.log(data.target.files)
      // console.log(this.extension(data.target.files))
      this.sheetother = false
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size
      }
      if (_.sum(sizefile)/ 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' })
      } else {
        for (let i = 0; i < uploadedFiles.length; i++) {
          if (uploadedFiles[i].type === 'image/jpeg' || uploadedFiles[i].type === 'image/png' || uploadedFiles[i].type === 'image/jpg') {
            var datas = []
            datas.push(uploadedFiles[i])
            this.onimgSelected(datas)
          } else if (this.extension(uploadedFiles[i].name) === 'media') {
            var file_video = []
            file_video.push(uploadedFiles[i])
            this.push_video(file_video)
          } else {
            this.selectFile = uploadedFiles[i]
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenroom', this.$route.params.roomid)
            uploadFile.append('tokenuser', this.token)
            uploadFile.append('type', this.typeuser)
            this.axios.post(process.env.APIimage + '/push_file', uploadFile).then((response) => {
              // console.log(response.data)
              if (response.data.status === 'success') {
                if (_.find(this.items, function(o) {
                    return o.tokenmessage === response.data.data.tokenmessage
                  }) === undefined) {
                  response.data.data.status = 'success'
                  this.items.push(response.data.data)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                  document.querySelector('#uploadfileChat').value = ''
                  this.socketupdate_file = response.data.data
                }
                setTimeout(this.scrollDown, 1)
              } else {}
            }, (error) => {
              console.log(error)
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          }
        }
      }
    },
    // onFileSelected (data) {
    //   console.log(data.target.files)
    //   this.sheetother = false
    //   let uploadedFiles = data.target.files
    //   var lengthfile = uploadedFiles.length
    //   var sizefile = []
    //   for (var i = 0; i < lengthfile; i++) {
    //     sizefile[i] = uploadedFiles[i].size
    //   }
    //   if (data.target.files.type === 'image/jpeg' || data.target.files.type === 'image/png' || data.target.files.type === 'image/jpg') {
    //     this.onimgSelected(data)
    //     // console.log(data.target.files[i])
    //   } else if (this.extension(uploadedFiles[i].name) === 'media') {
    //     var file_video = []
    //     file_video.push(uploadedFiles[i])
    //     this.push_video(file_video)
    //   } else {
    //     if (_.sum(sizefile)/ 1024 / 1024 > 25) {
    //       this.$swal({ title: 'ไม่สามารถส่งไฟล์ได้ เนื่องจากไฟล์มีขนาดเกิน 25 MB', type: 'warning' })
    //     } else {
    //       for (let i = 0; i < uploadedFiles.length; i++) {
    //         // console.log(data.target.files[i].type)
    //         this.selectFile = data.target.files[i]
    //         // console.log(this.selectFile)
    //         var uploadFile = new FormData()
    //         uploadFile.append('file', this.selectFile, this.selectFile.name)
    //         uploadFile.append('tokenroom', this.$route.params.roomid)
    //         uploadFile.append('tokenuser', this.token)
    //         uploadFile.append('type', this.typeuser)
    //         this.axios.post(process.env.APIimage + '/push_file', uploadFile).then((response) => {
    //           if (response.data.status === 'success') {
    //             if (_.find(this.items, function(o) {
    //                 return o.tokenmessage === response.data.data.tokenmessage
    //               }) === undefined) {
    //               response.data.data.status = 'success'
    //               // this.items.push(response.data.data)
    //               this.clearQuickreply()
    //               // this.items = _.sortBy(this.items, function(dateObj) {
    //               //   return new Date(dateObj.timestamp)
    //               // })
    //               // this.items = _.unionBy(this.items, 'tokenmessage')
    //               document.querySelector('#uploadfileChat').value = ''
    //               // console.log(response.data.data)
    //               this.socketupdate_file = response.data.data
    //             }
    //             setTimeout(this.scrollDown, 1)
    //           } else {}
    //         }, (error) => {
    //           console.log(error)
    //           this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
    //         })
    //       }
    //     }
    //   }
    // },
    push_video (data) {
      // console.log(data)
      this.sheetother = false
      var lengthfile = data.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size
      }
      if (_.sum(sizefile)/ 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' })
      } else {
        for (let i = 0; i < data.length; i++) {
          // console.log('it image')
          this.selectFile = data[i]
          var uploadFile = new FormData()
          uploadFile.append('file', this.selectFile, this.selectFile.name)
          uploadFile.append('tokenroom', this.$route.params.roomid)
          uploadFile.append('tokenuser', this.token)
          this.axios.post(process.env.APInew_pushvideo, uploadFile).then((response) => {
            if (response.data.status === 'success') {
              if (_.find(this.items, function(o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
                this.socketupdate_file = response.data.data
                // console.log(response.data.data)
                response.data.data.status = 'success'
                this.items.push(response.data.data)
                this.clearQuickreply()
                this.items = _.sortBy(this.items, function(dateObj) {
                  return new Date(dateObj.timestamp)
                })
                this.items = _.unionBy(this.items, 'tokenmessage')
                document.querySelector('#uploadpic').value = ''
                document.querySelector('#uploadfileChat').value = ''
              }
              setTimeout(this.scrollDown, 1)
            } else {}
          }, (error) => {
            console.log(error)
            this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
          })
        }
      }
    },
    closeNote (value) {
      this.dialogNote = value
    },
    closeAccount (value) {
      this.dialogAccount = value
    },
    // closeMap (value) {
    //   this.dialogMap = value
    // },
    detailNote (id) {
      this.dialogNote = true
      this.note_id = id
      this.status_block = this.block
    },
    convert (msg) {
      // var linkifyStr = require('linkifyjs/string')
      // var str = msg
      // var processedContent = linkifyStr(str)
      // return processedContent
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g
      // console.log(msg.match(regex))
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2;">@')
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
          // processedContent = processedContent.replace(' ', '&nbsp;')
          processedContent = processedContent.replace('\t', '\u00a0\u00a0\u00a0\u00a0\u00a0')
        }
      }
      return processedContent
    },
    convertURL (msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0 ) {
          // console.log(linkmsg.slice(0,5))
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
      // console.log(msg.match(urlRegex) !== null);
    },
    clicklink_website (url) {
      // window.open(url)
      this.checkBrowser(url, '')
    },
  }
}
</script>
<style type="text/css" scoped>
.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
.app-header {
  padding: 16px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  background-color: #555;
  color: #ddd;
}

.app-content {
  padding: 24px 16px;
}

.right {
  float: right;
}
.height-template {
  min-height: 445px !important;
}
.border_website {
  border-left: #153c6d 2px solid;
  padding-left: 5px;
}
.img_website {
  height: 50px;
  width: 50px;
  margin: auto;
}
.centerimg_website {
  justify-content: center;
  display: flex;
}
.description_website {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #556579;
}
.title_website {
  margin: 0 !important;
  font-weight: 600;
  color: #2562af;
}
.friendList {
  /* position: absolute; */
  /* bottom: 100px; */
  /* top: calc(100vh - 114px) !important; */
  /* max-height: 200px; */
  /* overflow-y: auto; */
  /* width: 100% !important; */
  background: #ffffff !important;
  margin: 0 !important;
  position: fixed !important;
  width: 100% !important;
  max-height: 300px !important;
  padding: 5px !important;
  /* top: calc(100vh - 198px) !important; */
  bottom: 90px !important;
  overflow-y: auto !important;
}
.friendList::-webkit-scrollbar {
  width: 4px;
}
.friendList::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-image__image--cover {
  background-size: contain !important;
} */
.joinBtn {
  margin-top: 15px;
  border-radius: 20px !important;
  background: #294071 !important;
  color: white !important;
  text-transform: none !important;
}
.text-transform {
  text-transform: none;
}
.span-trext-overflow {
  white-space: nowrap !important;
  width: 135px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.p-announce {
  cursor: pointer !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.p-announce:hover {
  color: #1b232c !important;
}
>>>.v-tabs__wrapper {
  contain: content;
  display: flex;
  overflow-x: scroll;
}
.text-overflow-quickreply {
  display: block;
  max-width: 10em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text-task-detail {
  color: black !important;
  margin-bottom: 5px !important;
  text-align: left !important;
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}
.test-overflow-chip {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 100px !important;
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
}
.chat_self_createablums {
  text-align: left;
  margin: 20px auto;
  margin-right: 10px !important;
  margin-top: 0;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  width: 450px;
  cursor: pointer;
  /* height: 250px; */
}
.chat_other_createablums {
  cursor: pointer;
  text-align: left;
  margin: 20px auto;
  margin-left: 10px !important;
  margin-top: 0;
  border-radius: 20px;
  background:  #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  width: 450px;
}
>>>.v-toolbar__title:not(:first-child) {
  margin-left: 5px;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 110%;
  position: fixed;
  overflow: hidden;
  width: 100%;
  top: 0;
  left: 0;
}
.showmention {
  background: #1b232d63 !important;
  margin: 0 !important;
  /*bottom: 128px !important;*/
  position: fixed !important;
  width: 100% !important;
  height: 55px !important;
  padding: 5px !important;
}
.boxself_unsend {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  max-width: 170px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}
.boxother_unsend {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  max-width: 225px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}
.boxother_system {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  max-width: 300px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}
.boxself_system {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  max-width: 300px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}
.scrolling-wrapper {
  display: flex;
  overflow-x: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 10px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.scrolling-wrapper-template {
  display: flex;
  overflow-x: auto;
}
.scrolling-wrapper-template::-webkit-scrollbar {
  height: 10px;
  width: 8px;
  cursor: pointer;
}
.scrolling-wrapper-template::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.chat_other_question {
  border-width: thin;
  border-style: solid;
  text-align: left;
  border-radius: 20px;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  max-width: 60vw;
  border-color: #b1b1b1b3;
}
.quick_reply {
  background: white !important;
  text-transform: none;
  font-weight: 200;
  border: #2160b0 1px solid;
  color: #2160b0;
}
.quick_replydis {
  background: white !important;
  text-transform: none;
  font-weight: 200;
  border: lightgrey 1px solid;
  color: #2160b0;
}
.quick_reply:hover {
  background: #1976d240 !important;
}
>>>.blue-grey.darken-2 {
  background-color: #27303d!important;
  border-color: #27303d!important;
}
.layout.wrap {
  flex-wrap: nowrap;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  /*box-shadow: none;*/
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
.btncreategroup {
  color: white !important;
  background-color: #2562af !important;
}
.btncanclegroup {
  color: #1b232db3 !important;
  background-color: #cacacae3 !important;
}
>>>.v-btn .v-btn--flat .v-btn--icon .theme--light {
  margin-bottom: 0px !important;
}
>>>.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 40%;
}
/*>>>.v-input__slot {
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}*/
>>> .v-list__tile__action, .v-list__tile__avatar {
  display: flex;
  justify-content: flex-start;
  min-width: 40px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.chatbox {
  width: 100%;
  /* height: calc(100% - 128px); */
  /* background-color: #eceff1; */
  background-color: #ffffff;
  position: fixed;
  /* margin-top: 64px !important; */
}
.centerbox {
  /* margin-top: 55px !important; */
  height: calc(100vh - 64px);
  /* background: #eceff1 !important; */
  background-color: #ffffff;
}
.chatlogs {
  /*padding: 20px;*/
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px;
  padding-top: 10px;
  width: 100%;
  /* height: 100%; */
  /* height: calc(100vh - 140px); */
  /* height: 90%; */
  overflow-x: hidden;
  overflow-y: scroll;
  /* margin-top: 10px; */
  margin-bottom: 0.5vh;
  background: #eceff1;
}
.chatlogs::-webkit-scrollbar{
  width: 10px;
}
.chatlogs::-webkit-scrollbar-thumb{
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.chat{
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  height: 100%;
  margin-bottom: -2vh;
  /*margin-bottom: 10px;*/
}
  .chat .user-photo{
    width: 40px;
    height: 40px;
    background: #ccc;
    border-radius: 50%;
    overflow: hidden;
  }
  .chat .user-photo img{
   width: 100%
  }
 .centerimage {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
 }
 .chat .chat-message{
  font-size: 16px;
  position: relative;
  display: inline-block;
  clear: both;
  margin-bottom: 8px;
  padding: 13px 14px;
  vertical-align: top;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
.chat .chat-message:before{
  position: absolute;
  top: 19px;
  display: block;
  width: 8px;
  height: 6px;
  content: '\00a0';
  -moz-transform: rotate(29deg) skew(-35deg);
  -ms-transform: rotate(29deg) skew(-35deg);
  -webkit-transform: rotate(29deg) skew(-35deg);
  transform: rotate(29deg) skew(-35deg);
}
.chat-form{
  display: flex;
  align-items: flex-start;
  margin-bottom: 1vh;
}
.chat-form textarea{
  background: #fbfbfb;
  width: 90% !important;
  height: 50px;
  border: 2px solid rgb(155, 155, 155);
  border-radius: 3px;
  resize: none;
  padding:10px;
  font-size: 18px;
  color: #333;
}
.chat-form textarea:focus{
  background: #fff;
  /*background-color: red;*/
}
.chat-form textarea::-webkit-scrollbar{
  width: 2px;
}
.chat-form textarea::-webkit-scrollbar-thumb{
  /*border-radius: 5px;*/
  background: rgba(0, 0, 0, .1);
}
p .chat-message {
    max-width: 40em;
    /*border: 1px solid #000000;*/
    word-wrap: break-word;
}
.inputWrapper {
  height: 35px;
  width: 40px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  /*Using a background color, but you can use a background image to represent a button*/
  background-color: #2196f3;
  margin: 5px 10px 0;
  border-radius: 5px;
}
.fileInput {
  cursor: pointer;
  /*height: 100%;*/
  position:absolute;
  /*top: 0;*/
  /*right: 0;*/
  z-index: 99;
  /*This makes the button huge. If you want a bigger button, increase the font size*/
  /*font-size:50px;*/
  /*Opacity settings for all browsers*/
  opacity: 0;
  -moz-opacity: 0;
  filter:progid:DXImageTransform.Microsoft.Alpha(opacity=0)
}
.word-wrap {
word-wrap: break-word;
}
.thumbnail {
  max-width: 40%;
}
.italic { font-style: italic; }
.small { font-size: 0.8em; }
/** LIGHTBOX MARKUP **/
.lightbox {
  /** Default lightbox to hidden */
  display: none;
  /** Position and style */
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.8);
}
.lightbox img {
  /** Pad the lightbox image */
  max-width: 90%;
  max-height: 80%;
  margin-top: 2%;
}
.lightbox:target {
  /** Remove default browser outline */
  outline: none;
  /** Unhide lightbox **/
  display: block;
}
.boxselfsticker{
  text-align: right;
  /*margin: 20px auto;*/
  border-radius: 20px;
  padding: 10px;
  font-weight: 300;
  color: black;
  text-align: right;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 40vw;
}
.boxfriendsticker {
  text-align: left;
  margin: 2vw auto;
  border-radius: 20px;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  max-width: 40vw;
}
.boxselffile {
  text-align: right;
  margin: 20px auto;
  border-radius: 20px;
  padding: 10px;
  font-weight: 300;
  color: black;
  text-align: right;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 60vw;
  /* background-color: #27303d; */
  background-color: #27303e;
}
.boxselfimage {
  text-align: right;
  margin: 20px auto;
  border-radius: 20px;
  padding: 10px;
  font-weight: 300;
  color: black;
  text-align: right;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 60vw;
  /*background-color: #27303d;*/
}
.boxfriendfile {
  text-align: left;
  margin: 2vw auto;
  border-radius: 20px;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  max-width: 60vw;
  background-color: #4a4a4a;
  /* background-color: #505357; */
}
.boxfriendimage {
  text-align: left;
  margin: 2vw auto;
  border-radius: 20px;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  max-width: 60vw;
  /*background-color: #d4d7d8;*/
  /*background-color: #505357;*/
}

.boxself {
  text-align: left;
  margin: 20px auto;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 25vw;
}
.boxfriend {
  text-align: left;
  margin: 2vw auto;
  border-radius: 20px;
  background: #d4d7d8;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  max-width: 25vw;
}
/* speech bubble 13 */
.sbself:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 15px solid #b4d1f5;
  border-right: 15px solid transparent;
  border-top: 15px solid #b4d1f5;
  border-bottom: 15px solid transparent;
  right: -20px;
  top: 14px;
}
.sbfriend:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 15px solid transparent;
  border-right: 15px solid #d4d7d8;
  border-top: 15px solid #d4d7d8;
  border-bottom: 15px solid transparent;
  left: -20px;
  top: 13px;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.imgmessage {cursor: pointer;}
.imgmessage:hover {opacity: 0.8;}
.text {
  white-space: nowrap;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'Kanit', sans-serif !important;
}
.chat-messages {
  padding: 9px;
  height: 128px;
  width: 50% !important;
  background: #27303e;
  bottom: 0;
  position: fixed;
}
.chat-messages textarea {
  width: 100%;
  border: none;
  padding: 10px 20px;
  font: 14px/22px "Lato", Arial, sans-serif;
  margin-bottom: 0px;
  border-radius: 5px;
  resize: none;

}
.chat-messages .buttonsend {
  float: right;
  /*color: blue;*/
  font-size: 16px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  /*font-weight: bold;*/
  background: #52ceff !important;
}

.chat-messages .buttonsend :hover {
  color: darken($blue, 7%);

}
.clearfix:after {
visibility: hidden;
display: block;
font-size: 0;
content: " ";
clear: both;
height: 0;
}
/* .chat-messages .textareabg {
   background: white;
   width: 100% !important;
   height: 70px !important
}

.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}
.conversation-start span {
  font-size: 10px;
  display: inline-block;
  color: #999;
}
.conversation-start span:before, .conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 33vh;
  height: 1px;
  content: '';
  background-color: #e6e6e6;
}
.conversation-start span:before {
  left: 0;
}
.conversation-start span:after {
  right: 0;
}*/
.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}
.conversation-start span {
  border-style: solid;
  font-size: 10px;
  display: inline-block;
  color: #424242;
  border-width: thin;
  border-radius: 10px;
  width: 80px;
}
.conversation-start span:before, .conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 120px;
  height: 1px;
  content: '';
}
.conversation-start span:before {
  left: 0;
}
.conversation-start span:after {
  right: 0;
}
.fixed-content {
    min-height:100%;
    overflow: hidden;
    top: 0;
    bottom:0;
}
.iconchat:hover {
  color: #52ceff;
}
.chip.chip--outline:hover {
  background: #52ceff40;
}
.icon {
    font-size: 20px!important;
}
.application a {
    color: #1976d2;
}
/* The Modal (background) */
.modalc {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
 /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}
/* Modal Content (Image) */
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  /*width: 80%;*/
  width: auto;
  height: 50%;
}
/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}
#headcaption {
  /*margin: auto;
  display: block;
  text-align: left;
  color: white;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;*/
  margin: auto;
  display: block;
  text-align: left;
  color: #fff;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;
}
/* Add Animation - Zoom in the Modal */
/*.modal-contentc {
    animation-name: zoom;
    animation-duration: 0.6s;
}*/
@keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
}
/* The Close Button */
.close {
  top: 0;
  right: 35px;
  color: #fff;
  font-size: 25px;
  font-weight: 700;
  transition: .3s;
  margin-top: 15vh;
  /*position: absolute;
  top: 0vh;
  right: 35px;
  color: white;
  font-size: 25px;
  font-weight: 700px;
  transition: 0.3s;*/
}
.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}
/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
    .modal-contentc {
        /*width: 100vw;*/
    }
}

.wrapper {
  position: relative;
}
.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: white;
}
.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 100%;
  height: 20vh;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #ffffffe6;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #1b232d;
  font-size: 0.8rem;
  cursor: default;
  font-family: 'CS ChatThaiUI' !important;
}
.emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emojis:after {
  content: "";
  flex: auto;
}
.emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
  font-size: 30px;
}
.emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display:inline-flex;
}
.text2 {
  white-space: nowrap;
  width: 15vw;
  overflow: hidden;
  text-overflow: ellipsis;
}
.menuchat {
  font-size: 30px !important;
  color: black !important;
  cursor: pointer;
  text-align: center;
}
.menuchatword {
  font-size: 16px !important;
  color: black !important;
  cursor: pointer;
  text-align: center;
}
.textemo {
  text-transform: none !important;
  margin-top: 2vh;
  font-size: 20px;
}
.bgsearchcontact {
  background-color: #232a35 !important;
  color: white !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  margin-top: 2vh !important;
  margin-bottom: 2vh !important;
  width: 50% !important;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
}
input[type=texteditgroup] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
.sidebar-menu {
    margin: 0;
    padding: 0;
}

.sidebar-menu ul {
    margin: 0;
    padding: 5px;
}

.sidebar-menu li {
    text-align: center;
    width: 31.9%;
    margin-bottom: 3px!important;
    background-color: #fff;
    border: 1px solid #eee;
    display: inline-block;
    font-size: 10px;
    padding:0;
}
.sidebar-menu i {
  display: block;
  margin: 0 auto 10px auto;
  width: 32px;
    height: 32px;
    margin: 10px auto 0;
    line-height: 32px;
    text-align: center;
    font-size: 20px;
    color: #444444;
  margin-top:0;
  padding-top:5px;
}
.sidebar-menu a{
  text-decoration:none;
  width:100%;
  height:100%;
  display:block;
  margin:0;
  padding:0;
}
.sidebar-menu a span{
  color:black;
  font-size:10px;
  padding:5px 0 10px 0;
  display:block;
  text-transform:uppercase;
  letter-spacing:1px;
}
.sidebar-menu a:hover i{ color: #2562ae; }
.sidebar-menu a:hover { background: #E1F5FE; }
.chat_self {
  text-align: left;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:14px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 60vw;
  font-weight: 400;
  /*margin-top: 10px;*/
}
.chat_selfcontact {
  text-align: left;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  width: 180px;
}
.chat_other {
  text-align: left;
  border-radius: 20px;
  background: #efefef;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:14px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  max-width: 60vw;
  font-weight: 400;
}
.chat_othercontact {
  text-align: left;
  border-radius: 20px;
  background:  #efefef;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  width: 180px;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
input[type=text] {
  width: 130px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('searchicon.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

input[type=text]:focus {
  width: 100%;
}

.descriptionLink{
  display: inline;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;/* Important for long words! */
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/layout/CenterSideTest.vue